// 法语专四词汇
// 从数据库导出 - 共 1931 个单词

export default [
  {
    "id": 1,
    "word": "abandonner",
    "phonetic": "/a.bɑ̃.dɔ.ne/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 放弃，抛弃；v.pr. 沉溺于",
    "commonMeanings": [
      "放弃",
      "抛弃"
    ],
    "example": "N'abandonne jamais tes rêves.",
    "exampleTranslation": "永远不要放弃你的梦想。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 2,
    "word": "aboutir",
    "phonetic": "/abutir/",
    "type": "v.i.",
    "translation": "导致；成功",
    "commonMeanings": [
      "导致",
      "成功"
    ],
    "example": "Ce projet a enfin abouti.",
    "exampleTranslation": "这个项目终于成功了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 3,
    "word": "accepter",
    "phonetic": "/ak.sɛp.te/",
    "type": "v.t.",
    "translation": "v.t. 接受；同意",
    "commonMeanings": [
      "接受",
      "同意"
    ],
    "example": "J'accepte votre invitation avec plaisir.",
    "exampleTranslation": "我愉快地接受您的邀请。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 4,
    "word": "accompagner",
    "phonetic": "/a.kɔ̃.pa.ɲe/",
    "type": "v.t.",
    "translation": "v.t. 陪同，伴随；伴奏",
    "commonMeanings": [
      "陪同",
      "伴随",
      "伴奏"
    ],
    "example": "Je vous accompagne à la gare.",
    "exampleTranslation": "我陪您去火车站。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 5,
    "word": "accroître",
    "phonetic": "/akrwatr/",
    "type": "v.t.",
    "translation": "增加；增长",
    "commonMeanings": [
      "增加",
      "增长"
    ],
    "example": "La ville accroît sa population.",
    "exampleTranslation": "这座城市人口在增长。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 6,
    "word": "accueillir",
    "phonetic": "/akœjir/",
    "type": "v.t.",
    "translation": "接待；欢迎",
    "commonMeanings": [
      "接待",
      "欢迎"
    ],
    "example": "Elle nous a accueillis avec le sourire.",
    "exampleTranslation": "她微笑着迎接了我们。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 7,
    "word": "acheter",
    "phonetic": "/aʃ.te/",
    "type": "v.t.",
    "translation": "v.t. 购买，买",
    "commonMeanings": [
      "购买",
      "买"
    ],
    "example": "Je voudrais acheter un billet de train.",
    "exampleTranslation": "我想买一张火车票。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 8,
    "word": "acquérir",
    "phonetic": "/akerir/",
    "type": "v.t.",
    "translation": "获得；购得",
    "commonMeanings": [
      "获得",
      "购得"
    ],
    "example": "Il a acquis une grande expérience.",
    "exampleTranslation": "他获得了丰富的经验。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 9,
    "word": "admettre",
    "phonetic": "/admɛtr/",
    "type": "v.t.",
    "translation": "承认；准许",
    "commonMeanings": [
      "承认",
      "准许"
    ],
    "example": "Il a admis son erreur.",
    "exampleTranslation": "他承认了自己的错误。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 10,
    "word": "adorer",
    "phonetic": "/a.dɔ.ʁe/",
    "type": "v.t.",
    "translation": "v.t. 热爱；崇拜；非常喜欢",
    "commonMeanings": [
      "热爱",
      "崇拜",
      "非常喜欢"
    ],
    "example": "J'adore la cuisine française.",
    "exampleTranslation": "我超爱法国菜。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 11,
    "word": "adresser",
    "phonetic": "/a.dʁɛ.se/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 投寄；对…说；v.pr. 向…说话，找…帮忙",
    "commonMeanings": [
      "投寄",
      "对…说"
    ],
    "example": "Adressez-vous au guichet numéro 3.",
    "exampleTranslation": "请到3号窗口办理。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 12,
    "word": "agir",
    "phonetic": "/aʒir/",
    "type": "v.i.",
    "translation": "行动；起作用",
    "commonMeanings": [
      "行动",
      "起作用"
    ],
    "example": "Il faut agir sans tarder.",
    "exampleTranslation": "必须立刻行动。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 13,
    "word": "aider",
    "phonetic": "/ɛ.de/",
    "type": "v.t.",
    "translation": "v.t. 帮助，援助",
    "commonMeanings": [
      "帮助",
      "援助"
    ],
    "example": "Pourriez-vous m'aider à porter cette valise ?",
    "exampleTranslation": "您能帮我提这个行李箱吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 14,
    "word": "aimer",
    "phonetic": "/ɛ.me/",
    "type": "v.t.",
    "translation": "v.t. 爱，喜欢",
    "commonMeanings": [
      "爱",
      "喜欢"
    ],
    "example": "J'aime beaucoup ce film.",
    "exampleTranslation": "我非常喜欢这部电影。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 15,
    "word": "ajouter",
    "phonetic": "/a.ʒu.te/",
    "type": "v.t.",
    "translation": "v.t. 添加，补充；增加",
    "commonMeanings": [
      "添加",
      "补充",
      "增加"
    ],
    "example": "Voulez-vous ajouter quelque chose ?",
    "exampleTranslation": "您想补充点什么吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 16,
    "word": "aller",
    "phonetic": "/a.le/",
    "type": "v.i.",
    "translation": "v.i. 去，前往；进展；v.aux. 将要（最近将来时）",
    "commonMeanings": [
      "去",
      "前往",
      "进展",
      "将要"
    ],
    "example": "Je vais au cinéma ce soir.",
    "exampleTranslation": "我今晚去电影院。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 17,
    "word": "améliorer",
    "phonetic": "/ameljɔre/",
    "type": "v.t.",
    "translation": "改良；提高",
    "commonMeanings": [
      "改良",
      "提高"
    ],
    "example": "Améliorer votre prononciation.",
    "exampleTranslation": "改善您的发音。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 18,
    "word": "amuser",
    "phonetic": "/a.my.ze/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使开心，逗乐；v.pr. 玩得开心",
    "commonMeanings": [
      "使开心",
      "玩得开心"
    ],
    "example": "Les enfants s'amusent dans le jardin.",
    "exampleTranslation": "孩子们在花园里玩得很开心。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 19,
    "word": "annoncer",
    "phonetic": "/anɔ̃se/",
    "type": "v.t.",
    "translation": "宣布；通知",
    "commonMeanings": [
      "宣布",
      "通知"
    ],
    "example": "Il a annoncé son départ.",
    "exampleTranslation": "他宣布了离开。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 20,
    "word": "apercevoir",
    "phonetic": "/apɛrsəvwar/",
    "type": "v.t.",
    "translation": "瞥见；觉察",
    "commonMeanings": [
      "瞥见",
      "觉察"
    ],
    "example": "J'ai aperçu Pierre dans la foule.",
    "exampleTranslation": "我在人群中瞥见了Pierre。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 21,
    "word": "apparaître",
    "phonetic": "/aparɛtr/",
    "type": "v.i.",
    "translation": "出现",
    "commonMeanings": [
      "出现"
    ],
    "example": "Un arc-en-ciel est apparu.",
    "exampleTranslation": "一道彩虹出现了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 22,
    "word": "appartenir",
    "phonetic": "/apartənir/",
    "type": "v.i.",
    "translation": "属于",
    "commonMeanings": [
      "属于"
    ],
    "example": "Ce livre appartient à mon frère.",
    "exampleTranslation": "这本书是我哥哥的。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 23,
    "word": "appeler",
    "phonetic": "/a.p(ə).le/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 叫，打电话；v.pr. 名叫",
    "commonMeanings": [
      "叫",
      "打电话",
      "名叫"
    ],
    "example": "Comment tu t'appelles ?",
    "exampleTranslation": "你叫什么名字？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 24,
    "word": "apporter",
    "phonetic": "/a.pɔʁ.te/",
    "type": "v.t.",
    "translation": "v.t. 带来；提供，给予",
    "commonMeanings": [
      "带来",
      "提供",
      "给予"
    ],
    "example": "N'oubliez pas d'apporter votre passeport.",
    "exampleTranslation": "别忘了带护照。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 25,
    "word": "apprendre",
    "phonetic": "/aprɑ̃dr/",
    "type": "v.t.",
    "translation": "学习；得知",
    "commonMeanings": [
      "学习",
      "得知"
    ],
    "example": "J'apprends le français.",
    "exampleTranslation": "我在学法语。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 26,
    "word": "approcher",
    "phonetic": "/a.pʁɔ.ʃe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 靠近；v.pr. 临近，接近",
    "commonMeanings": [
      "靠近",
      "临近",
      "接近"
    ],
    "example": "La date limite approche.",
    "exampleTranslation": "截止日期临近了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 27,
    "word": "arrêter",
    "phonetic": "/a.ʁɛ.te/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 停止，逮捕；v.pr. 停下",
    "commonMeanings": [
      "停止",
      "逮捕",
      "停下"
    ],
    "example": "Arrêtez de fumer, c'est mauvais pour la santé.",
    "exampleTranslation": "别抽烟了，对身体不好。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 28,
    "word": "arriver",
    "phonetic": "/a.ʁi.ve/",
    "type": "v.i./v.imp.",
    "translation": "v.i. 到达，抵达；v.imp. 发生",
    "commonMeanings": [
      "到达",
      "抵达",
      "发生"
    ],
    "example": "Le train arrive à quelle heure ?",
    "exampleTranslation": "火车几点到？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 29,
    "word": "asseoir",
    "phonetic": "/a.swaʁ/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使坐下，安置；v.pr. 坐下",
    "commonMeanings": [
      "使坐下",
      "坐下"
    ],
    "example": "Asseyez-vous, je vous en prie.",
    "exampleTranslation": "请坐。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 30,
    "word": "assurer",
    "phonetic": "/asyre/",
    "type": "v.t.",
    "translation": "保证；保险",
    "commonMeanings": [
      "保证",
      "保险"
    ],
    "example": "Il assure qu'il viendra.",
    "exampleTranslation": "他保证他会来。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 31,
    "word": "atteindre",
    "phonetic": "/atɛ̃dr/",
    "type": "v.t.",
    "translation": "达到；到达",
    "commonMeanings": [
      "达到",
      "到达"
    ],
    "example": "Nous avons atteint notre but.",
    "exampleTranslation": "我们达到了目标。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 32,
    "word": "attendre",
    "phonetic": "/atɑ̃dr/",
    "type": "v.t.",
    "translation": "等待",
    "commonMeanings": [
      "等待"
    ],
    "example": "J'attends le bus.",
    "exampleTranslation": "我在等公交。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 33,
    "word": "attirer",
    "phonetic": "/a.ti.ʁe/",
    "type": "v.t.",
    "translation": "v.t. 吸引；引诱，招致",
    "commonMeanings": [
      "吸引",
      "引诱"
    ],
    "example": "Paris attire des millions de touristes chaque année.",
    "exampleTranslation": "巴黎每年吸引数百万游客。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 34,
    "word": "augmenter",
    "phonetic": "/oɡmɑ̃te/",
    "type": "v.t./v.i.",
    "translation": "增加",
    "commonMeanings": [
      "增加"
    ],
    "example": "Le prix a augmenté.",
    "exampleTranslation": "价格上涨了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 35,
    "word": "avancer",
    "phonetic": "/avɑ̃se/",
    "type": "v.t./v.i.",
    "translation": "前进；推进",
    "commonMeanings": [
      "前进",
      "推进"
    ],
    "example": "Les travaux avancent vite.",
    "exampleTranslation": "工程进展很快。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 36,
    "word": "avertir",
    "phonetic": "/avɛrtir/",
    "type": "v.t.",
    "translation": "通知；警告",
    "commonMeanings": [
      "通知",
      "警告"
    ],
    "example": "Je vous avertis du danger.",
    "exampleTranslation": "我提醒你有危险。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 37,
    "word": "avoir",
    "phonetic": "/a.vwaʁ/",
    "type": "v.t.",
    "translation": "v.t. 有，拥有；（助动词）构成复合时态",
    "commonMeanings": [
      "有",
      "拥有",
      "助动词"
    ],
    "example": "Elle a une voiture.",
    "exampleTranslation": "她有一辆车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 38,
    "word": "battre",
    "phonetic": "/batr/",
    "type": "v.t.",
    "translation": "打；击败",
    "commonMeanings": [
      "打",
      "击败"
    ],
    "example": "Notre équipe a battu l'adversaire.",
    "exampleTranslation": "我们队击败了对手。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 39,
    "word": "bénéficier",
    "phonetic": "/benefisje/",
    "type": "v.i.",
    "translation": "得益；享受",
    "commonMeanings": [
      "得益",
      "享受"
    ],
    "example": "Il bénéficie d'une bourse.",
    "exampleTranslation": "他享有奖学金。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 40,
    "word": "boire",
    "phonetic": "/bwar/",
    "type": "v.t.",
    "translation": "喝；饮",
    "commonMeanings": [
      "喝",
      "饮"
    ],
    "example": "Voulez-vous boire un café ?",
    "exampleTranslation": "您想喝杯咖啡吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 41,
    "word": "bouger",
    "phonetic": "/buʒe/",
    "type": "v.t./v.i.",
    "translation": "移动；晃动",
    "commonMeanings": [
      "移动",
      "晃动"
    ],
    "example": "Ne bougez pas !",
    "exampleTranslation": "别动！",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 42,
    "word": "briller",
    "phonetic": "/brije/",
    "type": "v.i.",
    "translation": "发光；出众",
    "commonMeanings": [
      "发光",
      "出众"
    ],
    "example": "Le soleil brille.",
    "exampleTranslation": "阳光灿烂。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 43,
    "word": "briser",
    "phonetic": "/brize/",
    "type": "v.t.",
    "translation": "打碎；折断",
    "commonMeanings": [
      "打碎",
      "折断"
    ],
    "example": "Il a brisé le miroir.",
    "exampleTranslation": "他打碎了镜子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 44,
    "word": "cacher",
    "phonetic": "/ka.ʃe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 隐藏，掩盖；v.pr. 躲藏",
    "commonMeanings": [
      "隐藏",
      "掩盖",
      "躲藏"
    ],
    "example": "Où as-tu caché mon téléphone ?",
    "exampleTranslation": "你把我的手机藏哪儿了？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 45,
    "word": "changer",
    "phonetic": "/ʃɑ̃ʒe/",
    "type": "v.t./v.i.",
    "translation": "改变；换",
    "commonMeanings": [
      "改变",
      "换"
    ],
    "example": "Changer de train.",
    "exampleTranslation": "换乘火车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 46,
    "word": "chanter",
    "phonetic": "/ʃɑ̃te/",
    "type": "v.t./v.i.",
    "translation": "唱歌",
    "commonMeanings": [
      "唱歌"
    ],
    "example": "Elle chante très bien.",
    "exampleTranslation": "她唱得很好。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 47,
    "word": "charger",
    "phonetic": "/ʃarʒe/",
    "type": "v.t.",
    "translation": "装载；负责",
    "commonMeanings": [
      "装载",
      "负责"
    ],
    "example": "Charger la voiture.",
    "exampleTranslation": "给车装货。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 48,
    "word": "chasser",
    "phonetic": "/ʃase/",
    "type": "v.t.",
    "translation": "打猎；驱逐",
    "commonMeanings": [
      "打猎",
      "驱逐"
    ],
    "example": "Chasser les mouches.",
    "exampleTranslation": "赶苍蝇。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 49,
    "word": "chercher",
    "phonetic": "/ʃɛʁ.ʃe/",
    "type": "v.t.",
    "translation": "v.t. 寻找；试图（做某事）",
    "commonMeanings": [
      "寻找",
      "试图"
    ],
    "example": "Je cherche mes clés partout.",
    "exampleTranslation": "我到处找我的钥匙。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 50,
    "word": "choisir",
    "phonetic": "/ʃwazir/",
    "type": "v.t.",
    "translation": "选择",
    "commonMeanings": [
      "选择"
    ],
    "example": "Vous devez choisir un plat.",
    "exampleTranslation": "您需要选一道菜。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 51,
    "word": "combattre",
    "phonetic": "/kɔ̃batr/",
    "type": "v.t.",
    "translation": "战斗；反对",
    "commonMeanings": [
      "战斗",
      "反对"
    ],
    "example": "Combattre la maladie.",
    "exampleTranslation": "与疾病作斗争。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 52,
    "word": "commander",
    "phonetic": "/kɔmɑ̃de/",
    "type": "v.t.",
    "translation": "命令；订购",
    "commonMeanings": [
      "命令",
      "订购"
    ],
    "example": "Commander un repas.",
    "exampleTranslation": "订一份餐。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 53,
    "word": "commencer",
    "phonetic": "/kɔmɑ̃se/",
    "type": "v.t.",
    "translation": "开始",
    "commonMeanings": [
      "开始"
    ],
    "example": "Le spectacle commence.",
    "exampleTranslation": "演出开始了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 54,
    "word": "comprendre",
    "phonetic": "/kɔ̃prɑ̃dr/",
    "type": "v.t.",
    "translation": "理解；包含",
    "commonMeanings": [
      "理解",
      "包含"
    ],
    "example": "Je comprends tout.",
    "exampleTranslation": "我全明白了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 55,
    "word": "compter",
    "phonetic": "/kɔ̃.te/",
    "type": "v.t./v.i.",
    "translation": "v.t. 数，计算；v.i. 打算，算数",
    "commonMeanings": [
      "数",
      "计算",
      "打算"
    ],
    "example": "Je compte partir demain matin.",
    "exampleTranslation": "我打算明天早上出发。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 56,
    "word": "conduire",
    "phonetic": "/kɔ̃dɥir/",
    "type": "v.t.",
    "translation": "驾驶；引导",
    "commonMeanings": [
      "驾驶",
      "引导"
    ],
    "example": "Conduire une voiture.",
    "exampleTranslation": "驾驶汽车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 57,
    "word": "confier",
    "phonetic": "/kɔ̃fje/",
    "type": "v.t.",
    "translation": "委托；吐露",
    "commonMeanings": [
      "委托",
      "吐露"
    ],
    "example": "Confier un secret.",
    "exampleTranslation": "倾诉一个秘密。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 58,
    "word": "connaître",
    "phonetic": "/kɔnɛtr/",
    "type": "v.t.",
    "translation": "认识；了解",
    "commonMeanings": [
      "认识",
      "了解"
    ],
    "example": "Je connais ce monsieur.",
    "exampleTranslation": "我认识这位先生。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 59,
    "word": "conquérir",
    "phonetic": "/kɔ̃kerir/",
    "type": "v.t.",
    "translation": "征服；赢得",
    "commonMeanings": [
      "征服",
      "赢得"
    ],
    "example": "Conquérir le marché.",
    "exampleTranslation": "征服市场。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 60,
    "word": "conseiller",
    "phonetic": "/kɔ̃seje/",
    "type": "v.t.",
    "translation": "建议；劝告",
    "commonMeanings": [
      "建议",
      "劝告"
    ],
    "example": "Je vous conseille de partir.",
    "exampleTranslation": "我建议您离开。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 61,
    "word": "consentir",
    "phonetic": "/kɔ̃sɑ̃tir/",
    "type": "v.i.",
    "translation": "同意",
    "commonMeanings": [
      "同意"
    ],
    "example": "Consentir à un projet.",
    "exampleTranslation": "同意一个项目。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 62,
    "word": "considérer",
    "phonetic": "/kɔ̃.si.de.ʁe/",
    "type": "v.t.",
    "translation": "v.t. 考虑；认为；打量",
    "commonMeanings": [
      "考虑",
      "认为",
      "打量"
    ],
    "example": "Je considère que c'est une bonne idée.",
    "exampleTranslation": "我认为这是个好主意。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 63,
    "word": "construire",
    "phonetic": "/kɔ̃strɥir/",
    "type": "v.t.",
    "translation": "建造",
    "commonMeanings": [
      "建造"
    ],
    "example": "Construire une maison.",
    "exampleTranslation": "建造一所房子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 64,
    "word": "contenir",
    "phonetic": "/kɔ̃tnir/",
    "type": "v.t.",
    "translation": "包含；克制",
    "commonMeanings": [
      "包含",
      "克制"
    ],
    "example": "Ce sac contient des fruits.",
    "exampleTranslation": "这个包里装着水果。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 65,
    "word": "continuer",
    "phonetic": "/kɔ̃tinɥe/",
    "type": "v.t./v.i.",
    "translation": "继续",
    "commonMeanings": [
      "继续"
    ],
    "example": "Continuez votre travail.",
    "exampleTranslation": "继续您的工作。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 66,
    "word": "convaincre",
    "phonetic": "/kɔ̃vɛ̃kr/",
    "type": "v.t.",
    "translation": "说服",
    "commonMeanings": [
      "说服"
    ],
    "example": "Convaincre le client.",
    "exampleTranslation": "说服客户。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 67,
    "word": "convenir",
    "phonetic": "/kɔ̃vnir/",
    "type": "v.i.",
    "translation": "适合；一致",
    "commonMeanings": [
      "适合",
      "一致"
    ],
    "example": "Cela me convient.",
    "exampleTranslation": "这很适合我。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 68,
    "word": "correspondre",
    "phonetic": "/kɔrɛspɔ̃dr/",
    "type": "v.i.",
    "translation": "符合；通信",
    "commonMeanings": [
      "符合",
      "通信"
    ],
    "example": "Cela correspond à mes attentes.",
    "exampleTranslation": "这符合我的期望。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 69,
    "word": "coucher",
    "phonetic": "/ku.ʃe/",
    "type": "v.t./v.pr./v.i.",
    "translation": "v.t. 使躺下；v.pr. 就寝；v.i.（日月）落下",
    "commonMeanings": [
      "使躺下",
      "就寝",
      "落下"
    ],
    "example": "Je me couche tôt en semaine.",
    "exampleTranslation": "工作日我早睡。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 70,
    "word": "couper",
    "phonetic": "/ku.pe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 切，剪，切断，关掉；v.pr. 割伤自己",
    "commonMeanings": [
      "切",
      "剪",
      "切断",
      "关掉"
    ],
    "example": "Peux-tu couper le pain, s'il te plaît ?",
    "exampleTranslation": "请你切一下面包好吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 71,
    "word": "courir",
    "phonetic": "/kurir/",
    "type": "v.i.",
    "translation": "跑",
    "commonMeanings": [
      "跑"
    ],
    "example": "Courir dans le parc.",
    "exampleTranslation": "在公园里跑步。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 72,
    "word": "craindre",
    "phonetic": "/krɛ̃dr/",
    "type": "v.t.",
    "translation": "害怕；担心",
    "commonMeanings": [
      "害怕",
      "担心"
    ],
    "example": "Je crains qu'il ne pleuve.",
    "exampleTranslation": "我怕会下雨。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 73,
    "word": "créer",
    "phonetic": "/kʁe.e/",
    "type": "v.t.",
    "translation": "v.t. 创造；创建；创作",
    "commonMeanings": [
      "创造",
      "创建",
      "创作"
    ],
    "example": "Ils ont créé leur entreprise il y a deux ans.",
    "exampleTranslation": "他们两年前创建了自己的公司。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 74,
    "word": "crier",
    "phonetic": "/kʁi.je/",
    "type": "v.i./v.t.",
    "translation": "v.i. 叫喊；v.t. 呼喊，大声说",
    "commonMeanings": [
      "叫喊",
      "呼喊"
    ],
    "example": "Ne crie pas si fort, le bébé dort.",
    "exampleTranslation": "别那么大声喊，宝宝在睡觉。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 75,
    "word": "croire",
    "phonetic": "/krwar/",
    "type": "v.t.",
    "translation": "相信；认为",
    "commonMeanings": [
      "相信",
      "认为"
    ],
    "example": "Je crois qu'il a raison.",
    "exampleTranslation": "我相信他是对的。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 76,
    "word": "cueillir",
    "phonetic": "/kœjir/",
    "type": "v.t.",
    "translation": "采；摘",
    "commonMeanings": [
      "采",
      "摘"
    ],
    "example": "Cueillir des fleurs.",
    "exampleTranslation": "采花。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 77,
    "word": "danser",
    "phonetic": "/dɑ̃.se/",
    "type": "v.i./v.t.",
    "translation": "v.t./v.i. 跳舞",
    "commonMeanings": [
      "跳舞"
    ],
    "example": "Voulez-vous danser avec moi ?",
    "exampleTranslation": "您愿意和我跳支舞吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 78,
    "word": "décevoir",
    "phonetic": "/desəvwar/",
    "type": "v.t.",
    "translation": "使失望",
    "commonMeanings": [
      "使失望"
    ],
    "example": "Ce film m'a déçu.",
    "exampleTranslation": "这部电影让我失望。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 79,
    "word": "décider",
    "phonetic": "/deside/",
    "type": "v.t.",
    "translation": "决定",
    "commonMeanings": [
      "决定"
    ],
    "example": "Décider de partir.",
    "exampleTranslation": "决定离开。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 80,
    "word": "déclarer",
    "phonetic": "/de.kla.ʁe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 宣布，声明；v.pr. 表态，自称",
    "commonMeanings": [
      "宣布",
      "声明",
      "表态"
    ],
    "example": "Il a déclaré son amour à Marie.",
    "exampleTranslation": "他向Marie表白了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 81,
    "word": "découvrir",
    "phonetic": "/dekuvrir/",
    "type": "v.t.",
    "translation": "发现",
    "commonMeanings": [
      "发现"
    ],
    "example": "Découvrir un secret.",
    "exampleTranslation": "发现一个秘密。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 82,
    "word": "décrire",
    "phonetic": "/dekrir/",
    "type": "v.t.",
    "translation": "描写",
    "commonMeanings": [
      "描写"
    ],
    "example": "Décrire un paysage.",
    "exampleTranslation": "描绘一处风景。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 83,
    "word": "défendre",
    "phonetic": "/defɑ̃dr/",
    "type": "v.t.",
    "translation": "保卫；禁止",
    "commonMeanings": [
      "保卫",
      "禁止"
    ],
    "example": "Défendre ses droits.",
    "exampleTranslation": "捍卫自己的权利。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 84,
    "word": "demander",
    "phonetic": "/də.mɑ̃.de/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 问，请求；v.pr. 自问，寻思",
    "commonMeanings": [
      "问",
      "请求",
      "自问"
    ],
    "example": "Puis-je vous demander un service ?",
    "exampleTranslation": "我能请您帮个忙吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 85,
    "word": "dépendre",
    "phonetic": "/depɑ̃dr/",
    "type": "v.i.",
    "translation": "取决于",
    "commonMeanings": [
      "取决于"
    ],
    "example": "Cela dépend du temps.",
    "exampleTranslation": "这取决于天气。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 86,
    "word": "descendre",
    "phonetic": "/desɑ̃dr/",
    "type": "v.i.",
    "translation": "下来",
    "commonMeanings": [
      "下来"
    ],
    "example": "Descendre l'escalier.",
    "exampleTranslation": "下楼梯。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 87,
    "word": "détester",
    "phonetic": "/de.tɛs.te/",
    "type": "v.t.",
    "translation": "v.t. 憎恨，厌恶，讨厌",
    "commonMeanings": [
      "憎恨",
      "厌恶",
      "讨厌"
    ],
    "example": "Je déteste les mensonges.",
    "exampleTranslation": "我痛恨谎言。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 88,
    "word": "détruire",
    "phonetic": "/detrɥir/",
    "type": "v.t.",
    "translation": "破坏",
    "commonMeanings": [
      "破坏"
    ],
    "example": "Le feu détruit tout.",
    "exampleTranslation": "大火毁灭一切。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 89,
    "word": "développer",
    "phonetic": "/de.vlɔ.pe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 发展；展开；开发；v.pr. 发展壮大",
    "commonMeanings": [
      "发展",
      "展开",
      "开发"
    ],
    "example": "L'entreprise veut développer de nouveaux marchés.",
    "exampleTranslation": "公司想开拓新市场。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 90,
    "word": "devenir",
    "phonetic": "/dəvnir/",
    "type": "v.i.",
    "translation": "变成",
    "commonMeanings": [
      "变成"
    ],
    "example": "Il devient célèbre.",
    "exampleTranslation": "他变得出名了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 91,
    "word": "deviner",
    "phonetic": "/dəvine/",
    "type": "v.t.",
    "translation": "猜",
    "commonMeanings": [
      "猜"
    ],
    "example": "Deviner une énigme.",
    "exampleTranslation": "猜一个谜语。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 92,
    "word": "devoir",
    "phonetic": "/dəvwar/",
    "type": "v.t.",
    "translation": "应该；欠",
    "commonMeanings": [
      "应该",
      "欠"
    ],
    "example": "Je dois travailler.",
    "exampleTranslation": "我必须工作。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 93,
    "word": "diminuer",
    "phonetic": "/diminɥe/",
    "type": "v.t./v.i.",
    "translation": "减少",
    "commonMeanings": [
      "减少"
    ],
    "example": "La pluie diminue.",
    "exampleTranslation": "雨势减弱了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 94,
    "word": "dîner",
    "phonetic": "/di.ne/",
    "type": "v.i.",
    "translation": "v.i. 吃晚饭，用正餐",
    "commonMeanings": [
      "吃晚饭",
      "用正餐"
    ],
    "example": "Nous dînons toujours à 20 heures.",
    "exampleTranslation": "我们总是晚上8点吃晚饭。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 95,
    "word": "dire",
    "phonetic": "/diʁ/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 说，告诉；v.pr. 自称，心想",
    "commonMeanings": [
      "说",
      "告诉",
      "自称"
    ],
    "example": "Il m'a dit la vérité.",
    "exampleTranslation": "他把真相告诉了我。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 96,
    "word": "diriger",
    "phonetic": "/di.ʁi.ʒe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 领导，管理，指挥；v.pr. 走向",
    "commonMeanings": [
      "领导",
      "管理",
      "指挥"
    ],
    "example": "Elle dirige une équipe de dix personnes.",
    "exampleTranslation": "她领导着一个十人的团队。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 97,
    "word": "discuter",
    "phonetic": "/dis.ky.te/",
    "type": "v.t./v.i.",
    "translation": "v.t. 讨论，争论；v.i. 聊天",
    "commonMeanings": [
      "讨论",
      "争论",
      "聊天"
    ],
    "example": "Nous devons discuter de ce problème sérieusement.",
    "exampleTranslation": "我们需要认真讨论这个问题。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 98,
    "word": "disparaître",
    "phonetic": "/disparɛtr/",
    "type": "v.i.",
    "translation": "消失",
    "commonMeanings": [
      "消失"
    ],
    "example": "Le soleil disparaît.",
    "exampleTranslation": "太阳消失了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 99,
    "word": "distinguer",
    "phonetic": "/distɛ̃ɡe/",
    "type": "v.t.",
    "translation": "区分",
    "commonMeanings": [
      "区分"
    ],
    "example": "Distinguer les couleurs.",
    "exampleTranslation": "区分颜色。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 100,
    "word": "donner",
    "phonetic": "/dɔ.ne/",
    "type": "v.t.",
    "translation": "v.t. 给，给予；朝向（门窗）",
    "commonMeanings": [
      "给",
      "给予",
      "朝向"
    ],
    "example": "Peux-tu me donner un coup de main ?",
    "exampleTranslation": "你能帮我一把吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 101,
    "word": "dormir",
    "phonetic": "/dɔrmir/",
    "type": "v.i.",
    "translation": "睡觉",
    "commonMeanings": [
      "睡觉"
    ],
    "example": "Dormir huit heures.",
    "exampleTranslation": "睡八个小时。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 102,
    "word": "douter",
    "phonetic": "/dute/",
    "type": "v.i.",
    "translation": "怀疑",
    "commonMeanings": [
      "怀疑"
    ],
    "example": "Je doute de lui.",
    "exampleTranslation": "我对他有怀疑。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 103,
    "word": "échapper",
    "phonetic": "/eʃape/",
    "type": "v.i.",
    "translation": "逃脱",
    "commonMeanings": [
      "逃脱"
    ],
    "example": "Échapper au danger.",
    "exampleTranslation": "逃脱危险。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 104,
    "word": "échouer",
    "phonetic": "/eʃwe/",
    "type": "v.i.",
    "translation": "失败",
    "commonMeanings": [
      "失败"
    ],
    "example": "Échouer à l'examen.",
    "exampleTranslation": "考试失败。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 105,
    "word": "écouter",
    "phonetic": "/ekute/",
    "type": "v.t.",
    "translation": "听",
    "commonMeanings": [
      "听"
    ],
    "example": "Écouter la radio.",
    "exampleTranslation": "听广播。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 106,
    "word": "écrire",
    "phonetic": "/ekrir/",
    "type": "v.t.",
    "translation": "写",
    "commonMeanings": [
      "写"
    ],
    "example": "Écrire une lettre.",
    "exampleTranslation": "写一封信。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 107,
    "word": "effacer",
    "phonetic": "/efase/",
    "type": "v.t.",
    "translation": "擦掉",
    "commonMeanings": [
      "擦掉"
    ],
    "example": "Effacer le tableau.",
    "exampleTranslation": "擦黑板。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 108,
    "word": "élever",
    "phonetic": "/el.ve/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 举起，抚养，提高；v.pr. 升起",
    "commonMeanings": [
      "举起",
      "抚养",
      "提高"
    ],
    "example": "Elle a élevé trois enfants toute seule.",
    "exampleTranslation": "她独自抚养了三个孩子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 109,
    "word": "élire",
    "phonetic": "/elir/",
    "type": "v.t.",
    "translation": "选举",
    "commonMeanings": [
      "选举"
    ],
    "example": "Élire un président.",
    "exampleTranslation": "选举一位总统。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 110,
    "word": "éloigner",
    "phonetic": "/elwaɲe/",
    "type": "v.t.",
    "translation": "使远离",
    "commonMeanings": [
      "使远离"
    ],
    "example": "Éloigner les enfants du feu.",
    "exampleTranslation": "让孩子们远离火源。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 111,
    "word": "embrasser",
    "phonetic": "/ɑ̃brase/",
    "type": "v.t.",
    "translation": "拥抱/亲吻",
    "commonMeanings": [
      "拥抱/亲吻"
    ],
    "example": "Embrasser ses parents.",
    "exampleTranslation": "拥抱父母。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 112,
    "word": "emmener",
    "phonetic": "/ɑ̃mne/",
    "type": "v.t.",
    "translation": "带走（人/动物）",
    "commonMeanings": [
      "带走"
    ],
    "example": "Emmener les enfants à l'école.",
    "exampleTranslation": "送孩子们去学校。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 113,
    "word": "empêcher",
    "phonetic": "/ɑ̃pɛʃe/",
    "type": "v.t.",
    "translation": "阻止",
    "commonMeanings": [
      "阻止"
    ],
    "example": "Empêcher quelqu'un de sortir.",
    "exampleTranslation": "阻止某人外出。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 114,
    "word": "employer",
    "phonetic": "/ɑ̃plwaje/",
    "type": "v.t.",
    "translation": "使用/雇佣",
    "commonMeanings": [
      "使用/雇佣"
    ],
    "example": "Employer un outil.",
    "exampleTranslation": "使用一种工具。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 115,
    "word": "emprunter",
    "phonetic": "/ɑ̃prœ̃te/",
    "type": "v.t.",
    "translation": "借入",
    "commonMeanings": [
      "借入"
    ],
    "example": "Emprunter un livre à la bibliothèque.",
    "exampleTranslation": "从图书馆借一本书。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 116,
    "word": "encourager",
    "phonetic": "/ɑ̃kuraʒe/",
    "type": "v.t.",
    "translation": "鼓励",
    "commonMeanings": [
      "鼓励"
    ],
    "example": "Encourager ses élèves.",
    "exampleTranslation": "鼓励学生。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 117,
    "word": "engager",
    "phonetic": "/ɑ̃ɡaʒe/",
    "type": "v.t.",
    "translation": "雇佣；约束",
    "commonMeanings": [
      "雇佣",
      "约束"
    ],
    "example": "Engager du personnel.",
    "exampleTranslation": "招聘员工。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 118,
    "word": "enlever",
    "phonetic": "/ɑ̃lve/",
    "type": "v.t.",
    "translation": "脱下；除去",
    "commonMeanings": [
      "脱下",
      "除去"
    ],
    "example": "Enlever son manteau.",
    "exampleTranslation": "脱掉大衣。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 119,
    "word": "ennuyer",
    "phonetic": "/ɑ̃nɥije/",
    "type": "v.t.",
    "translation": "使厌烦；打扰",
    "commonMeanings": [
      "使厌烦",
      "打扰"
    ],
    "example": "Cette musique m'ennuie.",
    "exampleTranslation": "这音乐让我厌烦。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 120,
    "word": "enseigner",
    "phonetic": "/ɑ̃seɲe/",
    "type": "v.t.",
    "translation": "教；教导",
    "commonMeanings": [
      "教",
      "教导"
    ],
    "example": "Enseigner le français.",
    "exampleTranslation": "教法语。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 121,
    "word": "entendre",
    "phonetic": "/ɑ̃tɑ̃dr/",
    "type": "v.t.",
    "translation": "听见",
    "commonMeanings": [
      "听见"
    ],
    "example": "Entendre un bruit.",
    "exampleTranslation": "听到一声响动。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 122,
    "word": "entourer",
    "phonetic": "/ɑ̃ture/",
    "type": "v.t.",
    "translation": "围住",
    "commonMeanings": [
      "围住"
    ],
    "example": "Entourer le jardin d'un mur.",
    "exampleTranslation": "用墙围住花园。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 123,
    "word": "entraîner",
    "phonetic": "/ɑ̃trɛne/",
    "type": "v.t.",
    "translation": "训练；导致",
    "commonMeanings": [
      "训练",
      "导致"
    ],
    "example": "Entraîner une équipe.",
    "exampleTranslation": "训练一支球队。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 124,
    "word": "entreprendre",
    "phonetic": "/ɑ̃trəprɑ̃dr/",
    "type": "v.t.",
    "translation": "着手；进行",
    "commonMeanings": [
      "着手",
      "进行"
    ],
    "example": "Entreprendre des réformes.",
    "exampleTranslation": "进行改革。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 125,
    "word": "entrer",
    "phonetic": "/ɑ̃.tʁe/",
    "type": "v.i.",
    "translation": "v.i. 进入，进来",
    "commonMeanings": [
      "进入",
      "进来"
    ],
    "example": "Entrez, je vous en prie !",
    "exampleTranslation": "请进！",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 126,
    "word": "entretenir",
    "phonetic": "/ɑ̃trətnir/",
    "type": "v.t.",
    "translation": "维持；保养",
    "commonMeanings": [
      "维持",
      "保养"
    ],
    "example": "Entretenir la maison.",
    "exampleTranslation": "维护房子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 127,
    "word": "envahir",
    "phonetic": "/ɑ̃vazir/",
    "type": "v.t.",
    "translation": "侵略；充满",
    "commonMeanings": [
      "侵略",
      "充满"
    ],
    "example": "La foule envahit la rue.",
    "exampleTranslation": "人群涌入街道。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 128,
    "word": "envisager",
    "phonetic": "/ɑ̃vizaʒe/",
    "type": "v.t.",
    "translation": "展望；考虑",
    "commonMeanings": [
      "展望",
      "考虑"
    ],
    "example": "Envisager l'avenir.",
    "exampleTranslation": "展望未来。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 129,
    "word": "envoyer",
    "phonetic": "/ɑ̃vwaje/",
    "type": "v.t.",
    "translation": "发送",
    "commonMeanings": [
      "发送"
    ],
    "example": "Envoyer un e-mail.",
    "exampleTranslation": "发送一封邮件。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 130,
    "word": "espérer",
    "phonetic": "/ɛspere/",
    "type": "v.t.",
    "translation": "希望",
    "commonMeanings": [
      "希望"
    ],
    "example": "J'espère qu'il viendra.",
    "exampleTranslation": "我希望他会来。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 131,
    "word": "essayer",
    "phonetic": "/eseje/",
    "type": "v.t.",
    "translation": "尝试",
    "commonMeanings": [
      "尝试"
    ],
    "example": "Essayer une robe.",
    "exampleTranslation": "试穿一条裙子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 132,
    "word": "établir",
    "phonetic": "/etablir/",
    "type": "v.t.",
    "translation": "建立",
    "commonMeanings": [
      "建立"
    ],
    "example": "Établir un record.",
    "exampleTranslation": "创造一项纪录。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 133,
    "word": "éteindre",
    "phonetic": "/etɛ̃dr/",
    "type": "v.t.",
    "translation": "关(灯)；熄灭",
    "commonMeanings": [
      "关(灯)",
      "熄灭"
    ],
    "example": "Éteindre la lumière.",
    "exampleTranslation": "关灯。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 134,
    "word": "étendre",
    "phonetic": "/etɑ̃dr/",
    "type": "v.t.",
    "translation": "铺开；扩大",
    "commonMeanings": [
      "铺开",
      "扩大"
    ],
    "example": "Étendre le linge.",
    "exampleTranslation": "晾衣服。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 135,
    "word": "étonner",
    "phonetic": "/etɔne/",
    "type": "v.t.",
    "translation": "使惊讶",
    "commonMeanings": [
      "使惊讶"
    ],
    "example": "Cela m'étonne beaucoup.",
    "exampleTranslation": "这让我很惊讶。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 136,
    "word": "être",
    "phonetic": "/ɛtʁ/",
    "type": "v.",
    "translation": "是；存在；（助动词）构成复合时态",
    "commonMeanings": [
      "是",
      "存在",
      "助动词"
    ],
    "example": "Il est médecin.",
    "exampleTranslation": "他是医生。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 137,
    "word": "étudier",
    "phonetic": "/etydje/",
    "type": "v.t.",
    "translation": "学习；研究",
    "commonMeanings": [
      "学习",
      "研究"
    ],
    "example": "Étudier la médecine.",
    "exampleTranslation": "学医。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 138,
    "word": "éviter",
    "phonetic": "/evite/",
    "type": "v.t.",
    "translation": "避免",
    "commonMeanings": [
      "避免"
    ],
    "example": "Éviter les fautes.",
    "exampleTranslation": "避免错误。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 139,
    "word": "évoluer",
    "phonetic": "/evɔlɥe/",
    "type": "v.i.",
    "translation": "进化；演变",
    "commonMeanings": [
      "进化",
      "演变"
    ],
    "example": "La situation évolue.",
    "exampleTranslation": "形势在变化发展。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 140,
    "word": "exagérer",
    "phonetic": "/ɛɡzaʒere/",
    "type": "v.t.",
    "translation": "夸张",
    "commonMeanings": [
      "夸张"
    ],
    "example": "Tu exagères toujours !",
    "exampleTranslation": "你总是夸张！",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 141,
    "word": "examiner",
    "phonetic": "/ɛɡzamine/",
    "type": "v.t.",
    "translation": "检查；审视",
    "commonMeanings": [
      "检查",
      "考试"
    ],
    "example": "Examiner un patient.",
    "exampleTranslation": "检查一位病人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 142,
    "word": "excuser",
    "phonetic": "/ɛk.sky.ze/",
    "type": "v.t.",
    "translation": "v.t. 原谅，宽恕",
    "commonMeanings": [
      "原谅",
      "宽恕"
    ],
    "example": "Excusez-moi, je suis en retard.",
    "exampleTranslation": "对不起，我迟到了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 143,
    "word": "exiger",
    "phonetic": "/ɛɡziʒe/",
    "type": "v.t.",
    "translation": "要求",
    "commonMeanings": [
      "要求"
    ],
    "example": "Exiger le silence.",
    "exampleTranslation": "要求安静。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 144,
    "word": "exister",
    "phonetic": "/ɛɡziste/",
    "type": "v.i.",
    "translation": "存在",
    "commonMeanings": [
      "存在"
    ],
    "example": "Le Père Noël n'existe pas.",
    "exampleTranslation": "圣诞老人是不存在的。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 145,
    "word": "expliquer",
    "phonetic": "/ɛksplike/",
    "type": "v.t.",
    "translation": "解释",
    "commonMeanings": [
      "解释"
    ],
    "example": "Expliquer une règle.",
    "exampleTranslation": "解释一条规则。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 146,
    "word": "exprimer",
    "phonetic": "/ɛksprime/",
    "type": "v.t.",
    "translation": "表达",
    "commonMeanings": [
      "表达"
    ],
    "example": "Exprimer sa joie.",
    "exampleTranslation": "表达喜悦。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 147,
    "word": "fabriquer",
    "phonetic": "/fabrike/",
    "type": "v.t.",
    "translation": "制造",
    "commonMeanings": [
      "制造"
    ],
    "example": "Fabriquer des jouets.",
    "exampleTranslation": "制造玩具。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 148,
    "word": "faillir",
    "phonetic": "/fajir/",
    "type": "v.i.",
    "translation": "差点儿；失败",
    "commonMeanings": [
      "差点儿",
      "失败"
    ],
    "example": "J'ai failli tomber.",
    "exampleTranslation": "我差点摔倒。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 149,
    "word": "faire",
    "phonetic": "/fɛʁ/",
    "type": "v.t./v.i.",
    "translation": "v.t. 做，制作，使；v.i. 做，干",
    "commonMeanings": [
      "做",
      "制作",
      "使"
    ],
    "example": "Que faites-vous dans la vie ?",
    "exampleTranslation": "您是做什么工作的？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 150,
    "word": "falloir",
    "phonetic": "/falwar/",
    "type": "v.imp.",
    "translation": "必须",
    "commonMeanings": [
      "必须"
    ],
    "example": "Il faut partir.",
    "exampleTranslation": "必须出发了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 151,
    "word": "fatiguer",
    "phonetic": "/fa.ti.ɡe/",
    "type": "v.t./v.pr./v.i.",
    "translation": "v.t. 使疲劳；v.pr. 费劲；v.i. 使厌倦",
    "commonMeanings": [
      "使疲劳",
      "费劲",
      "使厌倦"
    ],
    "example": "Ce long voyage m'a beaucoup fatigué.",
    "exampleTranslation": "这次长途旅行让我很疲惫。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 152,
    "word": "féliciter",
    "phonetic": "/felisite/",
    "type": "v.t.",
    "translation": "祝贺",
    "commonMeanings": [
      "祝贺"
    ],
    "example": "Féliciter un ami.",
    "exampleTranslation": "祝贺一位朋友。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 153,
    "word": "fermer",
    "phonetic": "/fɛrme/",
    "type": "v.t.",
    "translation": "关闭",
    "commonMeanings": [
      "关闭"
    ],
    "example": "Fermer la porte.",
    "exampleTranslation": "关门。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 154,
    "word": "fêter",
    "phonetic": "/fɛte/",
    "type": "v.t.",
    "translation": "庆祝",
    "commonMeanings": [
      "庆祝"
    ],
    "example": "Fêter son anniversaire.",
    "exampleTranslation": "庆祝生日。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 155,
    "word": "figurer",
    "phonetic": "/fiɡyre/",
    "type": "v.i./v.pr.",
    "translation": "v.i. 出现，列入；v.pr. 想象",
    "commonMeanings": [
      "出现",
      "想象"
    ],
    "example": "Figurer sur une liste.",
    "exampleTranslation": "出现在一个名单上。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 156,
    "word": "finir",
    "phonetic": "/fi.niʁ/",
    "type": "v.t./v.i.",
    "translation": "v.t. 结束，完成；v.i. 以…结束",
    "commonMeanings": [
      "结束",
      "完成"
    ],
    "example": "J'ai enfin fini mes devoirs.",
    "exampleTranslation": "我终于做完了作业。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 157,
    "word": "fixer",
    "phonetic": "/fikse/",
    "type": "v.t.",
    "translation": "固定；注视",
    "commonMeanings": [
      "固定",
      "注视"
    ],
    "example": "Fixer un rendez-vous.",
    "exampleTranslation": "约定一个约会。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 158,
    "word": "flatter",
    "phonetic": "/flate/",
    "type": "v.t.",
    "translation": "奉承；使高兴",
    "commonMeanings": [
      "奉承",
      "使高兴"
    ],
    "example": "Flatter son patron.",
    "exampleTranslation": "奉承老板。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 159,
    "word": "fleurir",
    "phonetic": "/flœrir/",
    "type": "v.i.",
    "translation": "开花；繁荣",
    "commonMeanings": [
      "开花",
      "繁荣"
    ],
    "example": "Les roses fleurissent.",
    "exampleTranslation": "玫瑰花开了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 160,
    "word": "forcer",
    "phonetic": "/fɔrse/",
    "type": "v.t.",
    "translation": "强迫；强行打开",
    "commonMeanings": [
      "强迫"
    ],
    "example": "Forcer la serrure.",
    "exampleTranslation": "撬锁。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 161,
    "word": "former",
    "phonetic": "/fɔrme/",
    "type": "v.t.",
    "translation": "形成；培训",
    "commonMeanings": [
      "形成",
      "培训"
    ],
    "example": "Former des jeunes.",
    "exampleTranslation": "培养年轻人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 162,
    "word": "fournir",
    "phonetic": "/furnir/",
    "type": "v.t.",
    "translation": "提供",
    "commonMeanings": [
      "提供"
    ],
    "example": "Fournir des preuves.",
    "exampleTranslation": "提供证据。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 163,
    "word": "frapper",
    "phonetic": "/frape/",
    "type": "v.t./v.i.",
    "translation": "敲；打",
    "commonMeanings": [
      "敲",
      "打"
    ],
    "example": "Frapper à la porte.",
    "exampleTranslation": "敲门。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 164,
    "word": "frémir",
    "phonetic": "/fremir/",
    "type": "v.i.",
    "translation": "战栗",
    "commonMeanings": [
      "战栗"
    ],
    "example": "Frémir de peur.",
    "exampleTranslation": "因恐惧而发抖。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 165,
    "word": "fuir",
    "phonetic": "/fɥir/",
    "type": "v.t./v.i.",
    "translation": "v.t. 逃避；v.i. 漏，流失",
    "commonMeanings": [
      "逃避",
      "漏"
    ],
    "example": "Fuir la réalité.",
    "exampleTranslation": "逃避现实。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 166,
    "word": "fumer",
    "phonetic": "/fyme/",
    "type": "v.t./v.i.",
    "translation": "v.t. 抽烟；v.i. 冒烟",
    "commonMeanings": [
      "抽烟",
      "冒烟"
    ],
    "example": "Fumer une cigarette.",
    "exampleTranslation": "抽一支烟。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 167,
    "word": "gagner",
    "phonetic": "/ɡaɲe/",
    "type": "v.t.",
    "translation": "赢得；挣钱",
    "commonMeanings": [
      "赢得",
      "挣钱"
    ],
    "example": "Gagner un match.",
    "exampleTranslation": "赢得一场比赛。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 168,
    "word": "garder",
    "phonetic": "/ɡarde/",
    "type": "v.t.",
    "translation": "保持；看守",
    "commonMeanings": [
      "保持",
      "看守"
    ],
    "example": "Garder le silence.",
    "exampleTranslation": "保持沉默。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 169,
    "word": "gaspiller",
    "phonetic": "/ɡaspije/",
    "type": "v.t.",
    "translation": "浪费",
    "commonMeanings": [
      "浪费"
    ],
    "example": "Gaspiller son temps.",
    "exampleTranslation": "浪费时间。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 170,
    "word": "gâter",
    "phonetic": "/ɡate/",
    "type": "v.t.",
    "translation": "宠坏；弄坏",
    "commonMeanings": [
      "宠坏",
      "弄坏"
    ],
    "example": "Gâter un enfant.",
    "exampleTranslation": "溺爱一个孩子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 171,
    "word": "gêner",
    "phonetic": "/ʒene/",
    "type": "v.t.",
    "translation": "妨碍；使尴尬",
    "commonMeanings": [
      "妨碍",
      "使尴尬"
    ],
    "example": "Cela me gêne.",
    "exampleTranslation": "这让我不舒服。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 172,
    "word": "gérer",
    "phonetic": "/ʒere/",
    "type": "v.t.",
    "translation": "管理",
    "commonMeanings": [
      "管理"
    ],
    "example": "Gérer une crise.",
    "exampleTranslation": "处理一场危机。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 173,
    "word": "goûter",
    "phonetic": "/ɡute/",
    "type": "v.t.",
    "translation": "品尝",
    "commonMeanings": [
      "品尝"
    ],
    "example": "Goûter un vin.",
    "exampleTranslation": "品尝一种葡萄酒。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 174,
    "word": "gouverner",
    "phonetic": "/ɡuvɛrne/",
    "type": "v.t.",
    "translation": "统治；治理",
    "commonMeanings": [
      "统治",
      "治理"
    ],
    "example": "Gouverner un pays.",
    "exampleTranslation": "治理一个国家。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 175,
    "word": "grimper",
    "phonetic": "/ɡrɛ̃pe/",
    "type": "v.i.",
    "translation": "攀爬",
    "commonMeanings": [
      "攀爬"
    ],
    "example": "Grimper sur un arbre.",
    "exampleTranslation": "爬上一棵树。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 176,
    "word": "guérir",
    "phonetic": "/ɡerir/",
    "type": "v.t./v.i.",
    "translation": "v.t. 治愈；v.i. 痊愈",
    "commonMeanings": [
      "治愈",
      "痊愈"
    ],
    "example": "Guérir d'une maladie.",
    "exampleTranslation": "从疾病中痊愈。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 177,
    "word": "habiller",
    "phonetic": "/a.bi.je/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 给…穿衣；v.pr. 穿衣，打扮",
    "commonMeanings": [
      "给…穿衣",
      "穿衣",
      "打扮"
    ],
    "example": "Habille-toi vite, on va être en retard !",
    "exampleTranslation": "快点穿衣服，我们要迟到了！",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 178,
    "word": "habiter",
    "phonetic": "/abite/",
    "type": "v.t./v.i.",
    "translation": "v.t. 住在；v.i. 居住",
    "commonMeanings": [
      "居住"
    ],
    "example": "J'habite à Pékin.",
    "exampleTranslation": "我住在北京。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 179,
    "word": "haïr",
    "phonetic": "/air/",
    "type": "v.t.",
    "translation": "仇恨",
    "commonMeanings": [
      "仇恨"
    ],
    "example": "Je hais le mensonge.",
    "exampleTranslation": "我痛恨谎言。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 180,
    "word": "harceler",
    "phonetic": "/arsəle/",
    "type": "v.t.",
    "translation": "纠缠/骚扰",
    "commonMeanings": [
      "纠缠/骚扰"
    ],
    "example": "Harceler un collègue.",
    "exampleTranslation": "骚扰一位同事。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 181,
    "word": "hasarder",
    "phonetic": "/azarde/",
    "type": "v.t.",
    "translation": "冒险",
    "commonMeanings": [
      "冒险"
    ],
    "example": "Hasarder une réponse.",
    "exampleTranslation": "冒昧猜一个答案。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 182,
    "word": "hésiter",
    "phonetic": "/ezite/",
    "type": "v.i.",
    "translation": "犹豫",
    "commonMeanings": [
      "犹豫"
    ],
    "example": "N'hésitez pas à poser des questions.",
    "exampleTranslation": "请随便提问。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 183,
    "word": "honorer",
    "phonetic": "/ɔnɔme/",
    "type": "v.t.",
    "translation": "尊敬/感到光荣",
    "commonMeanings": [
      "尊敬/感到光荣"
    ],
    "example": "Honorer ses parents.",
    "exampleTranslation": "孝敬父母。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 184,
    "word": "humilier",
    "phonetic": "/ymilje/",
    "type": "v.t.",
    "translation": "羞辱",
    "commonMeanings": [
      "羞辱"
    ],
    "example": "Humilier son adversaire.",
    "exampleTranslation": "羞辱对手。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 185,
    "word": "hurler",
    "phonetic": "/yrle/",
    "type": "v.i.",
    "translation": "嚎叫/吼叫",
    "commonMeanings": [
      "嚎叫/吼叫"
    ],
    "example": "Hurler de douleur.",
    "exampleTranslation": "疼得大叫。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 186,
    "word": "identifier",
    "phonetic": "/idɑ̃tifje/",
    "type": "v.t.",
    "translation": "识别/鉴定",
    "commonMeanings": [
      "识别/鉴定"
    ],
    "example": "Identifier un suspect.",
    "exampleTranslation": "指认一名嫌疑人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 187,
    "word": "ignorer",
    "phonetic": "/iɲɔme/",
    "type": "v.t.",
    "translation": "不知道/不理睬",
    "commonMeanings": [
      "不知道/不理睬"
    ],
    "example": "J'ignore son adresse.",
    "exampleTranslation": "我不知道他的地址。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 188,
    "word": "illustrer",
    "phonetic": "/ilystre/",
    "type": "v.t.",
    "translation": "说明/阐述",
    "commonMeanings": [
      "说明/阐述"
    ],
    "example": "Illustrer un propos.",
    "exampleTranslation": "说明一个观点。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 189,
    "word": "imaginer",
    "phonetic": "/imaʒine/",
    "type": "v.t.",
    "translation": "想象",
    "commonMeanings": [
      "想象"
    ],
    "example": "Imaginer une solution.",
    "exampleTranslation": "想出一个解决办法。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 190,
    "word": "imiter",
    "phonetic": "/imite/",
    "type": "v.t.",
    "translation": "模仿",
    "commonMeanings": [
      "模仿"
    ],
    "example": "Imiter un accent.",
    "exampleTranslation": "模仿一种口音。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 191,
    "word": "importer",
    "phonetic": "/ɛ̃.pɔʁ.te/",
    "type": "v.t./v.imp.",
    "translation": "v.t. 进口，输入；v.imp. 重要，有关系",
    "commonMeanings": [
      "进口",
      "重要"
    ],
    "example": "Peu importe le résultat, tu as fait de ton mieux.",
    "exampleTranslation": "结果不重要，你已经尽力了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 192,
    "word": "imposer",
    "phonetic": "/ɛ̃poze/",
    "type": "v.t.",
    "translation": "强加/征税",
    "commonMeanings": [
      "强加/征税"
    ],
    "example": "Imposer sa volonté.",
    "exampleTranslation": "强加自己的意愿。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 193,
    "word": "impressionner",
    "phonetic": "/ɛ̃prɛsjɔne/",
    "type": "v.t.",
    "translation": "给...留下印象",
    "commonMeanings": [
      "给...留下印象"
    ],
    "example": "Ce film m'a impressionné.",
    "exampleTranslation": "这部电影给我留下了深刻印象。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 194,
    "word": "imprimer",
    "phonetic": "/ɛ̃prime/",
    "type": "v.t.",
    "translation": "打印/印染",
    "commonMeanings": [
      "打印/印染"
    ],
    "example": "Imprimer un document.",
    "exampleTranslation": "打印一份文件。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 195,
    "word": "indiquer",
    "phonetic": "/ɛ̃dike/",
    "type": "v.t.",
    "translation": "指出/指示",
    "commonMeanings": [
      "指出/指示"
    ],
    "example": "Indiquer le chemin.",
    "exampleTranslation": "指路。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 196,
    "word": "informer",
    "phonetic": "/ɛ̃fɔrme/",
    "type": "v.t.",
    "translation": "通知/告知",
    "commonMeanings": [
      "通知/告知"
    ],
    "example": "Informer le public.",
    "exampleTranslation": "告知公众。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 197,
    "word": "inquiéter",
    "phonetic": "/ɛ̃kjete/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使担心；v.pr. 担心，焦虑",
    "commonMeanings": [
      "使担心/焦虑"
    ],
    "example": "Cela m'inquiète.",
    "exampleTranslation": "这让我担心。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 198,
    "word": "insister",
    "phonetic": "/ɛ̃siste/",
    "type": "v.i.",
    "translation": "坚持/强调",
    "commonMeanings": [
      "坚持/强调"
    ],
    "example": "Insister sur un point.",
    "exampleTranslation": "强调一点。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 199,
    "word": "installer",
    "phonetic": "/ɛ̃stale/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 安装，安置；v.pr. 安顿，就坐",
    "commonMeanings": [
      "安装/安置"
    ],
    "example": "Installer un logiciel.",
    "exampleTranslation": "安装一个软件。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 200,
    "word": "interdire",
    "phonetic": "/ɛ̃tɛrdir/",
    "type": "v.t.",
    "translation": "禁止",
    "commonMeanings": [
      "禁止"
    ],
    "example": "Interdire de fumer.",
    "exampleTranslation": "禁止吸烟。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 201,
    "word": "intéresser",
    "phonetic": "/ɛ̃terese/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使感兴趣；v.pr. 对…感兴趣",
    "commonMeanings": [
      "使感兴趣"
    ],
    "example": "S'intéresser à l'art.",
    "exampleTranslation": "对艺术感兴趣。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 202,
    "word": "interroger",
    "phonetic": "/ɛ̃.tɛ.ʁɔ.ʒe/",
    "type": "v.t.",
    "translation": "v.t. 询问；审问；提问",
    "commonMeanings": [
      "询问",
      "审问",
      "提问"
    ],
    "example": "Le professeur interroge les élèves un par un.",
    "exampleTranslation": "老师逐个提问学生。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 203,
    "word": "interrompre",
    "phonetic": "/ɛ̃terɔ̃pr/",
    "type": "v.t.",
    "translation": "打断/中断",
    "commonMeanings": [
      "打断/中断"
    ],
    "example": "Interrompre un discours.",
    "exampleTranslation": "打断一场演讲。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 204,
    "word": "inventer",
    "phonetic": "/ɛ̃vɑ̃te/",
    "type": "v.t.",
    "translation": "发明/虚构",
    "commonMeanings": [
      "发明/虚构"
    ],
    "example": "Inventer une machine.",
    "exampleTranslation": "发明一台机器。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 205,
    "word": "inviter",
    "phonetic": "/ɛ̃vite/",
    "type": "v.t.",
    "translation": "邀请",
    "commonMeanings": [
      "邀请"
    ],
    "example": "Inviter des amis.",
    "exampleTranslation": "邀请朋友。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 206,
    "word": "jeter",
    "phonetic": "/ʒəte/",
    "type": "v.t.",
    "translation": "扔/投",
    "commonMeanings": [
      "扔/投"
    ],
    "example": "Jeter un coup d'œil.",
    "exampleTranslation": "瞥一眼。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 207,
    "word": "jouer",
    "phonetic": "/ʒwe/",
    "type": "v.t./v.i.",
    "translation": "v.t. 玩，演奏；v.i. 玩耍",
    "commonMeanings": [
      "玩/演奏"
    ],
    "example": "Jouer du piano.",
    "exampleTranslation": "弹钢琴。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 208,
    "word": "juger",
    "phonetic": "/ʒyʒe/",
    "type": "v.t.",
    "translation": "判断/审判",
    "commonMeanings": [
      "判断/审判"
    ],
    "example": "Juger sur les faits.",
    "exampleTranslation": "根据事实来判断。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 209,
    "word": "laisser",
    "phonetic": "/lɛ.se/",
    "type": "v.t.",
    "translation": "v.t. 留下；让，允许",
    "commonMeanings": [
      "留下",
      "让",
      "允许"
    ],
    "example": "Laissez-moi tranquille, s'il vous plaît.",
    "exampleTranslation": "请让我安静一下。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 210,
    "word": "lancer",
    "phonetic": "/lɑ̃se/",
    "type": "v.t.",
    "translation": "投掷；发动",
    "commonMeanings": [
      "投掷",
      "发动"
    ],
    "example": "Lancer un nouveau produit.",
    "exampleTranslation": "推出一款新产品。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 211,
    "word": "lever",
    "phonetic": "/ləve/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 举起；v.pr. 起床，升起",
    "commonMeanings": [
      "举起",
      "起床"
    ],
    "example": "Le soleil se lève à l'est.",
    "exampleTranslation": "太阳从东边升起。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 212,
    "word": "lier",
    "phonetic": "/lje/",
    "type": "v.t.",
    "translation": "捆绑；联系",
    "commonMeanings": [
      "捆绑",
      "联系"
    ],
    "example": "Lier amitié avec quelqu'un.",
    "exampleTranslation": "与某人结下友谊。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 213,
    "word": "limiter",
    "phonetic": "/limite/",
    "type": "v.t.",
    "translation": "限制",
    "commonMeanings": [
      "限制"
    ],
    "example": "Limiter la vitesse.",
    "exampleTranslation": "限制速度。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 214,
    "word": "lire",
    "phonetic": "/lir/",
    "type": "v.t.",
    "translation": "读",
    "commonMeanings": [
      "读"
    ],
    "example": "Lire un journal.",
    "exampleTranslation": "读一份报纸。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 215,
    "word": "loger",
    "phonetic": "/lɔʒe/",
    "type": "v.t./v.i.",
    "translation": "v.t. 安置住宿；v.i. 住宿",
    "commonMeanings": [
      "住宿",
      "安置"
    ],
    "example": "Loger chez l'habitant.",
    "exampleTranslation": "住在当地居民家里。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 216,
    "word": "louer",
    "phonetic": "/lwe/",
    "type": "v.t.",
    "translation": "租用；称赞",
    "commonMeanings": [
      "租用",
      "称赞"
    ],
    "example": "Louer un appartement.",
    "exampleTranslation": "租一套公寓。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 217,
    "word": "lutter",
    "phonetic": "/lyte/",
    "type": "v.i.",
    "translation": "斗争",
    "commonMeanings": [
      "斗争"
    ],
    "example": "Lutter contre la pauvreté.",
    "exampleTranslation": "与贫困作斗争。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 218,
    "word": "maintenir",
    "phonetic": "/mɛ̃tnir/",
    "type": "v.t.",
    "translation": "维持",
    "commonMeanings": [
      "维持"
    ],
    "example": "Maintenir l'ordre.",
    "exampleTranslation": "维持秩序。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 219,
    "word": "manger",
    "phonetic": "/mɑ̃ʒe/",
    "type": "v.t.",
    "translation": "吃",
    "commonMeanings": [
      "吃"
    ],
    "example": "Manger à sa faim.",
    "exampleTranslation": "吃饱饭。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 220,
    "word": "manquer",
    "phonetic": "/mɑ̃ke/",
    "type": "v.t./v.i.",
    "translation": "v.t. 错过；v.i. 缺少，缺乏",
    "commonMeanings": [
      "错过",
      "缺乏"
    ],
    "example": "Manquer le train.",
    "exampleTranslation": "错过火车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 221,
    "word": "marcher",
    "phonetic": "/marʃe/",
    "type": "v.i.",
    "translation": "行走；运转",
    "commonMeanings": [
      "行走",
      "运转"
    ],
    "example": "Marcher sur le trottoir.",
    "exampleTranslation": "走在人行道上。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 222,
    "word": "marier",
    "phonetic": "/ma.ʁje/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使结婚，嫁，娶；v.pr. 结婚",
    "commonMeanings": [
      "使结婚",
      "结婚"
    ],
    "example": "Ils vont se marier en juin prochain.",
    "exampleTranslation": "他们将在明年六月结婚。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 223,
    "word": "mener",
    "phonetic": "/mne/",
    "type": "v.t.",
    "translation": "引导；带领",
    "commonMeanings": [
      "引导",
      "带领"
    ],
    "example": "Mener une enquête.",
    "exampleTranslation": "进行一项调查。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 224,
    "word": "mentionner",
    "phonetic": "/mɑ̃sjɔne/",
    "type": "v.t.",
    "translation": "提到",
    "commonMeanings": [
      "提到"
    ],
    "example": "Mentionner un nom.",
    "exampleTranslation": "提到一个名字。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 225,
    "word": "mentir",
    "phonetic": "/mɑ̃tir/",
    "type": "v.i.",
    "translation": "撒谎",
    "commonMeanings": [
      "撒谎"
    ],
    "example": "Mentir à ses parents.",
    "exampleTranslation": "对父母撒谎。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 226,
    "word": "mériter",
    "phonetic": "/merite/",
    "type": "v.t.",
    "translation": "值得",
    "commonMeanings": [
      "值得"
    ],
    "example": "Il mérite cette récompense.",
    "exampleTranslation": "他值得这份奖赏。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 227,
    "word": "mesurer",
    "phonetic": "/məzyre/",
    "type": "v.t.",
    "translation": "测量",
    "commonMeanings": [
      "测量"
    ],
    "example": "Mesurer la distance.",
    "exampleTranslation": "测量距离。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 228,
    "word": "mettre",
    "phonetic": "/mɛtr/",
    "type": "v.t.",
    "translation": "放；穿",
    "commonMeanings": [
      "放",
      "穿"
    ],
    "example": "Mettre la table.",
    "exampleTranslation": "摆餐具。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 229,
    "word": "monter",
    "phonetic": "/mɔ̃te/",
    "type": "v.i./v.t.",
    "translation": "v.i. 上升，登上；v.t. 搬上，组装",
    "commonMeanings": [
      "上升",
      "登上"
    ],
    "example": "Monter dans l'avion.",
    "exampleTranslation": "登上飞机。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 230,
    "word": "montrer",
    "phonetic": "/mɔ̃tre/",
    "type": "v.t.",
    "translation": "出示；显示",
    "commonMeanings": [
      "出示",
      "显示"
    ],
    "example": "Montrer son passeport.",
    "exampleTranslation": "出示护照。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 231,
    "word": "mourir",
    "phonetic": "/murir/",
    "type": "v.i.",
    "translation": "死亡",
    "commonMeanings": [
      "死亡"
    ],
    "example": "Mourir de rire.",
    "exampleTranslation": "笑死了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 232,
    "word": "multiplier",
    "phonetic": "/myltiplije/",
    "type": "v.t.",
    "translation": "增加；乘",
    "commonMeanings": [
      "增加",
      "乘"
    ],
    "example": "Multiplier les efforts.",
    "exampleTranslation": "加倍努力。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 233,
    "word": "naître",
    "phonetic": "/nɛtr/",
    "type": "v.i.",
    "translation": "出生",
    "commonMeanings": [
      "出生"
    ],
    "example": "Naître en France.",
    "exampleTranslation": "出生在法国。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 234,
    "word": "naviguer",
    "phonetic": "/naviɡe/",
    "type": "v.i.",
    "translation": "航行",
    "commonMeanings": [
      "航行"
    ],
    "example": "Naviguer sur Internet.",
    "exampleTranslation": "上网浏览。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 235,
    "word": "négliger",
    "phonetic": "/neɡliʒe/",
    "type": "v.t.",
    "translation": "疏忽",
    "commonMeanings": [
      "疏忽"
    ],
    "example": "Négliger son travail.",
    "exampleTranslation": "忽视工作。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 236,
    "word": "négocier",
    "phonetic": "/neɡɔsje/",
    "type": "v.t.",
    "translation": "谈判",
    "commonMeanings": [
      "谈判"
    ],
    "example": "Négocier un contrat.",
    "exampleTranslation": "洽谈一份合同。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 237,
    "word": "nettoyer",
    "phonetic": "/netwajje/",
    "type": "v.t.",
    "translation": "打扫",
    "commonMeanings": [
      "打扫"
    ],
    "example": "Nettoyer la cuisine.",
    "exampleTranslation": "打扫厨房。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 238,
    "word": "nommer",
    "phonetic": "/nɔme/",
    "type": "v.t.",
    "translation": "命名；任命",
    "commonMeanings": [
      "命名",
      "任命"
    ],
    "example": "Nommer un directeur.",
    "exampleTranslation": "任命一位主任。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 239,
    "word": "noter",
    "phonetic": "/nɔte/",
    "type": "v.t.",
    "translation": "记录；打分",
    "commonMeanings": [
      "记录",
      "打分"
    ],
    "example": "Noter une adresse.",
    "exampleTranslation": "记下一个地址。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 240,
    "word": "nourrir",
    "phonetic": "/nurir/",
    "type": "v.t.",
    "translation": "喂养；养育",
    "commonMeanings": [
      "喂养",
      "养育"
    ],
    "example": "Nourrir un animal.",
    "exampleTranslation": "喂养一只动物。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 241,
    "word": "nuire",
    "phonetic": "/nɥir/",
    "type": "v.t.indir.",
    "translation": "损害",
    "commonMeanings": [
      "损害"
    ],
    "example": "Cela nuit à la santé.",
    "exampleTranslation": "这对健康有害。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 242,
    "word": "obéir",
    "phonetic": "/ɔbeir/",
    "type": "v.t.indir.",
    "translation": "服从",
    "commonMeanings": [
      "服从"
    ],
    "example": "Obéir aux ordres.",
    "exampleTranslation": "服从命令。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 243,
    "word": "obliger",
    "phonetic": "/ɔbliʒe/",
    "type": "v.t.",
    "translation": "强迫",
    "commonMeanings": [
      "强迫"
    ],
    "example": "Obliger quelqu'un à partir.",
    "exampleTranslation": "强迫某人离开。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 244,
    "word": "observer",
    "phonetic": "/ɔbsɛrve/",
    "type": "v.t.",
    "translation": "观察；遵守",
    "commonMeanings": [
      "观察",
      "遵守"
    ],
    "example": "Observer les oiseaux.",
    "exampleTranslation": "观察鸟类。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 245,
    "word": "obtenir",
    "phonetic": "/ɔptənir/",
    "type": "v.t.",
    "translation": "获得",
    "commonMeanings": [
      "获得"
    ],
    "example": "Obtenir un diplôme.",
    "exampleTranslation": "获得一个文凭。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 246,
    "word": "occuper",
    "phonetic": "/ɔkype/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 占用，占据；v.pr. 照看，忙于",
    "commonMeanings": [
      "占用",
      "照看"
    ],
    "example": "S'occuper des enfants.",
    "exampleTranslation": "照看孩子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 247,
    "word": "offrir",
    "phonetic": "/ɔfrir/",
    "type": "v.t.",
    "translation": "提供；赠送",
    "commonMeanings": [
      "提供",
      "赠送"
    ],
    "example": "Offrir un cadeau.",
    "exampleTranslation": "赠送一份礼物。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 248,
    "word": "organiser",
    "phonetic": "/ɔʁ.ɡa.ni.ze/",
    "type": "v.t.",
    "translation": "v.t. 组织，安排，筹划",
    "commonMeanings": [
      "组织",
      "安排",
      "筹划"
    ],
    "example": "Qui organise cette fête ?",
    "exampleTranslation": "谁组织的这次聚会？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 249,
    "word": "oser",
    "phonetic": "/oze/",
    "type": "v.t.",
    "translation": "敢于",
    "commonMeanings": [
      "敢于"
    ],
    "example": "Il n'ose pas parler.",
    "exampleTranslation": "他不敢说话。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 250,
    "word": "oublier",
    "phonetic": "/ublije/",
    "type": "v.t.",
    "translation": "忘记",
    "commonMeanings": [
      "忘记"
    ],
    "example": "J'ai oublié mon sac.",
    "exampleTranslation": "我忘了我的包。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 251,
    "word": "ouvrir",
    "phonetic": "/uvrir/",
    "type": "v.t.",
    "translation": "打开",
    "commonMeanings": [
      "打开"
    ],
    "example": "Ouvrir la fenêtre.",
    "exampleTranslation": "打开窗户。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 252,
    "word": "paraître",
    "phonetic": "/parɛtr/",
    "type": "v.i.",
    "translation": "显得；出版",
    "commonMeanings": [
      "显得",
      "出版"
    ],
    "example": "Il paraît fatigué.",
    "exampleTranslation": "他看起来疲倦。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 253,
    "word": "parcourir",
    "phonetic": "/parkurir/",
    "type": "v.t.",
    "translation": "遍经；浏览",
    "commonMeanings": [
      "遍经",
      "浏览"
    ],
    "example": "Parcourir le monde.",
    "exampleTranslation": "环游世界。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 254,
    "word": "pardonner",
    "phonetic": "/pardɔne/",
    "type": "v.t.",
    "translation": "原谅",
    "commonMeanings": [
      "原谅"
    ],
    "example": "Pardonner une faute.",
    "exampleTranslation": "原谅一个错误。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 255,
    "word": "parler",
    "phonetic": "/paʁ.le/",
    "type": "v.i./v.t.",
    "translation": "v.i. 说话，讲话；v.t. 说（某种语言）",
    "commonMeanings": [
      "说话",
      "讲话",
      "说（语言）"
    ],
    "example": "Parlez-vous français ?",
    "exampleTranslation": "您说法语吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 256,
    "word": "partager",
    "phonetic": "/partaʒe/",
    "type": "v.t.",
    "translation": "分享；瓜分",
    "commonMeanings": [
      "分享",
      "瓜分"
    ],
    "example": "Partager un repas.",
    "exampleTranslation": "分享一顿饭。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 257,
    "word": "participer",
    "phonetic": "/partisipe/",
    "type": "v.t.indir.",
    "translation": "参加",
    "commonMeanings": [
      "参加"
    ],
    "example": "Participer à une réunion.",
    "exampleTranslation": "参加一次会议。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 258,
    "word": "partir",
    "phonetic": "/partir/",
    "type": "v.i.",
    "translation": "出发",
    "commonMeanings": [
      "出发"
    ],
    "example": "Partir en vacances.",
    "exampleTranslation": "去度假。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 259,
    "word": "parvenir",
    "phonetic": "/parvənir/",
    "type": "v.t.indir.",
    "translation": "到达；成功",
    "commonMeanings": [
      "到达",
      "成功"
    ],
    "example": "Parvenir à son but.",
    "exampleTranslation": "达到目的。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 260,
    "word": "passer",
    "phonetic": "/pase/",
    "type": "v.t./v.i.",
    "translation": "v.t. 经过，度过；v.i. 通过，路过",
    "commonMeanings": [
      "经过",
      "度过"
    ],
    "example": "Passer un examen.",
    "exampleTranslation": "参加一场考试。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 261,
    "word": "passionner",
    "phonetic": "/pasjɔne/",
    "type": "v.t.",
    "translation": "使入迷",
    "commonMeanings": [
      "使入迷"
    ],
    "example": "Ce sujet me passionne.",
    "exampleTranslation": "这个主题让我着迷。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 262,
    "word": "payer",
    "phonetic": "/peje/",
    "type": "v.t.",
    "translation": "支付",
    "commonMeanings": [
      "支付"
    ],
    "example": "Payer la facture.",
    "exampleTranslation": "付账单。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 263,
    "word": "pêcher",
    "phonetic": "/pɛʃe/",
    "type": "v.t./v.i.",
    "translation": "v.t. 钓（鱼）；v.i. 钓鱼",
    "commonMeanings": [
      "钓鱼"
    ],
    "example": "Aller pêcher le dimanche.",
    "exampleTranslation": "周日去钓鱼。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 264,
    "word": "peindre",
    "phonetic": "/pɛ̃dr/",
    "type": "v.t.",
    "translation": "绘画",
    "commonMeanings": [
      "绘画"
    ],
    "example": "Peindre un tableau.",
    "exampleTranslation": "画一幅画。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 265,
    "word": "pénétrer",
    "phonetic": "/penetre/",
    "type": "v.t./v.i.",
    "translation": "v.t. 渗入；v.i. 进入",
    "commonMeanings": [
      "进入",
      "渗入"
    ],
    "example": "Pénétrer dans la salle.",
    "exampleTranslation": "进入大厅。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 266,
    "word": "penser",
    "phonetic": "/pɑ̃se/",
    "type": "v.t./v.i.",
    "translation": "v.t. 想，认为；v.i. 想，思考",
    "commonMeanings": [
      "想",
      "认为"
    ],
    "example": "Je pense à toi.",
    "exampleTranslation": "我想你。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 267,
    "word": "perdre",
    "phonetic": "/pɛrdr/",
    "type": "v.t.",
    "translation": "丢失；输",
    "commonMeanings": [
      "丢失",
      "输"
    ],
    "example": "Perdre ses clés.",
    "exampleTranslation": "丢了钥匙。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 268,
    "word": "permettre",
    "phonetic": "/pɛrmɛtr/",
    "type": "v.t.",
    "translation": "允许",
    "commonMeanings": [
      "允许"
    ],
    "example": "Permettre de sortir.",
    "exampleTranslation": "允许外出。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 269,
    "word": "persuader",
    "phonetic": "/pɛrsɥade/",
    "type": "v.t.",
    "translation": "说服",
    "commonMeanings": [
      "说服"
    ],
    "example": "Persuader un client.",
    "exampleTranslation": "说服一位客户。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 270,
    "word": "peser",
    "phonetic": "/pəze/",
    "type": "v.t./v.i.",
    "translation": "v.t. 称重；v.i. 重量为",
    "commonMeanings": [
      "称重",
      "重量为"
    ],
    "example": "Peser ses bagages.",
    "exampleTranslation": "称行李重量。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 271,
    "word": "placer",
    "phonetic": "/plase/",
    "type": "v.t.",
    "translation": "放置；安置",
    "commonMeanings": [
      "放置",
      "安置"
    ],
    "example": "Placer son argent.",
    "exampleTranslation": "投资。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 272,
    "word": "plaindre",
    "phonetic": "/plɛ̃dr/",
    "type": "v.t.",
    "translation": "可怜；怜悯",
    "commonMeanings": [
      "可怜",
      "怜悯"
    ],
    "example": "Je plains ces pauvres gens.",
    "exampleTranslation": "我同情这些可怜的人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 273,
    "word": "plaire",
    "phonetic": "/plɛr/",
    "type": "v.t.indir.",
    "translation": "使喜欢",
    "commonMeanings": [
      "使喜欢"
    ],
    "example": "Ce film me plaît beaucoup.",
    "exampleTranslation": "我很喜欢这部电影。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 274,
    "word": "plaisanter",
    "phonetic": "/plɛzɑ̃te/",
    "type": "v.i.",
    "translation": "开玩笑",
    "commonMeanings": [
      "开玩笑"
    ],
    "example": "Tu plaisantes, j'espère ?",
    "exampleTranslation": "你是在开玩笑吧？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 275,
    "word": "pleurer",
    "phonetic": "/plœme/",
    "type": "v.i./v.t.",
    "translation": "哭",
    "commonMeanings": [
      "哭"
    ],
    "example": "L'enfant pleure son jouet.",
    "exampleTranslation": "孩子为他的玩具而哭。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 276,
    "word": "pleuvoir",
    "phonetic": "/plœvwar/",
    "type": "v.imp.",
    "translation": "下雨",
    "commonMeanings": [
      "下雨"
    ],
    "example": "Il pleut à verse.",
    "exampleTranslation": "下着倾盆大雨。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 277,
    "word": "plier",
    "phonetic": "/plije/",
    "type": "v.t.",
    "translation": "折叠；弯曲",
    "commonMeanings": [
      "折叠",
      "弯曲"
    ],
    "example": "Plier ses vêtements.",
    "exampleTranslation": "叠衣服。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 278,
    "word": "plonger",
    "phonetic": "/plɔ̃ʒe/",
    "type": "v.i./v.t.",
    "translation": "v.i. 潜水；v.t. 浸入",
    "commonMeanings": [
      "潜水",
      "浸入"
    ],
    "example": "Plonger dans la piscine.",
    "exampleTranslation": "跳进游泳池。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 279,
    "word": "porter",
    "phonetic": "/pɔrte/",
    "type": "v.t.",
    "translation": "拿；穿；带着",
    "commonMeanings": [
      "拿",
      "穿",
      "带着"
    ],
    "example": "Porter une valise.",
    "exampleTranslation": "提一个手提箱。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 280,
    "word": "poser",
    "phonetic": "/poze/",
    "type": "v.t.",
    "translation": "放置；提出",
    "commonMeanings": [
      "放置",
      "提出"
    ],
    "example": "Poser une question.",
    "exampleTranslation": "提一个问题。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 281,
    "word": "posséder",
    "phonetic": "/pɔsede/",
    "type": "v.t.",
    "translation": "拥有",
    "commonMeanings": [
      "拥有"
    ],
    "example": "Il possède une grande fortune.",
    "exampleTranslation": "他拥有一大笔财富。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 282,
    "word": "pousser",
    "phonetic": "/puse/",
    "type": "v.t./v.i.",
    "translation": "v.t. 推；v.i. 生长",
    "commonMeanings": [
      "推",
      "生长"
    ],
    "example": "Pousser la porte.",
    "exampleTranslation": "推门。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 283,
    "word": "pouvoir",
    "phonetic": "/puvwar/",
    "type": "v.mod.",
    "translation": "能够",
    "commonMeanings": [
      "能够"
    ],
    "example": "Je peux vous aider.",
    "exampleTranslation": "我可以帮您。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 284,
    "word": "pratiquer",
    "phonetic": "/pratike/",
    "type": "v.t.",
    "translation": "实践；从事",
    "commonMeanings": [
      "实践",
      "从事"
    ],
    "example": "Pratiquer un sport.",
    "exampleTranslation": "进行一项体育活动。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 285,
    "word": "préférer",
    "phonetic": "/prefere/",
    "type": "v.t.",
    "translation": "更喜欢",
    "commonMeanings": [
      "更喜欢"
    ],
    "example": "Je préfère le café.",
    "exampleTranslation": "我更喜欢咖啡。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 286,
    "word": "prendre",
    "phonetic": "/prɑ̃dr/",
    "type": "v.t.",
    "translation": "拿；吃；乘车",
    "commonMeanings": [
      "拿",
      "吃",
      "乘车"
    ],
    "example": "Prendre le métro.",
    "exampleTranslation": "乘地铁。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 287,
    "word": "préparer",
    "phonetic": "/prepare/",
    "type": "v.t.",
    "translation": "准备",
    "commonMeanings": [
      "准备"
    ],
    "example": "Préparer le dîner.",
    "exampleTranslation": "准备晚餐。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 288,
    "word": "présenter",
    "phonetic": "/prezɑ̃te/",
    "type": "v.t.",
    "translation": "介绍；呈现",
    "commonMeanings": [
      "介绍",
      "呈现"
    ],
    "example": "Présenter ses excuses.",
    "exampleTranslation": "道歉。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 289,
    "word": "préserver",
    "phonetic": "/prezɛrve/",
    "type": "v.t.",
    "translation": "保护；保存",
    "commonMeanings": [
      "保护",
      "保存"
    ],
    "example": "Préserver l'environnement.",
    "exampleTranslation": "保护环境。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 290,
    "word": "prévenir",
    "phonetic": "/prevnir/",
    "type": "v.t.",
    "translation": "预防；通知",
    "commonMeanings": [
      "预防",
      "通知"
    ],
    "example": "Prévenir la police.",
    "exampleTranslation": "通知警方。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 291,
    "word": "prévoir",
    "phonetic": "/prevwar/",
    "type": "v.t.",
    "translation": "预见；准备",
    "commonMeanings": [
      "预见",
      "准备"
    ],
    "example": "Prévoir le temps.",
    "exampleTranslation": "预测天气。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 292,
    "word": "prier",
    "phonetic": "/prije/",
    "type": "v.t.",
    "translation": "请求；祈祷",
    "commonMeanings": [
      "请求",
      "祈祷"
    ],
    "example": "Je vous prie de m'écouter.",
    "exampleTranslation": "请听我说。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 293,
    "word": "produire",
    "phonetic": "/prɔdɥir/",
    "type": "v.t.",
    "translation": "生产；产生",
    "commonMeanings": [
      "生产",
      "产生"
    ],
    "example": "Produire de l'énergie.",
    "exampleTranslation": "生产能源。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 294,
    "word": "profiter",
    "phonetic": "/prɔfite/",
    "type": "v.t.indir.",
    "translation": "利用；受益",
    "commonMeanings": [
      "利用",
      "受益"
    ],
    "example": "Profiter des vacances.",
    "exampleTranslation": "享受假期。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 295,
    "word": "projeter",
    "phonetic": "/prɔʒte/",
    "type": "v.t.",
    "translation": "投影；计划",
    "commonMeanings": [
      "投影",
      "计划"
    ],
    "example": "Projeter un film.",
    "exampleTranslation": "放映一部电影。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 296,
    "word": "promener",
    "phonetic": "/pʁɔm.ne/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使散步，遛（动物）；v.pr. 散步",
    "commonMeanings": [
      "散步",
      "遛"
    ],
    "example": "Je vais promener mon chien dans le parc.",
    "exampleTranslation": "我去公园遛狗。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 297,
    "word": "promettre",
    "phonetic": "/prɔmɛtr/",
    "type": "v.t.",
    "translation": "答应；承诺",
    "commonMeanings": [
      "答应",
      "承诺"
    ],
    "example": "Promettre de venir.",
    "exampleTranslation": "承诺会来。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 298,
    "word": "proposer",
    "phonetic": "/prɔpoze/",
    "type": "v.t.",
    "translation": "建议；提议",
    "commonMeanings": [
      "建议",
      "提议"
    ],
    "example": "Proposer une idée.",
    "exampleTranslation": "提一个建议。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 299,
    "word": "protéger",
    "phonetic": "/prɔteʒe/",
    "type": "v.t.",
    "translation": "保护",
    "commonMeanings": [
      "保护"
    ],
    "example": "Protéger la nature.",
    "exampleTranslation": "保护大自然。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 300,
    "word": "prouver",
    "phonetic": "/pruve/",
    "type": "v.t.",
    "translation": "证明",
    "commonMeanings": [
      "证明"
    ],
    "example": "Prouver son innocence.",
    "exampleTranslation": "证明自己的清白。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 301,
    "word": "publier",
    "phonetic": "/pyblije/",
    "type": "v.t.",
    "translation": "出版；公布",
    "commonMeanings": [
      "出版",
      "公布"
    ],
    "example": "Publier un article.",
    "exampleTranslation": "发表一篇文章。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 302,
    "word": "quitter",
    "phonetic": "/kite/",
    "type": "v.t.",
    "translation": "离开；放弃",
    "commonMeanings": [
      "离开",
      "放弃"
    ],
    "example": "Il a quitté la ville.",
    "exampleTranslation": "他离开了这座城市。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 303,
    "word": "raconter",
    "phonetic": "/rakɔ̃te/",
    "type": "v.t.",
    "translation": "讲述",
    "commonMeanings": [
      "讲述"
    ],
    "example": "Raconter une histoire.",
    "exampleTranslation": "讲一个故事。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 304,
    "word": "ralentir",
    "phonetic": "/ralɑ̃tir/",
    "type": "v.t./v.i.",
    "translation": "v.t. 放慢；v.i. 减速",
    "commonMeanings": [
      "放慢"
    ],
    "example": "Ralentir à l'approche d'un virage.",
    "exampleTranslation": "在接近弯道时减速。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 305,
    "word": "ramasser",
    "phonetic": "/ramase/",
    "type": "v.t.",
    "translation": "拾起；收集",
    "commonMeanings": [
      "拾起",
      "收集"
    ],
    "example": "Ramasser les copies.",
    "exampleTranslation": "收卷子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 306,
    "word": "ramener",
    "phonetic": "/ramne/",
    "type": "v.t.",
    "translation": "再带回来",
    "commonMeanings": [
      "再带回来"
    ],
    "example": "Ramener un ami chez lui.",
    "exampleTranslation": "送一个朋友回家。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 307,
    "word": "ranger",
    "phonetic": "/rɑ̃ʒe/",
    "type": "v.t.",
    "translation": "整理；排列",
    "commonMeanings": [
      "整理",
      "排列"
    ],
    "example": "Ranger sa chambre.",
    "exampleTranslation": "整理房间。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 308,
    "word": "rappeler",
    "phonetic": "/raple/",
    "type": "v.t.",
    "translation": "再叫；使想起",
    "commonMeanings": [
      "再叫",
      "使想起"
    ],
    "example": "Rappeler quelqu'un au téléphone.",
    "exampleTranslation": "回电话给某人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 309,
    "word": "rassembler",
    "phonetic": "/rasɑ̃ble/",
    "type": "v.t.",
    "translation": "召集；聚集",
    "commonMeanings": [
      "召集",
      "聚集"
    ],
    "example": "Rassembler des documents.",
    "exampleTranslation": "收集文件。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 310,
    "word": "rassurer",
    "phonetic": "/rasyre/",
    "type": "v.t.",
    "translation": "使放心",
    "commonMeanings": [
      "使放心"
    ],
    "example": "Rassurer un enfant.",
    "exampleTranslation": "安抚一个孩子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 311,
    "word": "rater",
    "phonetic": "/rate/",
    "type": "v.t.",
    "translation": "错过；失败",
    "commonMeanings": [
      "错过",
      "失败"
    ],
    "example": "Rater son train.",
    "exampleTranslation": "错过火车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 312,
    "word": "réagir",
    "phonetic": "/reaʒir/",
    "type": "v.i.",
    "translation": "反应",
    "commonMeanings": [
      "反应"
    ],
    "example": "Réagir avec calme.",
    "exampleTranslation": "冷静地反应。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 313,
    "word": "réaliser",
    "phonetic": "/realize/",
    "type": "v.t.",
    "translation": "实现；制作",
    "commonMeanings": [
      "实现",
      "制作"
    ],
    "example": "Réaliser un projet.",
    "exampleTranslation": "实现一个项目。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 314,
    "word": "recevoir",
    "phonetic": "/rəsəvwar/",
    "type": "v.t.",
    "translation": "收到；接待",
    "commonMeanings": [
      "收到",
      "接待"
    ],
    "example": "Recevoir une lettre.",
    "exampleTranslation": "收到一封信。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 315,
    "word": "réchauffer",
    "phonetic": "/reʃofe/",
    "type": "v.t.",
    "translation": "使变热",
    "commonMeanings": [
      "使变热"
    ],
    "example": "Réchauffer le plat.",
    "exampleTranslation": "加热菜。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 316,
    "word": "rechercher",
    "phonetic": "/rəʃɛrʃe/",
    "type": "v.t.",
    "translation": "寻找；研究",
    "commonMeanings": [
      "寻找",
      "研究"
    ],
    "example": "Rechercher la vérité.",
    "exampleTranslation": "追寻真相。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 317,
    "word": "réclamer",
    "phonetic": "/reklame/",
    "type": "v.t.",
    "translation": "要求；抗议",
    "commonMeanings": [
      "要求",
      "抗议"
    ],
    "example": "Réclamer justice.",
    "exampleTranslation": "要求正义。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 318,
    "word": "récolter",
    "phonetic": "/rekɔlte/",
    "type": "v.t.",
    "translation": "收割；收获",
    "commonMeanings": [
      "收割",
      "收获"
    ],
    "example": "Récolter le blé.",
    "exampleTranslation": "收割小麦。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 319,
    "word": "recommander",
    "phonetic": "/rəkɔmɑ̃de/",
    "type": "v.t.",
    "translation": "推荐；建议",
    "commonMeanings": [
      "推荐",
      "建议"
    ],
    "example": "Recommander un restaurant.",
    "exampleTranslation": "推荐一家餐厅。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 320,
    "word": "recommencer",
    "phonetic": "/rəkɔmɑ̃se/",
    "type": "v.t.",
    "translation": "重新开始",
    "commonMeanings": [
      "重新开始"
    ],
    "example": "Recommencer à zéro.",
    "exampleTranslation": "从零重新开始。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 321,
    "word": "reconnaître",
    "phonetic": "/rəkɔnɛtr/",
    "type": "v.t.",
    "translation": "认出；承认",
    "commonMeanings": [
      "认出",
      "承认"
    ],
    "example": "Reconnaître un ami.",
    "exampleTranslation": "认出一个朋友。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 322,
    "word": "récupérer",
    "phonetic": "/rekypere/",
    "type": "v.t.",
    "translation": "恢复；取回",
    "commonMeanings": [
      "恢复",
      "取回"
    ],
    "example": "Récupérer ses forces.",
    "exampleTranslation": "恢复体力。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 323,
    "word": "rédiger",
    "phonetic": "/rediʒe/",
    "type": "v.t.",
    "translation": "拟定；撰写",
    "commonMeanings": [
      "拟定",
      "撰写"
    ],
    "example": "Rédiger un rapport.",
    "exampleTranslation": "撰写一份报告。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 324,
    "word": "réduire",
    "phonetic": "/redɥir/",
    "type": "v.t.",
    "translation": "减少",
    "commonMeanings": [
      "减少"
    ],
    "example": "Réduire les dépenses.",
    "exampleTranslation": "减少开支。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 325,
    "word": "réfléchir",
    "phonetic": "/refleʃir/",
    "type": "v.t.indir./v.i.",
    "translation": "思考；反射",
    "commonMeanings": [
      "思考",
      "反射"
    ],
    "example": "Réfléchir avant d'agir.",
    "exampleTranslation": "三思而后行。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 326,
    "word": "refuser",
    "phonetic": "/rəfyze/",
    "type": "v.t.",
    "translation": "拒绝",
    "commonMeanings": [
      "拒绝"
    ],
    "example": "Refuser une invitation.",
    "exampleTranslation": "拒绝一项邀请。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 327,
    "word": "regarder",
    "phonetic": "/rəɡarde/",
    "type": "v.t.",
    "translation": "看；注视",
    "commonMeanings": [
      "看",
      "注视"
    ],
    "example": "Regarder la télévision.",
    "exampleTranslation": "看电视。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 328,
    "word": "regretter",
    "phonetic": "/rəɡrɛte/",
    "type": "v.t.",
    "translation": "后悔；怀念",
    "commonMeanings": [
      "后悔",
      "怀念"
    ],
    "example": "Regretter ses erreurs.",
    "exampleTranslation": "为自己的错误后悔。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 329,
    "word": "rejeter",
    "phonetic": "/rəʒte/",
    "type": "v.t.",
    "translation": "拒绝；抛弃",
    "commonMeanings": [
      "拒绝",
      "抛弃"
    ],
    "example": "Rejeter une proposition.",
    "exampleTranslation": "拒绝一个建议。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 330,
    "word": "remarquer",
    "phonetic": "/ʁə.maʁ.ke/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 注意到，指出；v.pr. 引人注目",
    "commonMeanings": [
      "注意到",
      "指出",
      "引人注目"
    ],
    "example": "As-tu remarqué son nouveau manteau ?",
    "exampleTranslation": "你注意到她的新大衣了吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 331,
    "word": "remercier",
    "phonetic": "/ʁə.mɛʁ.sje/",
    "type": "v.t.",
    "translation": "v.t. 感谢，道谢；解雇",
    "commonMeanings": [
      "感谢",
      "道谢"
    ],
    "example": "Je vous remercie de votre aide précieuse.",
    "exampleTranslation": "感谢您的宝贵帮助。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 332,
    "word": "remettre",
    "phonetic": "/ʁə.mɛtʁ/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 放回，移交，推迟；v.pr. 恢复",
    "commonMeanings": [
      "放回",
      "移交",
      "推迟"
    ],
    "example": "La réunion est remise à la semaine prochaine.",
    "exampleTranslation": "会议推迟到下周。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 333,
    "word": "rencontrer",
    "phonetic": "/ʁɑ̃.kɔ̃.tʁe/",
    "type": "v.t.",
    "translation": "v.t. 遇见，碰见；结识",
    "commonMeanings": [
      "遇见",
      "碰见",
      "结识"
    ],
    "example": "J'ai rencontré Paul par hasard dans la rue.",
    "exampleTranslation": "我在街上偶然碰见了Paul。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 334,
    "word": "rendre",
    "phonetic": "/ʁɑ̃dʁ/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 归还；使变得；v.pr. 前往",
    "commonMeanings": [
      "归还",
      "使变得",
      "前往"
    ],
    "example": "Tu dois rendre ce livre à la bibliothèque.",
    "exampleTranslation": "你应该把这本书还给图书馆。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 335,
    "word": "rentrer",
    "phonetic": "/ʁɑ̃.tʁe/",
    "type": "v.i./v.t.",
    "translation": "v.i. 回来，回家；v.t. 收进，放回",
    "commonMeanings": [
      "回来",
      "回家",
      "收进"
    ],
    "example": "À quelle heure rentres-tu du travail ?",
    "exampleTranslation": "你几点下班回家？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 336,
    "word": "répéter",
    "phonetic": "/repete/",
    "type": "v.t.",
    "translation": "重复；排练",
    "commonMeanings": [
      "重复",
      "排练"
    ],
    "example": "Répéter une leçon.",
    "exampleTranslation": "复习一课。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 337,
    "word": "répondre",
    "phonetic": "/repɔ̃dr/",
    "type": "v.t.indir.",
    "translation": "回答",
    "commonMeanings": [
      "回答"
    ],
    "example": "Répondre à une question.",
    "exampleTranslation": "回答一个问题。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 338,
    "word": "reposer",
    "phonetic": "/rəpoze/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 使休息；v.pr. 休息",
    "commonMeanings": [
      "休息",
      "安放"
    ],
    "example": "Se reposer après le travail.",
    "exampleTranslation": "下班后休息。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 339,
    "word": "reprendre",
    "phonetic": "/rəprɑ̃dr/",
    "type": "v.t.",
    "translation": "重新开始；取回",
    "commonMeanings": [
      "重新开始",
      "取回"
    ],
    "example": "Reprendre ses études.",
    "exampleTranslation": "重新复学。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 340,
    "word": "représenter",
    "phonetic": "/rəprezɑ̃te/",
    "type": "v.t.",
    "translation": "代表；表现",
    "commonMeanings": [
      "代表",
      "表现"
    ],
    "example": "Représenter un pays.",
    "exampleTranslation": "代表一个国家。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 341,
    "word": "reprocher",
    "phonetic": "/rəprɔʃe/",
    "type": "v.t.",
    "translation": "责备",
    "commonMeanings": [
      "责备"
    ],
    "example": "Reprocher une faute à qqn.",
    "exampleTranslation": "责备某人的一个错误。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 342,
    "word": "résoudre",
    "phonetic": "/rezudr/",
    "type": "v.t.",
    "translation": "解决",
    "commonMeanings": [
      "解决"
    ],
    "example": "Résoudre un problème.",
    "exampleTranslation": "解决一个问题。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 343,
    "word": "respecter",
    "phonetic": "/rɛspɛkte/",
    "type": "v.t.",
    "translation": "尊重",
    "commonMeanings": [
      "尊重"
    ],
    "example": "Respecter la loi.",
    "exampleTranslation": "遵守法律。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 344,
    "word": "ressembler",
    "phonetic": "/rəsɑ̃ble/",
    "type": "v.t.indir.",
    "translation": "相像",
    "commonMeanings": [
      "相像"
    ],
    "example": "Il ressemble à son père.",
    "exampleTranslation": "他长得像他爸爸。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 345,
    "word": "ressentir",
    "phonetic": "/rəsɑ̃tir/",
    "type": "v.t.",
    "translation": "感觉到",
    "commonMeanings": [
      "感觉到"
    ],
    "example": "Ressentir de la joie.",
    "exampleTranslation": "感到快乐。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 346,
    "word": "rester",
    "phonetic": "/rɛste/",
    "type": "v.i.",
    "translation": "停留；保持",
    "commonMeanings": [
      "停留",
      "保持"
    ],
    "example": "Rester à la maison.",
    "exampleTranslation": "呆在家里。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 347,
    "word": "retenir",
    "phonetic": "/rətnir/",
    "type": "v.t.",
    "translation": "留住；记住",
    "commonMeanings": [
      "留住",
      "记住"
    ],
    "example": "Retenir une leçon.",
    "exampleTranslation": "记住一课。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 348,
    "word": "retirer",
    "phonetic": "/rətire/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 撤回，提取；v.pr. 退下，离开",
    "commonMeanings": [
      "撤回",
      "提取"
    ],
    "example": "Retirer de l'argent.",
    "exampleTranslation": "取钱。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 349,
    "word": "retourner",
    "phonetic": "/rəturne/",
    "type": "v.i./v.t.",
    "translation": "v.i. 返回；v.t. 翻转",
    "commonMeanings": [
      "返回",
      "翻转"
    ],
    "example": "Retourner au bureau.",
    "exampleTranslation": "回办公室。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 350,
    "word": "retrouver",
    "phonetic": "/rətruve/",
    "type": "v.t.",
    "translation": "找回；重逢",
    "commonMeanings": [
      "找回",
      "重逢"
    ],
    "example": "Retrouver ses clés.",
    "exampleTranslation": "找回钥匙。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 351,
    "word": "réunir",
    "phonetic": "/ʁe.y.niʁ/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 聚集，汇集；v.pr. 集合，会面",
    "commonMeanings": [
      "聚集",
      "汇集",
      "集合"
    ],
    "example": "Le directeur va réunir toute l'équipe demain.",
    "exampleTranslation": "主任明天要召集全体团队。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 352,
    "word": "réussir",
    "phonetic": "/reysir/",
    "type": "v.i./v.t.",
    "translation": "成功",
    "commonMeanings": [
      "成功"
    ],
    "example": "Réussir un examen.",
    "exampleTranslation": "通过一场考试。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 353,
    "word": "réveiller",
    "phonetic": "/reveje/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 唤醒；v.pr. 醒来",
    "commonMeanings": [
      "唤醒"
    ],
    "example": "Se réveiller tôt.",
    "exampleTranslation": "早醒。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 354,
    "word": "révéler",
    "phonetic": "/revele/",
    "type": "v.t.",
    "translation": "揭露",
    "commonMeanings": [
      "揭露"
    ],
    "example": "Révéler un secret.",
    "exampleTranslation": "揭露一个秘密。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 355,
    "word": "revenir",
    "phonetic": "/rəvnir/",
    "type": "v.i.",
    "translation": "回来",
    "commonMeanings": [
      "回来"
    ],
    "example": "Revenir de voyage.",
    "exampleTranslation": "旅行回来。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 356,
    "word": "rêver",
    "phonetic": "/reve/",
    "type": "v.i./v.t.",
    "translation": "v.i. 做梦，梦想；v.t. 梦见",
    "commonMeanings": [
      "做梦"
    ],
    "example": "Rêver de voyager.",
    "exampleTranslation": "梦想旅行。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 357,
    "word": "revoir",
    "phonetic": "/rəvwar/",
    "type": "v.t.",
    "translation": "再见；复习",
    "commonMeanings": [
      "再见",
      "复习"
    ],
    "example": "Revoir un ami.",
    "exampleTranslation": "重新见到一个朋友。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 358,
    "word": "rire",
    "phonetic": "/rir/",
    "type": "v.i.",
    "translation": "笑",
    "commonMeanings": [
      "笑"
    ],
    "example": "Rire aux éclats.",
    "exampleTranslation": "放声大笑。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 359,
    "word": "risquer",
    "phonetic": "/riske/",
    "type": "v.t.",
    "translation": "冒险",
    "commonMeanings": [
      "冒险"
    ],
    "example": "Risquer sa vie.",
    "exampleTranslation": "冒生命危险。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 360,
    "word": "rompre",
    "phonetic": "/rɔ̃pr/",
    "type": "v.t./v.i.",
    "translation": "v.t. 打断；v.i. 分手",
    "commonMeanings": [
      "打断",
      "分手"
    ],
    "example": "Rompre le silence.",
    "exampleTranslation": "打破寂静。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 361,
    "word": "rouler",
    "phonetic": "/rule/",
    "type": "v.i./v.t.",
    "translation": "v.i. 滚动，行驶；v.t. 使滚动",
    "commonMeanings": [
      "滚动",
      "行驶"
    ],
    "example": "La voiture roule vite.",
    "exampleTranslation": "汽车开得快。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 362,
    "word": "s'abstenir",
    "phonetic": "/sabstənir/",
    "type": "v.pr.",
    "translation": "弃权；克制",
    "commonMeanings": [
      "弃权",
      "克制"
    ],
    "example": "Il s'abstient de fumer.",
    "exampleTranslation": "他戒烟了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 363,
    "word": "s'adapter",
    "phonetic": "/sadapte/",
    "type": "v.pr.",
    "translation": "适应",
    "commonMeanings": [
      "适应"
    ],
    "example": "Il s'adapte vite à son milieu.",
    "exampleTranslation": "他很快适应了环境。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 364,
    "word": "s'arrêter",
    "phonetic": "/sarɛte/",
    "type": "v.pr.",
    "translation": "停止",
    "commonMeanings": [
      "停止"
    ],
    "example": "La voiture s'arrête au feu.",
    "exampleTranslation": "汽车在红绿灯前停下了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 365,
    "word": "s'asseoir",
    "phonetic": "/saswar/",
    "type": "v.pr.",
    "translation": "坐下",
    "commonMeanings": [
      "坐下"
    ],
    "example": "Asseyez-vous, s'il vous plaît.",
    "exampleTranslation": "请坐。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 366,
    "word": "s'endormir",
    "phonetic": "/sɑ̃dɔrmir/",
    "type": "v.pr.",
    "translation": "入睡",
    "commonMeanings": [
      "入睡"
    ],
    "example": "Il s'endort devant la télé.",
    "exampleTranslation": "他在电视前睡着了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 367,
    "word": "s'enfuir",
    "phonetic": "/sɑ̃fɥir/",
    "type": "v.pr.",
    "translation": "逃跑",
    "commonMeanings": [
      "逃跑"
    ],
    "example": "Le voleur s'enfuit.",
    "exampleTranslation": "小偷逃跑了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 368,
    "word": "s'habiller",
    "phonetic": "/sabije/",
    "type": "v.pr.",
    "translation": "穿衣",
    "commonMeanings": [
      "穿衣"
    ],
    "example": "S'habiller chaudement.",
    "exampleTranslation": "穿得暖和。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 369,
    "word": "s'habituer",
    "phonetic": "/sabitye/",
    "type": "v.pr.",
    "translation": "习惯于",
    "commonMeanings": [
      "习惯于"
    ],
    "example": "S'habituer au climat.",
    "exampleTranslation": "适应气候。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 370,
    "word": "saisir",
    "phonetic": "/sezir/",
    "type": "v.t.",
    "translation": "抓住；理解",
    "commonMeanings": [
      "抓住",
      "理解"
    ],
    "example": "Saisir une occasion.",
    "exampleTranslation": "抓住一个机会。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 371,
    "word": "saluer",
    "phonetic": "/salue/",
    "type": "v.t.",
    "translation": "问候；敬礼",
    "commonMeanings": [
      "问候",
      "敬礼"
    ],
    "example": "Saluer son voisin.",
    "exampleTranslation": "向邻居打招呼。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 372,
    "word": "satisfaire",
    "phonetic": "/satisfɛr/",
    "type": "v.t.",
    "translation": "使满意",
    "commonMeanings": [
      "使满意"
    ],
    "example": "Satisfaire les clients.",
    "exampleTranslation": "让客户满意。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 373,
    "word": "sauver",
    "phonetic": "/so.ve/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 救，拯救；v.pr. 逃跑",
    "commonMeanings": [
      "救",
      "拯救",
      "逃跑"
    ],
    "example": "Les pompiers ont sauvé l'enfant des flammes.",
    "exampleTranslation": "消防员从火中救出了孩子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 374,
    "word": "savoir",
    "phonetic": "/savwar/",
    "type": "v.t.",
    "translation": "知道；会",
    "commonMeanings": [
      "知道",
      "会"
    ],
    "example": "Je ne sais pas.",
    "exampleTranslation": "我不知道。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 375,
    "word": "se fâcher",
    "phonetic": "/sə faʃe/",
    "type": "v.pr.",
    "translation": "生气",
    "commonMeanings": [
      "生气"
    ],
    "example": "Ne te fâche pas !",
    "exampleTranslation": "别生气！",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 376,
    "word": "se moquer",
    "phonetic": "/sə mɔke/",
    "type": "v.pr.",
    "translation": "嘲笑",
    "commonMeanings": [
      "嘲笑"
    ],
    "example": "Se moquer de quelqu'un.",
    "exampleTranslation": "嘲笑某人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 377,
    "word": "se plaindre",
    "phonetic": "/sə plɛ̃dr/",
    "type": "v.pr.",
    "translation": "抱怨；投诉",
    "commonMeanings": [
      "抱怨",
      "投诉"
    ],
    "example": "Il se plaint du bruit.",
    "exampleTranslation": "他抱怨噪音。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 378,
    "word": "se rapporter",
    "phonetic": "/sə rapɔrte/",
    "type": "v.pr.",
    "translation": "关联；有关",
    "commonMeanings": [
      "关联",
      "有关"
    ],
    "example": "Cela se rapporte à ce sujet.",
    "exampleTranslation": "这与这个主题有关。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 379,
    "word": "se souvenir",
    "phonetic": "/sə suvnir/",
    "type": "v.pr.",
    "translation": "回想起",
    "commonMeanings": [
      "回想起"
    ],
    "example": "Je me souviens de ce jour.",
    "exampleTranslation": "我记得那一天。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 380,
    "word": "sembler",
    "phonetic": "/sɑ̃ble/",
    "type": "v.i.",
    "translation": "好像",
    "commonMeanings": [
      "好像"
    ],
    "example": "Il semble content.",
    "exampleTranslation": "他看起来高兴。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 381,
    "word": "sentir",
    "phonetic": "/sɑ̃tir/",
    "type": "v.t./v.i.",
    "translation": "v.t. 感觉，闻；v.i. 有…气味",
    "commonMeanings": [
      "感觉",
      "闻"
    ],
    "example": "Sentir une odeur.",
    "exampleTranslation": "闻到一股气味。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 382,
    "word": "séparer",
    "phonetic": "/separe/",
    "type": "v.t.",
    "translation": "分隔；使分离",
    "commonMeanings": [
      "分隔",
      "使分离"
    ],
    "example": "Séparer le vrai du faux.",
    "exampleTranslation": "区分真假。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 383,
    "word": "serrer",
    "phonetic": "/sɛre/",
    "type": "v.t.",
    "translation": "握紧；挤",
    "commonMeanings": [
      "握紧",
      "挤"
    ],
    "example": "Serrer la main à quelqu'un.",
    "exampleTranslation": "与某人握手。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 384,
    "word": "servir",
    "phonetic": "/sɛrvir/",
    "type": "v.t./v.i.",
    "translation": "v.t. 为…服务；v.i. 有用，用作",
    "commonMeanings": [
      "服务",
      "有用"
    ],
    "example": "À quoi ça sert ?",
    "exampleTranslation": "这有什么用？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 385,
    "word": "signer",
    "phonetic": "/siɲe/",
    "type": "v.t.",
    "translation": "签名",
    "commonMeanings": [
      "签名"
    ],
    "example": "Signer un contrat.",
    "exampleTranslation": "签署一份合同。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 386,
    "word": "signifier",
    "phonetic": "/siɲifje/",
    "type": "v.t.",
    "translation": "意味着；表示",
    "commonMeanings": [
      "意味着",
      "表示"
    ],
    "example": "Que signifie ce mot ?",
    "exampleTranslation": "这个词是什么意思？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 387,
    "word": "situer",
    "phonetic": "/si.tɥe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 定位，确定位置；v.pr. 坐落于，处于（水平/等级）",
    "commonMeanings": [
      "定位",
      "坐落于",
      "处于"
    ],
    "example": "Où se situe la mairie ?",
    "exampleTranslation": "市政厅在什么位置？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 388,
    "word": "soigner",
    "phonetic": "/swaɲe/",
    "type": "v.t.",
    "translation": "照料；医治",
    "commonMeanings": [
      "照料",
      "医治"
    ],
    "example": "Soigner un malade.",
    "exampleTranslation": "照顾一个病人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 389,
    "word": "solliciter",
    "phonetic": "/sɔlisite/",
    "type": "v.t.",
    "translation": "请求；恳求",
    "commonMeanings": [
      "请求",
      "恳求"
    ],
    "example": "Solliciter une audience.",
    "exampleTranslation": "请求接见。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 390,
    "word": "songer",
    "phonetic": "/sɔ̃ʒe/",
    "type": "v.t.indir.",
    "translation": "考虑；想到",
    "commonMeanings": [
      "考虑",
      "想到"
    ],
    "example": "Je songe à changer de travail.",
    "exampleTranslation": "我在考虑换工作。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 391,
    "word": "sonner",
    "phonetic": "/sɔne/",
    "type": "v.i./v.t.",
    "translation": "v.i. 响；v.t. 按铃，敲响",
    "commonMeanings": [
      "响",
      "按铃"
    ],
    "example": "Le réveil sonne à sept heures.",
    "exampleTranslation": "闹钟七点响了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 392,
    "word": "sortir",
    "phonetic": "/sɔrtir/",
    "type": "v.i./v.t.",
    "translation": "v.i. 出去；v.t. 拿出",
    "commonMeanings": [
      "出去",
      "拿出"
    ],
    "example": "Sortir avec des amis.",
    "exampleTranslation": "和朋友出去。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 393,
    "word": "souffrir",
    "phonetic": "/sufrir/",
    "type": "v.i./v.t.",
    "translation": "v.i. 受苦；v.t. 忍受",
    "commonMeanings": [
      "受苦",
      "忍受"
    ],
    "example": "Souffrir de la chaleur.",
    "exampleTranslation": "受炎热之苦。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 394,
    "word": "souhaiter",
    "phonetic": "/swɛte/",
    "type": "v.t.",
    "translation": "希望；祝愿",
    "commonMeanings": [
      "希望",
      "祝愿"
    ],
    "example": "Je vous souhaite bonne chance.",
    "exampleTranslation": "祝您好运。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 395,
    "word": "souligner",
    "phonetic": "/suliɲe/",
    "type": "v.t.",
    "translation": "强调；划线",
    "commonMeanings": [
      "强调",
      "划线"
    ],
    "example": "Souligner l'importance de qch.",
    "exampleTranslation": "强调某事的重要性。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 396,
    "word": "soupçonner",
    "phonetic": "/supsɔne/",
    "type": "v.t.",
    "translation": "怀疑",
    "commonMeanings": [
      "怀疑"
    ],
    "example": "On le soupçonne de vol.",
    "exampleTranslation": "大家怀疑他偷窃。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 397,
    "word": "sourire",
    "phonetic": "/surir/",
    "type": "v.i.",
    "translation": "微笑",
    "commonMeanings": [
      "微笑"
    ],
    "example": "Elle sourit tout le temps.",
    "exampleTranslation": "她总是微笑。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 398,
    "word": "souvenir",
    "phonetic": "/su.v(ə).niʁ/",
    "type": "v.pr.",
    "translation": "v.pr. 记住，回想起，记得",
    "commonMeanings": [
      "记住",
      "回想起",
      "记得"
    ],
    "example": "Tu te souviens de notre premier rendez-vous ?",
    "exampleTranslation": "你还记得我们的第一次约会吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 399,
    "word": "subir",
    "phonetic": "/sybir/",
    "type": "v.t.",
    "translation": "遭受；忍受",
    "commonMeanings": [
      "遭受",
      "忍受"
    ],
    "example": "Subir un échec.",
    "exampleTranslation": "遭受失败。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 400,
    "word": "succéder",
    "phonetic": "/syksede/",
    "type": "v.t.indir.",
    "translation": "继承；接替",
    "commonMeanings": [
      "继承",
      "接替"
    ],
    "example": "Succéder à son père.",
    "exampleTranslation": "接替父亲。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 401,
    "word": "suffire",
    "phonetic": "/syfir/",
    "type": "v.t.indir.",
    "translation": "足够",
    "commonMeanings": [
      "足够"
    ],
    "example": "Cela suffit !",
    "exampleTranslation": "够了！",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 402,
    "word": "suggérer",
    "phonetic": "/syɡʒere/",
    "type": "v.t.",
    "translation": "建议；启发",
    "commonMeanings": [
      "建议",
      "启发"
    ],
    "example": "Suggérer une idée.",
    "exampleTranslation": "提出一个想法。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 403,
    "word": "suivre",
    "phonetic": "/sɥivr/",
    "type": "v.t.",
    "translation": "跟随；遵守",
    "commonMeanings": [
      "跟随",
      "遵守"
    ],
    "example": "Suivez le guide.",
    "exampleTranslation": "跟着导游走。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 404,
    "word": "supporter",
    "phonetic": "/sypɔrte/",
    "type": "v.t.",
    "translation": "支持；忍受",
    "commonMeanings": [
      "支持",
      "忍受"
    ],
    "example": "Ne pas supporter le bruit.",
    "exampleTranslation": "无法忍受噪音。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 405,
    "word": "supposer",
    "phonetic": "/sypoze/",
    "type": "v.t.",
    "translation": "假定",
    "commonMeanings": [
      "假定"
    ],
    "example": "Je suppose qu'il a oublié.",
    "exampleTranslation": "我想他大概是忘了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 406,
    "word": "surprendre",
    "phonetic": "/syrprɑ̃dr/",
    "type": "v.t.",
    "translation": "使惊讶；撞见",
    "commonMeanings": [
      "使惊讶",
      "撞见"
    ],
    "example": "Surprendre qqn en flagrant délit.",
    "exampleTranslation": "当场抓获某人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 407,
    "word": "surveiller",
    "phonetic": "/syrveje/",
    "type": "v.t.",
    "translation": "监视；看管",
    "commonMeanings": [
      "监视",
      "看管"
    ],
    "example": "Surveiller les enfants.",
    "exampleTranslation": "看管孩子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 408,
    "word": "survivre",
    "phonetic": "/syrvivr/",
    "type": "v.t.indir.",
    "translation": "幸存",
    "commonMeanings": [
      "幸存"
    ],
    "example": "Survivre à une catastrophe.",
    "exampleTranslation": "在一场灾难中幸存。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 409,
    "word": "tacher",
    "phonetic": "/taʃe/",
    "type": "v.t.",
    "translation": "弄脏",
    "commonMeanings": [
      "弄脏"
    ],
    "example": "Tacher sa chemise.",
    "exampleTranslation": "弄脏衬衫。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 410,
    "word": "tâcher",
    "phonetic": "/taʃe/",
    "type": "v.i.",
    "translation": "努力；设法",
    "commonMeanings": [
      "努力",
      "设法"
    ],
    "example": "Tâcher de bien faire.",
    "exampleTranslation": "努力做好。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 411,
    "word": "taire",
    "phonetic": "/tɛr/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 隐瞒；v.pr. 沉默",
    "commonMeanings": [
      "隐瞒",
      "沉默"
    ],
    "example": "Se taire pour écouter.",
    "exampleTranslation": "保持安静以便倾听。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 412,
    "word": "taper",
    "phonetic": "/tape/",
    "type": "v.t./v.i.",
    "translation": "v.t. 敲，打字；v.i. 拍打",
    "commonMeanings": [
      "敲",
      "打字"
    ],
    "example": "Tapez votre mot de passe.",
    "exampleTranslation": "输入您的密码。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 413,
    "word": "tarder",
    "phonetic": "/tarde/",
    "type": "v.i.",
    "translation": "耽搁；延迟",
    "commonMeanings": [
      "耽搁",
      "延迟"
    ],
    "example": "Ne tardez pas à répondre.",
    "exampleTranslation": "请尽快回复。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 414,
    "word": "téléphoner",
    "phonetic": "/telefɔne/",
    "type": "v.t.indir.",
    "translation": "打电话",
    "commonMeanings": [
      "打电话"
    ],
    "example": "Téléphoner à ses parents.",
    "exampleTranslation": "给父母打电话。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 415,
    "word": "témoigner",
    "phonetic": "/temwaɲe/",
    "type": "v.t./v.i.",
    "translation": "v.t. 证明；v.i. 作证，表明",
    "commonMeanings": [
      "证明",
      "表达"
    ],
    "example": "Témoigner de la reconnaissance.",
    "exampleTranslation": "表达感谢。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 416,
    "word": "tendre",
    "phonetic": "/tɑ̃dr/",
    "type": "v.t.",
    "translation": "伸出；拉紧",
    "commonMeanings": [
      "伸出",
      "拉紧"
    ],
    "example": "Tendre la main.",
    "exampleTranslation": "伸出手。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 417,
    "word": "tenir",
    "phonetic": "/tənir/",
    "type": "v.t./v.i.",
    "translation": "v.t. 拿着，握住；v.i. 坚持",
    "commonMeanings": [
      "拿着",
      "坚持"
    ],
    "example": "Tenir sa promesse.",
    "exampleTranslation": "遵守诺言。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 418,
    "word": "tenter",
    "phonetic": "/tɑ̃te/",
    "type": "v.t.",
    "translation": "试图；诱惑",
    "commonMeanings": [
      "试图",
      "诱惑"
    ],
    "example": "Tenter une expérience.",
    "exampleTranslation": "尝试一个实验。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 419,
    "word": "terminer",
    "phonetic": "/tɛrmine/",
    "type": "v.t.",
    "translation": "结束",
    "commonMeanings": [
      "结束"
    ],
    "example": "Terminer son travail.",
    "exampleTranslation": "完成工作。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 420,
    "word": "tirer",
    "phonetic": "/tire/",
    "type": "v.t.",
    "translation": "拉；抽出；打(球)",
    "commonMeanings": [
      "拉",
      "抽出",
      "打(球)"
    ],
    "example": "Tirer la sonnette.",
    "exampleTranslation": "拉门铃。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 421,
    "word": "tomber",
    "phonetic": "/tɔ̃be/",
    "type": "v.i.",
    "translation": "掉下；摔倒",
    "commonMeanings": [
      "掉下",
      "摔倒"
    ],
    "example": "La pluie tombe.",
    "exampleTranslation": "下雨了。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 422,
    "word": "toucher",
    "phonetic": "/tuʃe/",
    "type": "v.t./v.t.indir.",
    "translation": "触摸；感动",
    "commonMeanings": [
      "触摸",
      "感动"
    ],
    "example": "Ne touchez à rien.",
    "exampleTranslation": "什么也别碰。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 423,
    "word": "tourner",
    "phonetic": "/turne/",
    "type": "v.t./v.i.",
    "translation": "v.t. 旋转，转弯；v.i. 转动",
    "commonMeanings": [
      "旋转",
      "拐弯"
    ],
    "example": "Tourner à gauche.",
    "exampleTranslation": "左转。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 424,
    "word": "tracer",
    "phonetic": "/trase/",
    "type": "v.t.",
    "translation": "描绘；画(线)",
    "commonMeanings": [
      "描绘",
      "画(线)"
    ],
    "example": "Tracer un plan.",
    "exampleTranslation": "画一个平面图。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 425,
    "word": "traduire",
    "phonetic": "/tradɥir/",
    "type": "v.t.",
    "translation": "翻译",
    "commonMeanings": [
      "翻译"
    ],
    "example": "Traduire un texte.",
    "exampleTranslation": "翻译一篇课文。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 426,
    "word": "traîner",
    "phonetic": "/trɛne/",
    "type": "v.t./v.i.",
    "translation": "v.t. 拖，拉；v.i. 闲逛",
    "commonMeanings": [
      "拖",
      "闲逛"
    ],
    "example": "Ne traînez pas en chemin.",
    "exampleTranslation": "路上别磨蹭。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 427,
    "word": "traiter",
    "phonetic": "/trɛte/",
    "type": "v.t.",
    "translation": "处理；对待",
    "commonMeanings": [
      "处理",
      "对待"
    ],
    "example": "Traiter une affaire.",
    "exampleTranslation": "处理一件事务。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 428,
    "word": "transformer",
    "phonetic": "/trɑ̃sfɔrme/",
    "type": "v.t.",
    "translation": "改变；转换",
    "commonMeanings": [
      "改变",
      "转换"
    ],
    "example": "Transformer un essai.",
    "exampleTranslation": "转换尝试得分。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 429,
    "word": "transmettre",
    "phonetic": "/trɑ̃smɛtr/",
    "type": "v.t.",
    "translation": "转达；传递",
    "commonMeanings": [
      "转达",
      "传递"
    ],
    "example": "Transmettre un message.",
    "exampleTranslation": "传递一条信息。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 430,
    "word": "transporter",
    "phonetic": "/trɑ̃spɔrte/",
    "type": "v.t.",
    "translation": "运输",
    "commonMeanings": [
      "运输"
    ],
    "example": "Transporter des marchandises.",
    "exampleTranslation": "运输货物。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 431,
    "word": "travailler",
    "phonetic": "/travaje/",
    "type": "v.i.",
    "translation": "工作",
    "commonMeanings": [
      "工作"
    ],
    "example": "Travailler dur.",
    "exampleTranslation": "努力工作。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 432,
    "word": "traverser",
    "phonetic": "/travɛrse/",
    "type": "v.t.",
    "translation": "横穿",
    "commonMeanings": [
      "横穿"
    ],
    "example": "Traverser la rue.",
    "exampleTranslation": "过马路。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 433,
    "word": "trembler",
    "phonetic": "/trɑ̃ble/",
    "type": "v.i.",
    "translation": "发抖",
    "commonMeanings": [
      "发抖"
    ],
    "example": "Trembler de froid.",
    "exampleTranslation": "冷得发抖。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 434,
    "word": "tromper",
    "phonetic": "/trɔ̃pe/",
    "type": "v.t./v.pr.",
    "translation": "v.t. 欺骗；v.pr. 搞错",
    "commonMeanings": [
      "欺骗",
      "(自)搞错"
    ],
    "example": "Se tromper de numéro.",
    "exampleTranslation": "拨错号码。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 435,
    "word": "trouver",
    "phonetic": "/truve/",
    "type": "v.t.",
    "translation": "v.t. 找到，觉得；v.pr. 位于，处于",
    "commonMeanings": [
      "找到",
      "觉得"
    ],
    "example": "Je trouve que c'est bien.",
    "exampleTranslation": "我觉得这很好。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 436,
    "word": "tuer",
    "phonetic": "/tɥe/",
    "type": "v.t.",
    "translation": "杀死",
    "commonMeanings": [
      "杀死"
    ],
    "example": "Tuer le temps.",
    "exampleTranslation": "消磨时间。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 437,
    "word": "tutoyer",
    "phonetic": "/tytwaje/",
    "type": "v.t.",
    "translation": "用“你”称呼",
    "commonMeanings": [
      "用“你”称呼"
    ],
    "example": "On se tutoie ?",
    "exampleTranslation": "我们能以「你」相称吗？",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 438,
    "word": "unir",
    "phonetic": "/ynir/",
    "type": "v.t.",
    "translation": "联合；团结",
    "commonMeanings": [
      "联合",
      "团结"
    ],
    "example": "Unir ses forces.",
    "exampleTranslation": "联合力量。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 439,
    "word": "user",
    "phonetic": "/yze/",
    "type": "v.t.",
    "translation": "磨损；消耗",
    "commonMeanings": [
      "磨损",
      "消耗"
    ],
    "example": "User ses chaussures.",
    "exampleTranslation": "磨穿鞋子。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 440,
    "word": "utiliser",
    "phonetic": "/ytilize/",
    "type": "v.t.",
    "translation": "使用",
    "commonMeanings": [
      "使用"
    ],
    "example": "Utiliser un dictionnaire.",
    "exampleTranslation": "使用一本词典。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 441,
    "word": "vaincre",
    "phonetic": "/vɛ̃kr/",
    "type": "v.t.",
    "translation": "战胜",
    "commonMeanings": [
      "战胜"
    ],
    "example": "Vaincre la peur.",
    "exampleTranslation": "战胜恐惧。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 442,
    "word": "valider",
    "phonetic": "/valide/",
    "type": "v.t.",
    "translation": "使有效；确认",
    "commonMeanings": [
      "使有效",
      "确认"
    ],
    "example": "Valider un ticket.",
    "exampleTranslation": "验票。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 443,
    "word": "valoir",
    "phonetic": "/valwar/",
    "type": "v.i./v.t.",
    "translation": "v.i. 价值；v.t. 等于，值得",
    "commonMeanings": [
      "价值",
      "等于"
    ],
    "example": "Cela vaut la peine.",
    "exampleTranslation": "这很值得。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 444,
    "word": "varier",
    "phonetic": "/varje/",
    "type": "v.i./v.t.",
    "translation": "v.t. 改变，使变化；v.i. 变化",
    "commonMeanings": [
      "变化",
      "改变"
    ],
    "example": "Varier les plaisirs.",
    "exampleTranslation": "多样化地享受。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 445,
    "word": "veiller",
    "phonetic": "/veje/",
    "type": "v.i.",
    "translation": "守候；留意",
    "commonMeanings": [
      "守候",
      "留意"
    ],
    "example": "Veiller sur quelqu'un.",
    "exampleTranslation": "守护某人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 446,
    "word": "vendre",
    "phonetic": "/vɑ̃dr/",
    "type": "v.t.",
    "translation": "卖",
    "commonMeanings": [
      "卖"
    ],
    "example": "Vendre sa voiture.",
    "exampleTranslation": "卖掉他的车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 447,
    "word": "venger",
    "phonetic": "/vɑ̃ʒe/",
    "type": "v.t.",
    "translation": "报复；报仇",
    "commonMeanings": [
      "报复",
      "报仇"
    ],
    "example": "Venger un affront.",
    "exampleTranslation": "雪耻。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 448,
    "word": "venir",
    "phonetic": "/vənir/",
    "type": "v.i.",
    "translation": "来",
    "commonMeanings": [
      "来"
    ],
    "example": "Je viens de Paris.",
    "exampleTranslation": "我来自巴黎。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 449,
    "word": "vérifier",
    "phonetic": "/verifje/",
    "type": "v.t.",
    "translation": "核实；检查",
    "commonMeanings": [
      "核实",
      "检查"
    ],
    "example": "Vérifier ses calculs.",
    "exampleTranslation": "验算。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 450,
    "word": "verser",
    "phonetic": "/vɛrse/",
    "type": "v.t.",
    "translation": "倒；支付",
    "commonMeanings": [
      "倒",
      "支付"
    ],
    "example": "Verser du vin.",
    "exampleTranslation": "倒葡萄酒。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 451,
    "word": "vêtir",
    "phonetic": "/vɛtir/",
    "type": "v.t.",
    "translation": "给...穿衣",
    "commonMeanings": [
      "给...穿衣"
    ],
    "example": "Vêtir un enfant.",
    "exampleTranslation": "给孩子穿衣。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 452,
    "word": "vibrer",
    "phonetic": "/vibre/",
    "type": "v.i.",
    "translation": "震动",
    "commonMeanings": [
      "震动"
    ],
    "example": "Le téléphone vibre.",
    "exampleTranslation": "手机在震动。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 453,
    "word": "vider",
    "phonetic": "/vide/",
    "type": "v.t.",
    "translation": "倒空",
    "commonMeanings": [
      "倒空"
    ],
    "example": "Vider son sac.",
    "exampleTranslation": "清空他的包。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 454,
    "word": "vieillir",
    "phonetic": "/vjejjir/",
    "type": "v.i.",
    "translation": "变老",
    "commonMeanings": [
      "变老"
    ],
    "example": "Il ne vieillit pas.",
    "exampleTranslation": "他不显老。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 455,
    "word": "viser",
    "phonetic": "/vize/",
    "type": "v.t.",
    "translation": "瞄准",
    "commonMeanings": [
      "瞄准"
    ],
    "example": "Viser le sommet.",
    "exampleTranslation": "瞄准顶峰。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 456,
    "word": "visiter",
    "phonetic": "/vizite/",
    "type": "v.t.",
    "translation": "参观",
    "commonMeanings": [
      "参观"
    ],
    "example": "Visiter un musée.",
    "exampleTranslation": "参观一个博物馆。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 457,
    "word": "vivre",
    "phonetic": "/vivr/",
    "type": "v.i./v.t.",
    "translation": "v.i. 生活，活着；v.t. 经历，过…生活",
    "commonMeanings": [
      "生活",
      "活着"
    ],
    "example": "Vivre cent ans.",
    "exampleTranslation": "活一百岁。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 458,
    "word": "voir",
    "phonetic": "/vwar/",
    "type": "v.t.",
    "translation": "看见",
    "commonMeanings": [
      "看见"
    ],
    "example": "Voir un spectacle.",
    "exampleTranslation": "看一场演出。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 459,
    "word": "voler",
    "phonetic": "/vɔle/",
    "type": "v.i./v.t.",
    "translation": "v.i. 飞；v.t. 偷窃",
    "commonMeanings": [
      "飞",
      "偷窃"
    ],
    "example": "Voler un vélo.",
    "exampleTranslation": "偷一辆自行车。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 460,
    "word": "vomir",
    "phonetic": "/vɔmir/",
    "type": "v.i./v.t.",
    "translation": "v.t. 呕吐；v.i. 呕吐",
    "commonMeanings": [
      "呕吐"
    ],
    "example": "Envie de vomir.",
    "exampleTranslation": "想吐。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 461,
    "word": "voter",
    "phonetic": "/vɔte/",
    "type": "v.i.",
    "translation": "投票",
    "commonMeanings": [
      "投票"
    ],
    "example": "Voter pour un candidat.",
    "exampleTranslation": "投票给一位候选人。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 462,
    "word": "vouer",
    "phonetic": "/vwe/",
    "type": "v.t.",
    "translation": "献身；致力于",
    "commonMeanings": [
      "献身",
      "致力于"
    ],
    "example": "Vouer sa vie à l'art.",
    "exampleTranslation": "把一生献给艺术。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 463,
    "word": "vouloir",
    "phonetic": "/vulwar/",
    "type": "v.t.",
    "translation": "想要",
    "commonMeanings": [
      "想要"
    ],
    "example": "Je veux partir.",
    "exampleTranslation": "我想走。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 464,
    "word": "vouvoyer",
    "phonetic": "/vuvwaje/",
    "type": "v.t.",
    "translation": "用“您”称呼",
    "commonMeanings": [
      "用“您”称呼"
    ],
    "example": "Vouvoyer son patron.",
    "exampleTranslation": "对老板用敬称。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 465,
    "word": "voyager",
    "phonetic": "/vwajaʒe/",
    "type": "v.i.",
    "translation": "旅行",
    "commonMeanings": [
      "旅行"
    ],
    "example": "Voyager à l'étranger.",
    "exampleTranslation": "去国外旅行。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 466,
    "word": "vulgariser",
    "phonetic": "/vylɡarize/",
    "type": "v.t.",
    "translation": "普及；通俗化",
    "commonMeanings": [
      "普及",
      "通俗化"
    ],
    "example": "Vulgariser la science.",
    "exampleTranslation": "普及科学。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 467,
    "word": "zapper",
    "phonetic": "/zape/",
    "type": "v.i.",
    "translation": "跳台；跳过",
    "commonMeanings": [
      "跳台",
      "跳过"
    ],
    "example": "Zapper la publicité.",
    "exampleTranslation": "跳过广告。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 468,
    "word": "zigzaguer",
    "phonetic": "/ziɡzaɡe/",
    "type": "v.i.",
    "translation": "蜿蜒曲折",
    "commonMeanings": [
      "蜿蜒曲折"
    ],
    "example": "La route zigzague.",
    "exampleTranslation": "道路蜿蜒曲折。",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 469,
    "word": "voix",
    "phonetic": "[vwa]",
    "type": "",
    "translation": "语态 v.t. 开，打开；开辟；开放；开办；v.i. 开启；开张；开",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 470,
    "word": "minuit",
    "phonetic": "[minɥi]",
    "type": "",
    "translation": "n.m. 半夜，午夜；子夜12时，零时",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 471,
    "word": "locataire",
    "phonetic": "[lɔkatεr]",
    "type": "",
    "translation": "n. 租户，承租人；房屋承租人，房客",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 472,
    "word": "surpris",
    "phonetic": "[syrpri, i:z]",
    "type": "",
    "translation": "a. 被当场抓住的；惊愕的，惊讶的，惊奇的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 473,
    "word": "maison",
    "phonetic": "[mεzɔ̃]",
    "type": "",
    "translation": "n.f.（独户）住宅；家；院，所，馆；商行，商店",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 474,
    "word": "collègue",
    "phonetic": "[kɔlεg]",
    "type": "",
    "translation": "n. 同事，同僚；同职者",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 475,
    "word": "vingtaine",
    "phonetic": "[vɛ̃tεn]",
    "type": "",
    "translation": "n.f. 二十左右，二十来个 v.t.， v.pr. 1.缓慢流动，松出； 2.笔直走纺；拉丝； 3.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 476,
    "word": "filer",
    "phonetic": "[file]",
    "type": "",
    "translation": "尾随，跟踪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 477,
    "word": "difficile",
    "phonetic": "[difisil]",
    "type": "",
    "translation": "a. 难的，困难的；艰辛的；难以相处的，难以满足的 v.t.， v.pr. 1.认做，把...认作自己的 2.承认；供认，招",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 478,
    "word": "avouer",
    "phonetic": "[avwe]",
    "type": "",
    "translation": "认，认罪； 3.公开表明，表露；认可，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 479,
    "word": "geste",
    "phonetic": "[ʒεst]",
    "type": "",
    "translation": "n.m. 手势，姿势；动作；慷慨的行为 v.t. 举起，抬起，提起；揭起；撤去，解除，取消；使起",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 480,
    "word": "soleil",
    "phonetic": "[sɔlεj]",
    "type": "",
    "translation": "n.m. 太阳；阳光；晴天",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 481,
    "word": "silence",
    "phonetic": "[silɑ̃s]",
    "type": "",
    "translation": "n.m. 寂静，沉默；不联系，不写信",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 482,
    "word": "retour",
    "phonetic": "[r(ə)tur]",
    "type": "",
    "translation": "n.m. 返回；回程（票）；恢复；退回；回报；转向 v.i. 回来，回到；回家；恢复；进入；v.t. 收进；使进",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 483,
    "word": "bout",
    "phonetic": "[bu]",
    "type": "",
    "translation": "终结，结局；一段，一截，一部分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 484,
    "word": "conversation",
    "phonetic": "[kɔ̃vεrsasjɔ̃]",
    "type": "",
    "translation": "n.f. 谈话，会话，交谈；会谈",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 485,
    "word": "nos",
    "phonetic": "[no]",
    "type": "",
    "translation": "nôtre",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 486,
    "word": "direction",
    "phonetic": "[dirεksjɔ̃]",
    "type": "",
    "translation": "向",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 487,
    "word": "passé",
    "phonetic": "[pase]",
    "type": "",
    "translation": "a. 过去的，以前的；n.m. 过去，往昔 v.i. 跌倒；倒塌；跌落；脱落；降落；垂下；倒下；阵",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 488,
    "word": "station",
    "phonetic": "[stasjɔ̃]",
    "type": "",
    "translation": "n.f. 停留；站立，直立；车站；研究所；站，台，所，场",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 489,
    "word": "impossible",
    "phonetic": "[ɛ̃pɔsibl]",
    "type": "",
    "translation": "a. 不可能的，做不到的；难以相处的；荒谬的，离奇的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 490,
    "word": "blanc",
    "phonetic": "[blɑ̃, -∫]",
    "type": "",
    "translation": "n.m. 白色；白色衣服；白色颜料，白涂料；空白，间隔",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 491,
    "word": "comment",
    "phonetic": "[kɔmɑ̃]",
    "type": "",
    "translation": "adv. 如何， 怎么， 怎样；为何， 为什么 v.i. 再来；返回，回来；重新出现；在记忆中重现；回",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 492,
    "word": "autour",
    "phonetic": "[otur]",
    "type": "",
    "translation": "adv. 在周围，在四周",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 493,
    "word": "ami",
    "phonetic": "[ami]",
    "type": "",
    "translation": "n. 朋友；友好者，同情者；情人 a. 小的；矮小的；幼小的；微量的；细小的；无关紧要",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 494,
    "word": "petit",
    "phonetic": "[pəti, -t]",
    "type": "",
    "translation": "的；卑鄙的；渺小的；（地位）低微的；可爱的，亲爱的 1 of 35 单词 音标 解释 No. a. 绷紧的，紧贴的；密集的；精炼的；紧凑的；（时间",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 495,
    "word": "serré",
    "phonetic": "[sere]",
    "type": "",
    "translation": "ou [sεre] 等）紧的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 496,
    "word": "quoi",
    "phonetic": "[kwa]",
    "type": "",
    "translation": "pron.relat. 什么",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 497,
    "word": "merci",
    "phonetic": "[mεrsi]",
    "type": "",
    "translation": "n.f. 怜悯，仁慈，恩惠；n.m. 道谢的话；interj. 谢谢",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 498,
    "word": "vieux",
    "phonetic": "[vjø, vjεj]",
    "type": "",
    "translation": "a. 年老的，老年的；年长的；年代久的；旧的；n. 老人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 499,
    "word": "gens",
    "phonetic": "[ʒɑ̃]",
    "type": "",
    "translation": "n.m.， n.f. pl. 人们；人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 500,
    "word": "environ",
    "phonetic": "[ɑ̃virɔ̃]",
    "type": "",
    "translation": "adv. 大约，将近",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 501,
    "word": "résolution",
    "phonetic": "[rezɔlysjɔ̃]",
    "type": "",
    "translation": "n.f. 解决，解答；决心；分解；溶解；[法]撤销；决议",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 502,
    "word": "main",
    "phonetic": "[mɛ̃]",
    "type": "",
    "translation": "n.f. 手",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 503,
    "word": "sérieux",
    "phonetic": "[serjø]",
    "type": "",
    "translation": "a. 认真的，严肃的；庄重的，持重的；严重的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 504,
    "word": "papier",
    "phonetic": "[papje]",
    "type": "",
    "translation": "n.m. 纸；纸张；文件，文书；pl. 身份证件",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 505,
    "word": "septembre",
    "phonetic": "[sεptɑ̃br]",
    "type": "",
    "translation": "n.m. 九月 v.t. 敲，打，拍；打中，击中；冲制；侵袭，使遭受；使",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 506,
    "word": "part",
    "phonetic": "[par]",
    "type": "",
    "translation": "n.f. 份，份额；部分；股份",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 507,
    "word": "mercredi",
    "phonetic": "[mεrkrədi]",
    "type": "",
    "translation": "n.m. 星期三",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 508,
    "word": "serviteur",
    "phonetic": "[sεrvitœr]",
    "type": "",
    "translation": "n.m. 服务者",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 509,
    "word": "femme",
    "phonetic": "[fam]",
    "type": "",
    "translation": "n.f. 女人，妇女；妻子；已婚妇女",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 510,
    "word": "bras",
    "phonetic": "[bra, brɑ]",
    "type": "",
    "translation": "n.m. 臂，胳膊；臂状物；扶手 a. 美丽的，漂亮的；优美的；晴朗的；卓越的，优秀",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 511,
    "word": "beau",
    "phonetic": "[bo, bεl]",
    "type": "",
    "translation": "的；高尚的；适宜的；非常好的；大量的，重大的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 512,
    "word": "rang",
    "phonetic": "[rɑ̃]",
    "type": "",
    "translation": "n.m. 1.排，行，列； 2.等级，地位，位置",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 513,
    "word": "ciel",
    "phonetic": "[sjεl]",
    "type": "",
    "translation": "n.m. 天，天空；蓝天",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 514,
    "word": "tard",
    "phonetic": "[tar]",
    "type": "",
    "translation": "adv. 晚，迟；在傍晚；在深夜 v.i. 来，来到；出现，产生；发生，突然来临；来自；出",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 515,
    "word": "eau",
    "phonetic": "[o]",
    "type": "",
    "translation": "n.f. 水；海；湖；河；池塘；药水；溶液",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 516,
    "word": "action",
    "phonetic": "[aksjɔ̃]",
    "type": "",
    "translation": "n.f. 行动，动作，行为；股份；股票 v.i. 喊，叫；大声叫嚷；（物体）嘎吱响；v.t. 呼喊，喊",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 517,
    "word": "sorte",
    "phonetic": "[sɔrt]",
    "type": "",
    "translation": "n.f. 种类，类别，品种 adj.num.card.， adj.inv. 六；（一个月份的）6日；6",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 518,
    "word": "six",
    "phonetic": "[sis]",
    "type": "",
    "translation": "点钟；（房屋或房间的）6号；（纸牌等的）六点；一种 古铜币 a. 新出现的，新创的；新的，新近的；新奇的，前所未",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 519,
    "word": "nouveau",
    "phonetic": "[nuvo, -εl]",
    "type": "",
    "translation": "闻的；不熟悉的；无经验的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 520,
    "word": "ingénieur",
    "phonetic": "[ɛ̃ʒenjœr]",
    "type": "",
    "translation": "n.m. 工程师，技师",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 521,
    "word": "composer",
    "phonetic": "[kɔ̃poze]",
    "type": "",
    "translation": "v.t. 组成，构成；撰写，写作；作（曲） 2 of 35 单词 音标 解释 No. n.m. 名字；姓名；姓氏；名义；名称；名誉，名声；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 522,
    "word": "nom",
    "phonetic": "[nɔ̃]",
    "type": "",
    "translation": "[语]名词",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 523,
    "word": "mur",
    "phonetic": "[myr]",
    "type": "",
    "translation": "n.m. 墙，壁；障碍；峭壁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 524,
    "word": "rapidement",
    "phonetic": "[rapidmɑ̃]",
    "type": "",
    "translation": "adv. 很快地， 迅速地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 525,
    "word": "verre",
    "phonetic": "[vεr]",
    "type": "",
    "translation": "n.m. 杯子，玻璃酒杯；一杯酒；玻璃",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 526,
    "word": "ensemble",
    "phonetic": "[ɑ̃sɑ̃bl]",
    "type": "",
    "translation": "adv. 共同，一起；同时；n.m. 全部，全体；整体；同时",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 527,
    "word": "vie",
    "phonetic": "[vi]",
    "type": "",
    "translation": "平事迹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 528,
    "word": "temple",
    "phonetic": "[tɑ̃pl]",
    "type": "",
    "translation": "n.m. 庙宇，寺院；（新教）教堂，礼拜堂 v.t. 前移，使前进；使发展，促进；使提前；拨快；提",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 529,
    "word": "déjà",
    "phonetic": "[deʒa]",
    "type": "",
    "translation": "adv. 已经 adv. 更好地，较好地；更加；最好地；n.m. 最佳，最",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 530,
    "word": "mieux",
    "phonetic": "[mjø]",
    "type": "",
    "translation": "好；好转，更好",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 531,
    "word": "salut",
    "phonetic": "[saly]",
    "type": "",
    "translation": "n.m. 招呼，致意，致敬；拯救；得救",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 532,
    "word": "position",
    "phonetic": "[pozisjɔ̃]",
    "type": "",
    "translation": "n.f. 位置，方位；阵地；姿势；立场，观点",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 533,
    "word": "octobre",
    "phonetic": "[ɔktɔbr]",
    "type": "",
    "translation": "n.m. 十月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 534,
    "word": "silencieusement",
    "phonetic": "[silɑ̃sjøzmɑ̃]",
    "type": "",
    "translation": "adv. 默默",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 535,
    "word": "corps",
    "phonetic": "[kɔr]",
    "type": "",
    "translation": "n.m. 身体，躯体；肉体；躯干；尸体；物体；团体",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 536,
    "word": "silhouette",
    "phonetic": "[silwɛt]",
    "type": "",
    "translation": "n.f. 体型，体态；外形；侧影，剪影；影子；轮廓",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 537,
    "word": "club",
    "phonetic": "[klœb]",
    "type": "",
    "translation": "n.m. 俱乐部，会，社 a. 可能的，可能存在的，可能发生的；还可以的；可以",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 538,
    "word": "possible",
    "phonetic": "[pɔsibl]",
    "type": "",
    "translation": "接受的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 539,
    "word": "enfin",
    "phonetic": "[ɑ̃fɛ̃]",
    "type": "",
    "translation": "adv. 最后，终于；总之",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 540,
    "word": "accident",
    "phonetic": "[aksidɑ̃]",
    "type": "",
    "translation": "n.m.意外；事故",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 541,
    "word": "changement",
    "phonetic": "[∫ɑ̃ʒmɑ̃]",
    "type": "",
    "translation": "n.m. 更换，改变，变化",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 542,
    "word": "retard",
    "phonetic": "[r(ə)tar]",
    "type": "",
    "translation": "n.m. 延误，耽搁；减速，迟缓，延缓；落后",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 543,
    "word": "alors",
    "phonetic": "[alɔr]",
    "type": "",
    "translation": "adv. 那么，在这种情况下；当时，那时",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 544,
    "word": "vent",
    "phonetic": "[vɑ̃]",
    "type": "",
    "translation": "n.m. 风；空气，气流；趋势；风气",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 545,
    "word": "souvent",
    "phonetic": "[suvɑ̃]",
    "type": "",
    "translation": "adv. 经常，常常",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 546,
    "word": "musique",
    "phonetic": "[myzik]",
    "type": "",
    "translation": "n.f. 音乐；乐曲；音乐性，和谐，悦耳",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 547,
    "word": "toilette",
    "phonetic": "[twalεt]",
    "type": "",
    "translation": "n.f. 梳洗；打扮；梳妆台；n.f. pl. 厕所，卫生间",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 548,
    "word": "déjeuner",
    "phonetic": "[deʒœne]",
    "type": "",
    "translation": "n.m. 午饭，午餐；午餐菜肴；v.i. 吃早饭；吃午饭",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 549,
    "word": "favori",
    "phonetic": "[favɔri, -t]",
    "type": "",
    "translation": "的人，宠儿；红人；竞赛中最有希望获胜的人；赛马中最 有希望赢的马 a. 年轻的；年少的；新兴的；未成熟的；青年的；幼小",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 550,
    "word": "jeune",
    "phonetic": "[ʒœn]",
    "type": "",
    "translation": "的 3 of 35 单词 音标 解释 No. v.t. 重复，使增加一倍；把……对折；绕过；超过；加衬",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 551,
    "word": "doubler",
    "phonetic": "[duble]",
    "type": "",
    "translation": "里",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 552,
    "word": "presque",
    "phonetic": "[prεsk]",
    "type": "",
    "translation": "adv. 几乎，差不多 n.m. 火；火星，火焰；火灾；pl. 火光，灯光；灯；射",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 553,
    "word": "feu",
    "phonetic": "[fø]",
    "type": "",
    "translation": "击；开火；战争",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 554,
    "word": "exactement",
    "phonetic": "[εgzaktəmɑ̃]",
    "type": "",
    "translation": "adv. 准确地，确切地；严格地；准时地；如实地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 555,
    "word": "sac",
    "phonetic": "[sak]",
    "type": "",
    "translation": "n.m. 袋，囊，包；一袋之量；手提包",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 556,
    "word": "poignée",
    "phonetic": "[pwaɲe]",
    "type": "",
    "translation": "n.f. 一把，一撮；一小撮人；把手",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 557,
    "word": "banque",
    "phonetic": "[bɑ̃k]",
    "type": "",
    "translation": "n.f. 银行；银行业",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 558,
    "word": "calmer",
    "phonetic": "[kalme]",
    "type": "",
    "translation": "v.t. 使平静；平息，缓和",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 559,
    "word": "passage",
    "phonetic": "[pasaʒ]",
    "type": "",
    "translation": "n.m. 通过，经过；摆渡；通道，小巷；转变，过渡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 560,
    "word": "article",
    "phonetic": "[artikl]",
    "type": "",
    "translation": "n.m. 文章；条款，条文；项目；商品；[语]冠词",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 561,
    "word": "saison",
    "phonetic": "[sεzɔ̃]",
    "type": "",
    "translation": "n.f. 季；季节；当令期",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 562,
    "word": "voiture",
    "phonetic": "[vwatyr]",
    "type": "",
    "translation": "n.f. 车，车辆；汽车，轿车；[铁]客车，客车车厢",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 563,
    "word": "côté",
    "phonetic": "[kote]",
    "type": "",
    "translation": "n.m. 旁，侧；方向；方面；肋，胸侧，体侧",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 564,
    "word": "dollar",
    "phonetic": "[dɔlar]",
    "type": "",
    "translation": "n.m. 美元；澳元；加元；港元",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 565,
    "word": "pourtant",
    "phonetic": "[purtɑ̃]",
    "type": "",
    "translation": "adv. 然而， 无论如何， 可是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 566,
    "word": "toujours",
    "phonetic": "[tuʒur]",
    "type": "",
    "translation": "adv. 永远，一直；总是；始终",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 567,
    "word": "ton",
    "phonetic": "[tɔ̃]",
    "type": "",
    "translation": "n.m. 音调，声调；adj. 你的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 568,
    "word": "pourquoi",
    "phonetic": "[purkwa]",
    "type": "",
    "translation": "adv.， conj. 为什么，为何；原因，理由；问题 a. 志愿的，自愿的；有意的，故意的；n. 志愿者，志愿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 569,
    "word": "volontaire",
    "phonetic": "[vɔlɔ̃tεr]",
    "type": "",
    "translation": "人员",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 570,
    "word": "douze",
    "phonetic": "[duz]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 十二；第十二 v.i. 走，行走；踏，踩；（车辆、船的）行驶；运行，运",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 571,
    "word": "jamais",
    "phonetic": "[ʒamε]",
    "type": "",
    "translation": "adv. 从没，从未，从不；将来某日；曾经 adj.poss. 您的，你的；你们的；对于您（你）的；对于",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 572,
    "word": "votre",
    "phonetic": "[vɔtr]",
    "type": "",
    "translation": "你们的（指客体） a. 红颜色的；脸红的；红棕色的；烧红的；n.m. 红颜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 573,
    "word": "rouge",
    "phonetic": "[ruʒ]",
    "type": "",
    "translation": "色；口红；红色信号",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 574,
    "word": "bord",
    "phonetic": "[bɔr]",
    "type": "",
    "translation": "n.m. 边，边缘；岸边；船边，船舷；船 a. 高的；涨高的；昂贵的；地位高的，上流的；高度",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 575,
    "word": "haut",
    "phonetic": "[o, ot]",
    "type": "",
    "translation": "虚音H 的，特别的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 576,
    "word": "car",
    "phonetic": "[kar]",
    "type": "",
    "translation": "conj. 因为；n.m. 旅游车",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 577,
    "word": "treize",
    "phonetic": "[trεz]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 十三",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 578,
    "word": "matin",
    "phonetic": "[matɛ̃]",
    "type": "",
    "translation": "n.m. 早晨；上午，上半天 adj. 长的，远的；长久的，久远的 n.m.长，长度 adv.许",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 579,
    "word": "longue",
    "phonetic": "[lɔ̃g]",
    "type": "",
    "translation": "多，很多",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 580,
    "word": "chambre",
    "phonetic": "[∫ɑ̃br]",
    "type": "",
    "translation": "n.f. 房间，睡房；议会；公会",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 581,
    "word": "occupé",
    "phonetic": "[ɔkype]",
    "type": "",
    "translation": "a. 忙碌的；被占用的；有人预订的；被占领的 n.f. 结伴，作伴，陪同；协会，团体；公司；[军]连；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 582,
    "word": "compagnie",
    "phonetic": "[kɔ̃paɲi]",
    "type": "",
    "translation": "（动物的）群",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 583,
    "word": "prix",
    "phonetic": "[pri]",
    "type": "",
    "translation": "n.m. 价格；价值；代价；奖；奖金",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 584,
    "word": "autrefois",
    "phonetic": "[otrəfwa]",
    "type": "",
    "translation": "adv. 过去，以前，从前，往昔",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 585,
    "word": "cheval",
    "phonetic": "[∫(ə)val]",
    "type": "",
    "translation": "n.m. 马，马肉；骑马术；马力",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 586,
    "word": "vitesse",
    "phonetic": "[vitεs]",
    "type": "",
    "translation": "n.f. 速度；快，迅速",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 587,
    "word": "chemin",
    "phonetic": "[∫(ə)mɛ̃]",
    "type": "",
    "translation": "n.m. 路，小路；路程，行程；途径，方法",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 588,
    "word": "nous",
    "phonetic": "[nu]",
    "type": "",
    "translation": "pron.pers. 我们，咱们",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 589,
    "word": "route",
    "phonetic": "[rut]",
    "type": "",
    "translation": "n.f. 道路，公路；公路运输；路程，旅途",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 590,
    "word": "lieu",
    "phonetic": "[ljø]",
    "type": "",
    "translation": "n.m. 地点；地方；场所",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 591,
    "word": "mouvement",
    "phonetic": "[muvmɑ̃]",
    "type": "",
    "translation": "n.m. 运动，移动；行动，活动；流动",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 592,
    "word": "machine",
    "phonetic": "[ma∫in]",
    "type": "",
    "translation": "n.f. 机械，机器；机械车辆；机构，机关 a. 特有的，独特的；个别的，单独的；特别的；特定",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 593,
    "word": "particulier",
    "phonetic": "[partikylje, ε:r]",
    "type": "",
    "translation": "的；私人的，个人的；n.m. 个人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 594,
    "word": "mer",
    "phonetic": "[mεr]",
    "type": "",
    "translation": "n.f. 海；海水；海边；海潮；大量",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 595,
    "word": "détail",
    "phonetic": "[detaj]",
    "type": "",
    "translation": "n.m. 细节，细部；零售；详细，详尽，详细情况",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 596,
    "word": "seconde",
    "phonetic": "[səgɔ̃d]",
    "type": "",
    "translation": "n.f. 秒；瞬间，片刻 v.t. 领导，指挥；管理；指导，引导；引向，领向；驾",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 597,
    "word": "confortable",
    "phonetic": "[kɔ̃fɔrtabl]",
    "type": "",
    "translation": "a. 舒适的，适意的；令人快慰的 n.m. 服务，服役；勤务，公务；帮忙；用处；行政部",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 598,
    "word": "service",
    "phonetic": "[sεrvis]",
    "type": "",
    "translation": "门；处，科",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 599,
    "word": "chance",
    "phonetic": "[∫ɑ̃s]",
    "type": "",
    "translation": "n.f. 运气；幸运，好运；机会，可能性",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 600,
    "word": "nuit",
    "phonetic": "[nɥi]",
    "type": "",
    "translation": "n.f. 夜，夜晚，夜间；漆黑，黑暗",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 601,
    "word": "moment",
    "phonetic": "[mɔmɑ̃]",
    "type": "",
    "translation": "n.m. 时间，时刻；片刻，一会儿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 602,
    "word": "mon",
    "phonetic": "[mɔ̃, ma, me]",
    "type": "",
    "translation": "adj.poss. 我的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 603,
    "word": "projet",
    "phonetic": "[prɔʒε]",
    "type": "",
    "translation": "n.m. 打算，设想；计划，规划；草案；方案；草图 v.i. 登上，爬上；乘上（车等），骑上（马等）；升高，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 604,
    "word": "garçon",
    "phonetic": "[garsɔ̃]",
    "type": "",
    "translation": "n.m. 男孩；小伙子；小伙计；侍应生，男服务员",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 605,
    "word": "simplement",
    "phonetic": "[sɛ̃pləmɑ̃]",
    "type": "",
    "translation": "adv. 简单地；简朴地；爽直地，老实地；仅仅，只是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 606,
    "word": "mot",
    "phonetic": "[mo]",
    "type": "",
    "translation": "n.m. 词，字；短语；便条；名言",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 607,
    "word": "arrêt",
    "phonetic": "[arε]",
    "type": "",
    "translation": "n.m. 停止，中止；车站 v.t.,pr. 跟随；接着……而来；顺着……走；注意，关",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 608,
    "word": "coup",
    "phonetic": "[ku]",
    "type": "",
    "translation": "击声",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 609,
    "word": "regard",
    "phonetic": "[r(ə)gar]",
    "type": "",
    "translation": "n.m. 看；注视；目光 a. 单一的，单纯的；易懂的，简单的；简易的；简朴",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 610,
    "word": "simple",
    "phonetic": "[sɛ̃pl]",
    "type": "",
    "translation": "的；普通的；天真的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 611,
    "word": "religion",
    "phonetic": "[rəliʒjɔ̃]",
    "type": "",
    "translation": "n.f. 教义；宗教；宗教生活；宗教信仰",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 612,
    "word": "politique",
    "phonetic": "[pɔlitik]",
    "type": "",
    "translation": "a. 政治的，政治上的；n.f. 政治；政策，方针",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 613,
    "word": "raison",
    "phonetic": "[rεzɔ̃]",
    "type": "",
    "translation": "n.f. 原因，理由；理智，理性；道理，情理；明智；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 614,
    "word": "porte",
    "phonetic": "[pɔrt]",
    "type": "",
    "translation": "n.f. 门；城门；城门旧址 adj.poss.， pron.pers. 他们的， 她们的， 它们的；他",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 615,
    "word": "leur",
    "phonetic": "[lœr]",
    "type": "",
    "translation": "们， 她们， 它们[用作间接宾语]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 616,
    "word": "sans",
    "phonetic": "[sɑ̃]",
    "type": "",
    "translation": "prép. 没有，无，不",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 617,
    "word": "même",
    "phonetic": "[mεm]",
    "type": "",
    "translation": "[放在人称代词后]自己；adv. 甚至，即使；正是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 618,
    "word": "eux",
    "phonetic": "[ø]",
    "type": "",
    "translation": "pron.pers.m.pl. 他们，它们 v.i. 进入；触及，涉及；参加，参与；包括在；v.t. 搬",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 619,
    "word": "chose",
    "phonetic": "[∫oz]",
    "type": "",
    "translation": "n.f. 事情，事物；事实；事态；东西",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 620,
    "word": "loin",
    "phonetic": "[lwɛ̃]",
    "type": "",
    "translation": "adv. 远，遥远；久远，长久",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 621,
    "word": "malheureusement",
    "phonetic": "[malørøzmɑ̃]",
    "type": "",
    "translation": "adv. 不幸地，可惜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 622,
    "word": "air",
    "phonetic": "[εr]",
    "type": "",
    "translation": "n.m. 大气，空气；空中，天空；样子，神色",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 623,
    "word": "parfait",
    "phonetic": "[parfε]",
    "type": "",
    "translation": "a. 完美的，完善的；十足的，地道的；n.m. [语]完成式",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 624,
    "word": "riche",
    "phonetic": "[ri∫]",
    "type": "",
    "translation": "有钱人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 625,
    "word": "robe",
    "phonetic": "[rɔb]",
    "type": "",
    "translation": "n.f. 连衣裙；长袍",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 626,
    "word": "long",
    "phonetic": "[lɔ̃, -g]",
    "type": "",
    "translation": "a.（空间）长的，远的；（时间）长的，久的，久远的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 627,
    "word": "rue",
    "phonetic": "[ry]",
    "type": "",
    "translation": "n.f. 街，街道，马路",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 628,
    "word": "aussitôt",
    "phonetic": "[osito]",
    "type": "",
    "translation": "adv. 立刻，立即，即刻，马上",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 629,
    "word": "monde",
    "phonetic": "[mɔ̃d]",
    "type": "",
    "translation": "n.m. 世界；人间；人们；阶层；界；上流社会，社交界",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 630,
    "word": "absolument",
    "phonetic": "[apsɔlymɑ̃]",
    "type": "",
    "translation": "adv. 绝对地，完全地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 631,
    "word": "donné",
    "phonetic": "[dɔne]",
    "type": "",
    "translation": "定的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 632,
    "word": "dernier",
    "phonetic": "[dεrnje, -εr]",
    "type": "",
    "translation": "a. 最后的；最低劣的，最差的；最近的，最新的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 633,
    "word": "celui",
    "phonetic": "[səlɥi]",
    "type": "",
    "translation": "pron.dém. 指示代词这个",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 634,
    "word": "avec",
    "phonetic": "[avεk]",
    "type": "",
    "translation": "对于；带有，具有；尽管 v.t. 拿，取，抓；携带；搭乘；带走，接走；吃，喝，服",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 635,
    "word": "esprit",
    "phonetic": "[εspri]",
    "type": "",
    "translation": "n.m. 灵魂；神灵；精灵，鬼神；思想；精神",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 636,
    "word": "intérêt",
    "phonetic": "[ɛ̃terε]",
    "type": "",
    "translation": "n.m. 利息；利益，好处；关心；兴趣，注意",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 637,
    "word": "inutile",
    "phonetic": "[inytil]",
    "type": "",
    "translation": "a. 无用的，无实用价值的；无益的，无效的，徒劳的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 638,
    "word": "bon",
    "phonetic": "[bɔ̃, bɔn]",
    "type": "",
    "translation": "a. 好的；恰当的；正确的；优秀的；美好的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 639,
    "word": "chaise",
    "phonetic": "[∫εz]",
    "type": "",
    "translation": "n.f. 椅子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 640,
    "word": "capitale",
    "phonetic": "[kapital]",
    "type": "",
    "translation": "n.f. 首都；首府 v.,v.pr. 关，关闭；封闭；闭上，合拢；关掉（水、电",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 641,
    "word": "nécessaire",
    "phonetic": "[nesesεr]",
    "type": "",
    "translation": "ou [nesεsεr] 的；n.m.（生活）必需品；必须做的事 v.i. 滑，滑动，滑行 v.t. 悄悄地塞进；（把想法、意见）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 642,
    "word": "glisser",
    "phonetic": "[glise]",
    "type": "",
    "translation": "巧妙地加进去",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 643,
    "word": "enfant",
    "phonetic": "[ɑ̃fɑ̃]",
    "type": "",
    "translation": "n. 儿童，小孩；子女",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 644,
    "word": "billet",
    "phonetic": "[bijε]",
    "type": "",
    "translation": "n.m. 票，券；门票；钞票 6 of 35 单词 音标 解释 No. a. 第一的；原始的；第一位的，首要的；初步的，基本",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 645,
    "word": "premier",
    "phonetic": "[prəmje, -εr]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 646,
    "word": "classer",
    "phonetic": "[klase]",
    "type": "",
    "translation": "v.t. 分类，分级；归类；整理，排列；归；编组",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 647,
    "word": "samedi",
    "phonetic": "[samdi]",
    "type": "",
    "translation": "n.m. 星期六 v.t. 重新看，再看；重见某人，再见某人；复查，复核，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 648,
    "word": "pluie",
    "phonetic": "[plɥi]",
    "type": "",
    "translation": "n.f. 雨，下雨；（雨点般袭来的）一阵；大量，大批",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 649,
    "word": "coin",
    "phonetic": "[kwɛ̃]",
    "type": "",
    "translation": "n.m. 角，角落；一隅之地；偏僻的地方；居住的街区",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 650,
    "word": "gaz",
    "phonetic": "[gɑz]",
    "type": "",
    "translation": "n.m. 气，气体；天然气，煤气",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 651,
    "word": "histoire",
    "phonetic": "[istwar]",
    "type": "",
    "translation": "n.f. 历史；历史书籍；历史学；故事；（多用复数）谎言",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 652,
    "word": "lac",
    "phonetic": "[lak]",
    "type": "",
    "translation": "n.m. 湖，湖泊 v.t. 算，计算；估计，估量；盘算，打算；v.i. 算，计",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 653,
    "word": "calculer",
    "phonetic": "[kalkyle]",
    "type": "",
    "translation": "算；精打细算",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 654,
    "word": "travail",
    "phonetic": "[travaj]",
    "type": "",
    "translation": "n.m. 劳动，工作；活儿；任务；职业；干活；工作地点",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 655,
    "word": "front",
    "phonetic": "[frɔ̃]",
    "type": "",
    "translation": "n.m. 前额；顶，峰；正面；前线，阵线 a. 黑的，黑色的，黝黑的；黑暗的；肮脏的；悲观的，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 656,
    "word": "noir",
    "phonetic": "[nwar]",
    "type": "",
    "translation": "忧伤的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 657,
    "word": "nombre",
    "phonetic": "[nɔ̃br]",
    "type": "",
    "translation": "n.m. 数；数目，数量",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 658,
    "word": "contraire",
    "phonetic": "[kɔ̃trεr]",
    "type": "",
    "translation": "adj. 相反的；有害的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 659,
    "word": "éclat",
    "phonetic": "[ekla]",
    "type": "",
    "translation": "艳，鲜明；光彩",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 660,
    "word": "frère",
    "phonetic": "[frεr]",
    "type": "",
    "translation": "n.m. 兄弟；社友，会友；同行，同事；修士 a. 公众的，民众的；国家的，政府的；公立的；公共",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 661,
    "word": "public",
    "phonetic": "[pyblik]",
    "type": "",
    "translation": "的，公用的；公开的；n.m. 公众，民众，大众",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 662,
    "word": "année",
    "phonetic": "[ane]",
    "type": "",
    "translation": "n.f. 年，年份；年度",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 663,
    "word": "notre",
    "phonetic": "[nɔtr]",
    "type": "",
    "translation": "adj.poss. 我们的；我的 a. 宽的，宽阔的，宽敞的；宽大的；n.m. 宽度；外海，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 664,
    "word": "large",
    "phonetic": "[larʒ]",
    "type": "",
    "translation": "大海",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 665,
    "word": "superbe",
    "phonetic": "[sypεrb]",
    "type": "",
    "translation": "a. 美好的，漂亮的，绚丽的；极好的，绝妙的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 666,
    "word": "mois",
    "phonetic": "[mwa]",
    "type": "",
    "translation": "n.m. 月，月份；一个月的时间 v.i. 下，下来，下去；朝南走；下榻；出身于，是……的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 667,
    "word": "besoin",
    "phonetic": "[bəzwɛ̃]",
    "type": "",
    "translation": "n.m. 想望，欲望，要求；需要，必要，需求",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 668,
    "word": "citoyen",
    "phonetic": "[sitwajɛ̃, -εn]",
    "type": "",
    "translation": "n. 市民，城里人；公民，国民",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 669,
    "word": "mari",
    "phonetic": "[mari]",
    "type": "",
    "translation": "n.m. 丈夫",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 670,
    "word": "combien",
    "phonetic": "[kɔ̃bjɛ̃]",
    "type": "",
    "translation": "adv. 第几；几号；多少；多么",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 671,
    "word": "lit",
    "phonetic": "[li]",
    "type": "",
    "translation": "n.m. 床；垫，褥；河床 n.m. 营地，军营；野营地，露营地；（集中）营；[政]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 672,
    "word": "camp",
    "phonetic": "[kɑ̃]",
    "type": "",
    "translation": "阵营",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 673,
    "word": "trentaine",
    "phonetic": "[trɑ̃tεn]",
    "type": "",
    "translation": "n.f. 三十，三十来个；三十岁，三十岁左右",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 674,
    "word": "humain",
    "phonetic": "[ymɛ̃, -εn]",
    "type": "",
    "translation": "a. 有人的特点的，由人组成的；人的；人文的；人道的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 675,
    "word": "horrible",
    "phonetic": "[ɔribl]",
    "type": "",
    "translation": "a. 可怕的，恐怖的，可憎的；糟糕的，恶劣的 7 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 676,
    "word": "arrivée",
    "phonetic": "[arive]",
    "type": "",
    "translation": "n.f. 到达；到达的时间或地点",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 677,
    "word": "millier",
    "phonetic": "[milje]",
    "type": "",
    "translation": "n.m. 千，千数，约千数；很多很多",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 678,
    "word": "personnage",
    "phonetic": "[pεrsɔnaʒ]",
    "type": "",
    "translation": "n.m. 人物，角色；名人，要人；人[指品行、外表]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 679,
    "word": "gymnastique",
    "phonetic": "[ʒimnastik]",
    "type": "",
    "translation": "n.f. 体操",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 680,
    "word": "connaissance",
    "phonetic": "[kɔnεsɑ̃s]",
    "type": "",
    "translation": "n.f. 认识，知道；感觉；结识；知识 v.t. 影响；感动；使不安，使痛苦；规定……（的用",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 681,
    "word": "affecter",
    "phonetic": "[afεkte]",
    "type": "",
    "translation": "途），拨；指派，分配",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 682,
    "word": "vraiment",
    "phonetic": "[vrεmɑ̃]",
    "type": "",
    "translation": "adv. 真正地，确实地，实在地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 683,
    "word": "fenêtre",
    "phonetic": "[f(ə)nεtr]",
    "type": "",
    "translation": "n.f. 窗；玻璃窗；窗状开口；[信]窗口 v.t. 介绍，引见；送上；出示；阐述，说明；展示；显",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 684,
    "word": "égard",
    "phonetic": "[egar]",
    "type": "",
    "translation": "n.m. 1.考虑，注意； 2.注重",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 685,
    "word": "éléphant",
    "phonetic": "[elefɑ̃]",
    "type": "",
    "translation": "n.m. 象",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 686,
    "word": "novembre",
    "phonetic": "[nɔvɑ̃br]",
    "type": "",
    "translation": "n.m. 十一月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 687,
    "word": "idée",
    "phonetic": "[ide]",
    "type": "",
    "translation": "n.f. 看法，想法；概念；观念；概况；计划；思想",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 688,
    "word": "question",
    "phonetic": "[kεstjɔ̃]",
    "type": "",
    "translation": "n.f. 问题，问话；考题",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 689,
    "word": "circuler",
    "phonetic": "[sirkyle]",
    "type": "",
    "translation": "v.i. 循环，流通；往来，通行；流传；传播，散布",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 690,
    "word": "arbre",
    "phonetic": "[arbr]",
    "type": "",
    "translation": "n.m. 树，树木",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 691,
    "word": "groupe",
    "phonetic": "[grup]",
    "type": "",
    "translation": "n.m. 群；堆，丛；班，组；团体",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 692,
    "word": "exercice",
    "phonetic": "[εgzεrsis]",
    "type": "",
    "translation": "n.m. 练习，训练，锻炼；习题；体育活动 a. 习惯的，习惯性的，惯用的；经常的，通常的；常见",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 693,
    "word": "habituel",
    "phonetic": "[abitɥεl]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 694,
    "word": "probable",
    "phonetic": "[prɔbabl]",
    "type": "",
    "translation": "a. 很可能的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 695,
    "word": "quel",
    "phonetic": "[kεl]",
    "type": "",
    "translation": "adj.interr. 什么样的， 哪一类的；多么， 何等；哪一个 n.f. 事务；问题；事情；纠纷；买卖；pl. 商业，生意；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 696,
    "word": "affaire",
    "phonetic": "[afεr]",
    "type": "",
    "translation": "（个人的）衣物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 697,
    "word": "communication",
    "phonetic": "[kɔmynikasjɔ̃]",
    "type": "",
    "translation": "n.f. 交际，交流；通知；消息；相连",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 698,
    "word": "crédit",
    "phonetic": "[kredi]",
    "type": "",
    "translation": "n.m. 信任；信誉；信用；付款期限；信贷；[会]贷方",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 699,
    "word": "région",
    "phonetic": "[reʒjɔ̃]",
    "type": "",
    "translation": "n.f. 地区，地带；大区",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 700,
    "word": "lundi",
    "phonetic": "[lœ̃di]",
    "type": "",
    "translation": "n.m. 星期一",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 701,
    "word": "mariage",
    "phonetic": "[marjaʒ]",
    "type": "",
    "translation": "n.m. 结婚，婚姻；婚礼；联姻，合并；结合，融合 a. 低劣的，坏的；不适当的；不祥的；有害的，危险",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 702,
    "word": "mauvais",
    "phonetic": "[mɔvε, -z]",
    "type": "",
    "translation": "的；恶的，恶毒的，恶意的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 703,
    "word": "allure",
    "phonetic": "[alyr]",
    "type": "",
    "translation": "n.f. 步子，举止，态度",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 704,
    "word": "lune",
    "phonetic": "[lyn]",
    "type": "",
    "translation": "n.f. 月亮，月球",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 705,
    "word": "quart",
    "phonetic": "[kar]",
    "type": "",
    "translation": "n.m. 四分之一；四分之一升的小瓶；四分之一升的量",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 706,
    "word": "maximum",
    "phonetic": "[maksimɔm]",
    "type": "",
    "translation": "n.m. 最大量，最大数，最大限度；a. 最大的，最高的 8 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 707,
    "word": "appétit",
    "phonetic": "[apeti]",
    "type": "",
    "translation": "n.m. 食欲，胃口；欲望，渴望",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 708,
    "word": "probablement",
    "phonetic": "[prɔbabləmɑ̃]",
    "type": "",
    "translation": "adv. 可能，大概，或许",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 709,
    "word": "beaucoup",
    "phonetic": "[boku]",
    "type": "",
    "translation": "adv. 很，很多；太",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 710,
    "word": "exact",
    "phonetic": "[εgza(kt), εgzakt]",
    "type": "",
    "translation": "a. 准确的，确切的，精确的；准时的，守时的；真实的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 711,
    "word": "partie",
    "phonetic": "[parti]",
    "type": "",
    "translation": "n.f. 部分，局部；部门；专业；当事人；一盘，一场 v.t.， v.pr. 1.抛下，投下；使突然陷入； 2.加速加快；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 712,
    "word": "précipiter",
    "phonetic": "[presipite]",
    "type": "",
    "translation": "猛推，猛拉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 713,
    "word": "journal",
    "phonetic": "[ʒurnal]",
    "type": "",
    "translation": "n.m. 报纸；新闻报道；日记",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 714,
    "word": "nouvelle",
    "phonetic": "[nuvεl]",
    "type": "",
    "translation": "n.f. 消息；音信；新闻报道；短篇小说，中篇小说",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 715,
    "word": "forcé",
    "phonetic": "[fɔrse]",
    "type": "",
    "translation": "a. 被迫的，强制的；不可避免的，必然的；不自然的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 716,
    "word": "surface",
    "phonetic": "[syrfas]",
    "type": "",
    "translation": "n.f.（物体的）面，表面；面积；（事物的）外表",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 717,
    "word": "spécial",
    "phonetic": "[spesjal]",
    "type": "",
    "translation": "a. 特殊的，特别的；特有的，特设的；专门的；专用的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 718,
    "word": "extraordinaire",
    "phonetic": "[εkstraɔrdinεr]",
    "type": "",
    "translation": "的；巨大的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 719,
    "word": "famille",
    "phonetic": "[famij]",
    "type": "",
    "translation": "n.f. 家庭；家属；亲属；派，学派；类",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 720,
    "word": "joie",
    "phonetic": "[ʒwa]",
    "type": "",
    "translation": "n.f. 欢乐，快乐；喜悦，愉快，满意 v.t. 重获，重新找到，失而复得；重新赢得，再博得；返",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 721,
    "word": "regagner",
    "phonetic": "[r(ə)gaɲe]",
    "type": "",
    "translation": "回，回到",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 722,
    "word": "murmurer",
    "phonetic": "[myrmyre]",
    "type": "",
    "translation": "v.i. 低语，窃窃议论；低声抱怨；v.t. 低声说 a. 左边的，左面的，左侧的，左方的；笨拙的，不自然",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 723,
    "word": "gauche",
    "phonetic": "[go∫]",
    "type": "",
    "translation": "的；n.f. 左，左手，左边，左面；[政]左派 a. 发疯的，精神错乱的；疯疯癫癫的；疯狂的；失去理",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 724,
    "word": "fou",
    "phonetic": "[fu, fɔl]",
    "type": "",
    "translation": "智的；过分的，过多的；n. 疯子，狂人；疯疯癫癫的人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 725,
    "word": "retarder",
    "phonetic": "[rətarde]",
    "type": "",
    "translation": "v.i.（钟表）走得慢；落后，跟不上时代",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 726,
    "word": "tête",
    "phonetic": "[tεt]",
    "type": "",
    "translation": "n.f. 头；脑袋；脸；面容；表情；头脑；顶端",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 727,
    "word": "appartement",
    "phonetic": "[apartəmɑ̃]",
    "type": "",
    "translation": "n.m. 套房，成套房间，单元房",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 728,
    "word": "construction",
    "phonetic": "[kɔ̃stryksjɔ̃]",
    "type": "",
    "translation": "n.f. 建造，建筑，建设；结构，构造；建筑物；制造业",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 729,
    "word": "bagage",
    "phonetic": "[bagaʒ]",
    "type": "",
    "translation": "n.m. 行李箱，箱包；行李；衣物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 730,
    "word": "suffisant",
    "phonetic": "[syfizɑ̃]",
    "type": "",
    "translation": "a. 充分的，充足的，足够的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 731,
    "word": "marin",
    "phonetic": "[marɛ̃, -in]",
    "type": "",
    "translation": "n.m. 海员，水手；航海者；航行者",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 732,
    "word": "dissimuler",
    "phonetic": "[disimyle]",
    "type": "",
    "translation": "v.t.， v.pr. 1.掩饰，隐瞒；遮盖； 2.装作不知",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 733,
    "word": "signaler",
    "phonetic": "[siɲale]",
    "type": "",
    "translation": "v.t.（用信号）标明，指示；使注意，指出；揭发 a. 自然（界）的；天然的；天生的；正常的；合乎情理",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 734,
    "word": "naturel",
    "phonetic": "[natyrεl]",
    "type": "",
    "translation": "的 a. 完全的，完整的；全部的；全面的；已结束的，完成",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 735,
    "word": "complet",
    "phonetic": "[kɔ̃plε, -t]",
    "type": "",
    "translation": "的；满满的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 736,
    "word": "gros",
    "phonetic": "[gro, -s]",
    "type": "",
    "translation": "批发 9 of 35 单词 音标 解释 No. a. 正义的，公道的；公正的，公平的；正确的，正当",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 737,
    "word": "juste",
    "phonetic": "[ʒyst]",
    "type": "",
    "translation": "的；准确的，精确的；合理的；几乎不够的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 738,
    "word": "bas",
    "phonetic": "[bɑ, -s]",
    "type": "",
    "translation": "下部，下端；（女式）长筒袜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 739,
    "word": "gouvernement",
    "phonetic": "[guvεrnəmɑ̃]",
    "type": "",
    "translation": "n.m. 统治；管理，治理；政体；政府",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 740,
    "word": "britannique",
    "phonetic": "[britanik]",
    "type": "",
    "translation": "adj.， n. 1.大不列颠的，英国的 2.英国人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 741,
    "word": "immense",
    "phonetic": "[imɑ̃s]",
    "type": "",
    "translation": "a. 无边的，无限的，广大的，辽阔的；巨大的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 742,
    "word": "territoire",
    "phonetic": "[tεritwar]",
    "type": "",
    "translation": "n.m. 领土，国土；领地，属地；辖区，区域 prép. 自……以来，从……以后；从……，自……；adv.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 743,
    "word": "depuis",
    "phonetic": "[dəpɥi]",
    "type": "",
    "translation": "从此以后，此后",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 744,
    "word": "fer",
    "phonetic": "[fεr]",
    "type": "",
    "translation": "n.m. 铁；铁制器具 n.f. 线；界线；线条；轮廓；线路，航线；（政治上的）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 745,
    "word": "ligne",
    "phonetic": "[liɲ]",
    "type": "",
    "translation": "路线；细绳 n.f. 右面， 右边， 右方；（道路的）右边；[政]右派，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 746,
    "word": "droite",
    "phonetic": "[drwat]",
    "type": "",
    "translation": "右翼； 右派政党；右手；[数]直线",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 747,
    "word": "vol",
    "phonetic": "[vɔl]",
    "type": "",
    "translation": "n.m. 飞翔；飞行；盗窃，抢劫；诈骗；宰人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 748,
    "word": "voici",
    "phonetic": "[vwasi]",
    "type": "",
    "translation": "prép.， adv. 这是，这就是；以下就是，下面就是 v.跳，跳跃；猛扑，扑上去；蹦掉，飞掉；爆炸，炸毁；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 749,
    "word": "sauter",
    "phonetic": "[sote]",
    "type": "",
    "translation": "跳过， 跳越 n.m. 水道；流动；移动，运行；进展，过程，期间；课",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 750,
    "word": "cours",
    "phonetic": "[kur]",
    "type": "",
    "translation": "程",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 751,
    "word": "indépendant",
    "phonetic": "[ɛ̃depɑ̃dɑ̃]",
    "type": "",
    "translation": "a. 独立的；自主的；不受束缚的；不相关联的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 752,
    "word": "bureau",
    "phonetic": "[byro]",
    "type": "",
    "translation": "n.m. 办公桌；书房；办公室；局，署，所，处",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 753,
    "word": "port",
    "phonetic": "[pɔr]",
    "type": "",
    "translation": "n.m. 港，港口",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 754,
    "word": "ainsi",
    "phonetic": "[ɛ̃si]",
    "type": "",
    "translation": "adv. 1.这样，如此；同样，一样； 2.由此，因此 a. 强壮的，力气大的；胖，肥，粗；能干的；强大的，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 755,
    "word": "fort",
    "phonetic": "[fɔ:r]",
    "type": "",
    "translation": "坚强的；强烈的；浓烈的；坚固的；n.m. 防御工事，堡 垒，要塞",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 756,
    "word": "splendide",
    "phonetic": "[splɑ̃did]",
    "type": "",
    "translation": "a. 壮丽的，富丽堂皇的；灿烂的；辉煌的 v.t. 欠；应该；应归功于；可能会；n.m. 责任，义务；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 757,
    "word": "froidement",
    "phonetic": "[frwadmɑ̃]",
    "type": "",
    "translation": "adv. 冷淡地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 758,
    "word": "ceci",
    "phonetic": "[səsi]",
    "type": "",
    "translation": "pron.dém. 这， 这个； 这事 v.i. 跑；赛跑；赛车；赛马；（时间）流逝；v.t. 谋取，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 759,
    "word": "mission",
    "phonetic": "[misjɔ̃]",
    "type": "",
    "translation": "道，传教",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 760,
    "word": "parfaitement",
    "phonetic": "[parfεtmɑ̃]",
    "type": "",
    "translation": "adv. 完美地，极好地；完全地，十分地，非常地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 761,
    "word": "liberté",
    "phonetic": "[libεrte]",
    "type": "",
    "translation": "n.f. 自由，自由权；独立自主，无约束",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 762,
    "word": "vue",
    "phonetic": "[vy]",
    "type": "",
    "translation": "n.f. 视觉；视力；看，看见；视野；景色；观点，看法",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 763,
    "word": "accomplir",
    "phonetic": "[akɔ̃plir]",
    "type": "",
    "translation": "v.t. 完成，实现；履行，执行",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 764,
    "word": "chemise",
    "phonetic": "[∫(ə)miz]",
    "type": "",
    "translation": "n.f. 男式衬衫",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 765,
    "word": "rond",
    "phonetic": "[rɔ̃, -d]",
    "type": "",
    "translation": "a. 圆的；矮胖的；圆胖的，丰满的；喝醉酒的 10 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 766,
    "word": "bruit",
    "phonetic": "[brɥi]",
    "type": "",
    "translation": "n.m. 声音，噪声，嘈杂声；消息，风声，传闻 a. 好奇的；爱打听的；稀奇的，奇特的，古怪的；n. 好",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 767,
    "word": "curieux",
    "phonetic": "[kyrjø, -z]",
    "type": "",
    "translation": "奇的人，好学的人；爱打听的人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 768,
    "word": "oreille",
    "phonetic": "[ɔrεj]",
    "type": "",
    "translation": "n.f. 耳；听觉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 769,
    "word": "devant",
    "phonetic": "[d(ə)vɑ̃]",
    "type": "",
    "translation": "prép. 在……前面，当……面；adv. 在前面",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 770,
    "word": "ensuite",
    "phonetic": "[ɑ̃sɥit]",
    "type": "",
    "translation": "adv. 然后，后来；随后，接着 v.t. 穿入，渗入，进入；看透，识破；打进，打入；v.i.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 771,
    "word": "mal",
    "phonetic": "[mal]",
    "type": "",
    "translation": "难；坏话，坏处；adv. 坏，糟，不好，恶劣地 v.t. 切，割，砍，剪；删节（文字）；剪辑（影片）；打",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 772,
    "word": "salon",
    "phonetic": "[salɔ̃]",
    "type": "",
    "translation": "n.m. 客厅；上流社会；[文]沙龙",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 773,
    "word": "court",
    "phonetic": "[kur]",
    "type": "",
    "translation": "a. 短的，短小的；短促的，短暂的，简短的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 774,
    "word": "paroi",
    "phonetic": "[parwa]",
    "type": "",
    "translation": "n.f. 1. 隔墙，隔板； 2.内壁；岩壁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 775,
    "word": "prêtre",
    "phonetic": "[prεtr]",
    "type": "",
    "translation": "n.m. 祭司；牧师；神甫；方丈",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 776,
    "word": "soulier",
    "phonetic": "[sulje]",
    "type": "",
    "translation": "n.m. 鞋； 皮鞋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 777,
    "word": "cri",
    "phonetic": "[kri]",
    "type": "",
    "translation": "n.m. 叫喊声，喧哗声 v.t. 使重新站起，扶起；重建，修复；恢复；抬起；撩",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 778,
    "word": "relever",
    "phonetic": "[rəlve]",
    "type": "",
    "translation": "起；升高，提高；记下，抄录；接替",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 779,
    "word": "jambe",
    "phonetic": "[ʒɑ̃b]",
    "type": "",
    "translation": "n.f. 小腿；下肢",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 780,
    "word": "bientôt",
    "phonetic": "[bjɛ̃to]",
    "type": "",
    "translation": "adv. 马上，不久；很快；一会儿工夫，在很短的时间内 n.m. 出发；离开；起飞；启航；开端，开始；出发点，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 781,
    "word": "départ",
    "phonetic": "[depar]",
    "type": "",
    "translation": "起点",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 782,
    "word": "chapeau",
    "phonetic": "[∫apo]",
    "type": "",
    "translation": "n.m. 帽子；[机]帽，盖，罩子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 783,
    "word": "paquet",
    "phonetic": "[pakε]",
    "type": "",
    "translation": "n.m. 包，束，捆；包裹，盒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 784,
    "word": "quai",
    "phonetic": "[kε]",
    "type": "",
    "translation": "ou [ke] n.m. 站台，月台；码头；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 785,
    "word": "pauvre",
    "phonetic": "[povr]",
    "type": "",
    "translation": "a. 贫穷的；可怜的；贫乏的；贫瘠的；n. 穷人，贫民",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 786,
    "word": "lendemain",
    "phonetic": "[lɑ̃dmɛ̃]",
    "type": "",
    "translation": "n.m. 次日，翌日；未来，将来 v.t. 允许，允诺，答应；保证；预示，给人……的指望，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 787,
    "word": "charmant",
    "phonetic": "[∫armɑ̃, -t]",
    "type": "",
    "translation": "a. 迷人的，富于诱惑力的；可爱的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 788,
    "word": "métier",
    "phonetic": "[metje]",
    "type": "",
    "translation": "n.m. 职业；技能；行业；手艺",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 789,
    "word": "aile",
    "phonetic": "[εl]",
    "type": "",
    "translation": "n.f. 翼，翅膀；机翼；侧翼 v.t. 稍稍提起，略微抬起；激起，引起；煽起暴动，发动",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 790,
    "word": "soulever",
    "phonetic": "[sulve]",
    "type": "",
    "translation": "造反；激怒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 791,
    "word": "nuage",
    "phonetic": "[nɥaʒ]",
    "type": "",
    "translation": "n.m. 云；云状物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 792,
    "word": "globe",
    "phonetic": "[glɔb]",
    "type": "",
    "translation": "n.m. 球，球体；地球；世界 adv. 同样，一样多； ...也一样， ...也好， 还是...为",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 793,
    "word": "autant",
    "phonetic": "[otɑ̃]",
    "type": "",
    "translation": "好， 等于是；同...一样多",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 794,
    "word": "faute",
    "phonetic": "[fot]",
    "type": "",
    "translation": "n.f. 错误；过失，过错；差错；违章；犯规；失误",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 795,
    "word": "seul",
    "phonetic": "[sœl]",
    "type": "",
    "translation": "a. 孤独的，孤单的；惟一的；只有，仅仅",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 796,
    "word": "arrivé",
    "phonetic": "[arive]",
    "type": "",
    "translation": "adj. 到达，来到；进口；到达地，终点",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 797,
    "word": "flanc",
    "phonetic": "[flɑ̃]",
    "type": "",
    "translation": "n.m. 肋部[指人或动物]；母胎，母腹；侧，侧面，旁侧",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 798,
    "word": "affirmer",
    "phonetic": "[afirme]",
    "type": "",
    "translation": "v.t. 断言，肯定；证明，确认；显示，表明",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 799,
    "word": "entier",
    "phonetic": "[ɑ̃tje, -εr]",
    "type": "",
    "translation": "a. 整个的，全部的；完整的；完全的；绝对的；无损的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 800,
    "word": "situation",
    "phonetic": "[sitɥasjɔ̃]",
    "type": "",
    "translation": "n.f. 状况，形势；地点，位置；职位；地位；处境；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 801,
    "word": "qualité",
    "phonetic": "[kalite]",
    "type": "",
    "translation": "n.f. 质量；性质；优质；优良品质；优点；身份，资格",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 802,
    "word": "agent",
    "phonetic": "[aʒɑ̃]",
    "type": "",
    "translation": "n.m. 代理人，经纪人；警察，警探",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 803,
    "word": "fait",
    "phonetic": "[fε]",
    "type": "",
    "translation": "n.m. 行为，行动；事件，发生的事情；事实",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 804,
    "word": "observation",
    "phonetic": "[ɔpsεrvasjɔ̃]",
    "type": "",
    "translation": "n.f. 观察，观测；监视；评论；遵守，奉行 prép. 为了；对于；适合于；向，往；在……时间内；由",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 805,
    "word": "pour",
    "phonetic": "[pur]",
    "type": "",
    "translation": "于；依……看来；至于；换，比；代，替",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 806,
    "word": "temps",
    "phonetic": "[tɑ̃]",
    "type": "",
    "translation": "n.m. 时间；阶段；时代，时期；时候；[语]时态；天气",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 807,
    "word": "animal",
    "phonetic": "[animal]",
    "type": "",
    "translation": "n.m. 动物；蠢货，畜生；a. 动物的；兽性的 v.t. 再拿，再取；拿回；收回；恢复；夺回，收复；重新",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 808,
    "word": "jean",
    "phonetic": "[dʒin]",
    "type": "",
    "translation": "n.m. 粗斜纹棉布，牛仔布；牛仔裤",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 809,
    "word": "vivant",
    "phonetic": "[vivɑ̃, -t]",
    "type": "",
    "translation": "a. 活的，活着的；有生命的；活泼的；生动的，逼真的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 810,
    "word": "justement",
    "phonetic": "[ʒystəmɑ̃]",
    "type": "",
    "translation": "adv. 正确地，确切地，恰当地；正好，恰好 v.t. 绑，缚，固定；系，扣；使系于，使结合；给予，赋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 811,
    "word": "attacher",
    "phonetic": "[ata∫e]",
    "type": "",
    "translation": "予",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 812,
    "word": "vous",
    "phonetic": "[vu]",
    "type": "",
    "translation": "pron.pers. 您，你；你们",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 813,
    "word": "oui",
    "phonetic": "[wi]",
    "type": "",
    "translation": "adv. 是，是的，对",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 814,
    "word": "sauce",
    "phonetic": "[sos]",
    "type": "",
    "translation": "n.f. 调味汁，酱油",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 815,
    "word": "autre",
    "phonetic": "[otr]",
    "type": "",
    "translation": "a. 别的，另外的；不同的，不一样的；第二个，另一个",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 816,
    "word": "entre",
    "phonetic": "[ɑ̃tr]",
    "type": "",
    "translation": "prép. 在……之间；在……中间",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 817,
    "word": "cou",
    "phonetic": "[ku]",
    "type": "",
    "translation": "n.m. 颈，脖子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 818,
    "word": "rapprocher",
    "phonetic": "[raprɔ∫e]",
    "type": "",
    "translation": "v.t. 使更靠近，使更接近；使临近；使亲密 v.i. 剩下，留下，停留；逗留；留在某处不动；保持，处",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 819,
    "word": "tour",
    "phonetic": "[tur]",
    "type": "",
    "translation": "转的一周，一圈；巧妙的动作，技艺；诡计，花招；轮 班，轮值；n.f. 塔，楼；城楼，炮楼 a. 壮丽的，宏伟的；豪华的；极美的；极好的；很出色",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 820,
    "word": "magnifique",
    "phonetic": "[maɲifik]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 821,
    "word": "hôtel",
    "phonetic": "[otεl]",
    "type": "",
    "translation": "n.m. 旅馆，宾馆；办公大楼 v.t. 看见；观看；参观；经历；碰见；会见；看望；细",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 822,
    "word": "comme",
    "phonetic": "[kɔm]",
    "type": "",
    "translation": "例如；由于，因为；既然；多么；怎么，怎样",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 823,
    "word": "régulier",
    "phonetic": "[regylje, -εr]",
    "type": "",
    "translation": "a. 有规律的；规矩的；定期的；经常的；合法的 prép. [表时间]在……以前；[表空间]在……前面；[表次",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 824,
    "word": "avant",
    "phonetic": "[avɑ̃]",
    "type": "",
    "translation": "序、等级]在……之上，在……之前；优先；n.m. 前部； [体]前锋；[军]前线 n.f. 方式，方法；风格，手法；pl. 态度，举止；矫揉造",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 825,
    "word": "manière",
    "phonetic": "[manjεr]",
    "type": "",
    "translation": "作 n.m. 最小量，最少量，最低额，最低值，最低程度，最",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 826,
    "word": "minimum",
    "phonetic": "[minimɔm]",
    "type": "",
    "translation": "低限度 v.t.,v.pr. 超出，追过；高出；胜过；互相追赶；超过自",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 827,
    "word": "dépasser",
    "phonetic": "[depase]",
    "type": "",
    "translation": "己原有的水平或能力等",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 828,
    "word": "côte",
    "phonetic": "[kot]",
    "type": "",
    "translation": "n.f.坡道；山坡；海岸，海滨；[解]肋骨；肋，肋部",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 829,
    "word": "pyramide",
    "phonetic": "[piramid]",
    "type": "",
    "translation": "n.f. 金字塔；[数]棱锥（体），角锥（体）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 830,
    "word": "lui",
    "phonetic": "[lɥi]",
    "type": "",
    "translation": "pron.pers. 他，她，它 v.t. 做出，创造，制造；创作；制订；做，干，进行，实",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 831,
    "word": "quelque",
    "phonetic": "[kεlkə]",
    "type": "",
    "translation": "ou [kεlk] 修饰数词]；pl.几个；少量",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 832,
    "word": "partenaire",
    "phonetic": "[partənεr]",
    "type": "",
    "translation": "n. 伙伴，合伙人；搭档",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 833,
    "word": "donc",
    "phonetic": "[dɔ̃k]",
    "type": "",
    "translation": "conj. 所以，因而，因此，故；那么，得啦，到底，究竟",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 834,
    "word": "réel",
    "phonetic": "[reεl]",
    "type": "",
    "translation": "a. 真的，真正的，真实的；现实的；确实的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 835,
    "word": "huit",
    "phonetic": "[ɥit]",
    "type": "",
    "translation": "虚音H adj.num.card.， adj.inv. 八；第八",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 836,
    "word": "soir",
    "phonetic": "[swar]",
    "type": "",
    "translation": "n.m. 傍晚，黄昏；晚间，晚上",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 837,
    "word": "heure",
    "phonetic": "[œr]",
    "type": "",
    "translation": "n.f. 小时；时间；点钟；钟点；时刻，时期",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 838,
    "word": "face",
    "phonetic": "[fas]",
    "type": "",
    "translation": "n.f. 脸，面部；表面；（物体的）面；面貌；方面；局面",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 839,
    "word": "moins",
    "phonetic": "[mwɛ̃]",
    "type": "",
    "translation": "adv. 减；差；负；比……少，不如；最少，最不",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 840,
    "word": "train",
    "phonetic": "[trɛ̃]",
    "type": "",
    "translation": "n.m. 列车，火车；（车船等的）队列；系，组，列 adj.num.card.， adj.inv. （第）十一 ；第十一号房间",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 841,
    "word": "onze",
    "phonetic": "[ɔ̃z]",
    "type": "",
    "translation": "或桌子；（一个月份的）十一日；（11人组成的）足球 队 13 of 35 单词 音标 解释 No. n.m. 步，步子，步伐，步履；一步的距离；脚印，足",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 842,
    "word": "pas",
    "phonetic": "[pa]",
    "type": "",
    "translation": "迹；舞步",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 843,
    "word": "seulement",
    "phonetic": "[sœlmɑ̃]",
    "type": "",
    "translation": "adv. 只，仅仅；刚刚；不过",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 844,
    "word": "trois",
    "phonetic": "[trwa]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 三 v.t. 放，置，摆；送入，使进入；安置；戴，穿；配，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 845,
    "word": "qui",
    "phonetic": "[ki]",
    "type": "",
    "translation": "（人、事、物）；任何人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 846,
    "word": "repos",
    "phonetic": "[r(ə)po]",
    "type": "",
    "translation": "n.m. 休息；睡眠；安静，安宁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 847,
    "word": "homme",
    "phonetic": "[ɔm]",
    "type": "",
    "translation": "n.m. 人；人类；男人；男子汉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 848,
    "word": "pied",
    "phonetic": "[pje]",
    "type": "",
    "translation": "n.m. 脚，足；步伐；基部；英尺",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 849,
    "word": "transport",
    "phonetic": "[trɑ̃spɔr]",
    "type": "",
    "translation": "n.m. 运输，搬运，运送",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 850,
    "word": "jour",
    "phonetic": "[ʒur]",
    "type": "",
    "translation": "n.m. 天，日子；太阳光；白天",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 851,
    "word": "chaque",
    "phonetic": "[∫ak]",
    "type": "",
    "translation": "a.indéf.(整体中的)每个, 各个;每一个 adv. 也，同样，一样；还，此外；如此，这样；因此，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 852,
    "word": "aussi",
    "phonetic": "[osi]",
    "type": "",
    "translation": "所以，因而",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 853,
    "word": "plus",
    "phonetic": "[plys]",
    "type": "",
    "translation": "[ply] adv. 加，加上，外加；比……更；不再，再没",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 854,
    "word": "sévère",
    "phonetic": "[sevεr]",
    "type": "",
    "translation": "a. 严厉的；严格的，严酷的；朴素的；严重的，重大的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 855,
    "word": "fureur",
    "phonetic": "[fyrœr]",
    "type": "",
    "translation": "n.f. 狂怒，盛怒，暴怒；激烈，猛烈，狂暴；狂热，迷恋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 856,
    "word": "sauvage",
    "phonetic": "[sovaʒ]",
    "type": "",
    "translation": "a. 野生的；荒无人烟的；凶残的；粗野的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 857,
    "word": "vivement",
    "phonetic": "[vivmɑ̃]",
    "type": "",
    "translation": "adv. 急速地，迅速地；强烈地，深深地；非常，十分 500 tous 全体的，所有的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 858,
    "word": "son",
    "phonetic": "[sɔ̃]",
    "type": "",
    "translation": "n.m. 音，声音 / adj. 他（她、它）的 n.m. 小圆点；标点；句号；分数；百分点；地方；要",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 859,
    "word": "point",
    "phonetic": "[pwɛ̃]",
    "type": "",
    "translation": "点；程度",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 860,
    "word": "peu",
    "phonetic": "[pø]",
    "type": "",
    "translation": "adv. 少，不多；不太",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 861,
    "word": "elle",
    "phonetic": "[εl]",
    "type": "",
    "translation": "pron.pers.f. 她，它",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 862,
    "word": "wagon",
    "phonetic": "[vagɔ̃]",
    "type": "",
    "translation": "n.m.（火车）车厢；一车厢的货物 506 toute （阴性）任何，每一个 a. 大的，高大的；广阔的，宽广的；强烈的，剧烈的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 863,
    "word": "grand",
    "phonetic": "[grɑ̃, -d]",
    "type": "",
    "translation": "多的，大量的；长大的，成年的；重要的，重大的；伟大 的，杰出的 zhèi 1. (代) (常用在量词或数量词前) ce, cette ce livre",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 864,
    "word": "cette",
    "phonetic": "[sεt]",
    "type": "",
    "translation": "这本书 2. 另见 zhè。 zhè 1. (代) (指示较近的人或事 物) ce; cet ...",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 865,
    "word": "ville",
    "phonetic": "[vil]",
    "type": "",
    "translation": "n.f. 城市，都市；全城居民；城市生活 prép.， n.m. 经过，通过，从；走遍，跑遍；在…地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 866,
    "word": "par",
    "phonetic": "[par]",
    "type": "",
    "translation": "方：在…时候；按照，每；被，由；用，以，通过；由 于，出于；以…的名义；以 a. 可怕的，骇人的；令人讨厌的，叫人难受的；猛烈",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 867,
    "word": "terrible",
    "phonetic": "[teribl]",
    "type": "",
    "translation": "ou [tεribl] 的；非常多的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 868,
    "word": "certain",
    "phonetic": "[sεrtɛ̃, -εn]",
    "type": "",
    "translation": "a. 肯定的；确定的；确实的，确凿的；确信的；一些 prép. 在…家，在…那里；到…家，到…那里；在…家",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 869,
    "word": "chez",
    "phonetic": "[∫e]",
    "type": "",
    "translation": "乡；在…地方；在…时代；在…中；在…身上；在…作品 里",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 870,
    "word": "effet",
    "phonetic": "[efε]",
    "type": "",
    "translation": "n.m. 效果，作用；结果；效力；影响；[物，生]效应",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 871,
    "word": "encore",
    "phonetic": "[ɑ̃kɔr]",
    "type": "",
    "translation": "adv. 还，尚，仍；还不，还没有；再，又，重新 14 of 35 单词 音标 解释 No. v.t. 说，讲；告诉，讲述；（用某一种语言）表达；朗",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 872,
    "word": "assez",
    "phonetic": "[ase]",
    "type": "",
    "translation": "adv. 够，足够；相当；非常 v.t. 数；计算；算上，包括；拥有；算入，算作；v.i.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 873,
    "word": "dit",
    "phonetic": "[di, -t]",
    "type": "",
    "translation": "的；上述的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 874,
    "word": "sou",
    "phonetic": "[su]",
    "type": "",
    "translation": "n.m. 苏；pl. 钱",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 875,
    "word": "mai",
    "phonetic": "[mε]",
    "type": "",
    "translation": "n.m. 五月 a. 概括的，一般的；笼统的；普遍的，普通的，通常",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 876,
    "word": "général",
    "phonetic": "[ʒeneral]",
    "type": "",
    "translation": "的；总的，全体的，全部的；n.m. 一般，全体，全面； （陆、空军）上将；将军",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 877,
    "word": "cet",
    "phonetic": "[sεt]",
    "type": "",
    "translation": "这， 这些",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 878,
    "word": "habitant",
    "phonetic": "[abitɑ̃]",
    "type": "",
    "translation": "n. 居民，人口；居住者 n.m. 百万；百万法郎、百万元或百万镑等；巨大数目，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 879,
    "word": "million",
    "phonetic": "[miljɔ̃]",
    "type": "",
    "translation": "许许多多， 无数；一万法郎[按旧法郎一百万法郎折合新 法郎一百万生丁计算]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 880,
    "word": "vingt",
    "phonetic": "[vɛ̃]",
    "type": "",
    "translation": "adj.num.card. 二十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 881,
    "word": "population",
    "phonetic": "[pɔpylasjɔ̃]",
    "type": "",
    "translation": "n.f. 人口；（全体）居民",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 882,
    "word": "que",
    "phonetic": "[kə]",
    "type": "",
    "translation": "么， 什么东西， 什么事",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 883,
    "word": "enchanté",
    "phonetic": "[ɑ̃∫ɑ̃te]",
    "type": "",
    "translation": "a. 中魔法的；非常高兴的 v.t. 使熔化；使溶解，使融化；铸造；使合并，使融合；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 884,
    "word": "fondre",
    "phonetic": "[fɔ̃dr]",
    "type": "",
    "translation": "v.i. 熔化；溶解；融化",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 885,
    "word": "chaussure",
    "phonetic": "[∫osyr]",
    "type": "",
    "translation": "n.f. 鞋，靴",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 886,
    "word": "trop",
    "phonetic": "[tro]",
    "type": "",
    "translation": "adv. 太 v.i. 是；在，处在；存在，有；n.m. 存在，生存；存在",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 887,
    "word": "compagnon",
    "phonetic": "[kɔ̃paɲɔ̃]",
    "type": "",
    "translation": "n.m. 同伴，伙伴，伴侣，同事；同居男友",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 888,
    "word": "meilleur",
    "phonetic": "[mεjœr]",
    "type": "",
    "translation": "a. 较好的，更好的；n.m. 最好",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 889,
    "word": "prêt",
    "phonetic": "[prε]",
    "type": "",
    "translation": "n.m. 出借；贷款",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 890,
    "word": "secours",
    "phonetic": "[səkur]",
    "type": "",
    "translation": "n.m. 援助，援救；救济；救护；帮助；援兵",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 891,
    "word": "détacher",
    "phonetic": "[deta∫e]",
    "type": "",
    "translation": "v.t. 解开，拆开；卸下；裁下，撕下；派遣；使脱离",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 892,
    "word": "pression",
    "phonetic": "[prεsjɔ̃]",
    "type": "",
    "translation": "n.f. 压，按，揿；[技]压力；压强；逼迫，压制，压力 v.i. 吹哨；鸣笛；嘘嘘作响，呼啸；v.t. 用口哨吹；吹哨",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 893,
    "word": "siffler",
    "phonetic": "[sifle]",
    "type": "",
    "translation": "叫唤；吹哨宣布；发出嘘声反对；一饮而尽",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 894,
    "word": "parmi",
    "phonetic": "[parmi]",
    "type": "",
    "translation": "prép. 在……之中",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 895,
    "word": "soin",
    "phonetic": "[swɛ̃]",
    "type": "",
    "translation": "n.m. 细心，用心，仔细；照管，照看；pl. 治疗 v.t. 使成形；组成，建立；构成，形成；培养，训练，造",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 896,
    "word": "bois",
    "phonetic": "[bwa]",
    "type": "",
    "translation": "n.m. 树木，树林；木，木材；木制品",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 897,
    "word": "capitaine",
    "phonetic": "[kapitεn]",
    "type": "",
    "translation": "n.m. 船长；上尉；队长；头目",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 898,
    "word": "cheveu",
    "phonetic": "[∫(ə)vø]",
    "type": "",
    "translation": "n.m. 头发 v.t.， v.pr. 1.运输， 搬运； 2.使十分激动； 3.转让，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 899,
    "word": "bateau",
    "phonetic": "[bato]",
    "type": "",
    "translation": "n.m. 船，艇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 900,
    "word": "été",
    "phonetic": "[ete]",
    "type": "",
    "translation": "n.m. 夏，夏季，夏天 v.t. 带，领；运送；导往，通向；领导，指挥；执行；进",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 901,
    "word": "offre",
    "phonetic": "[ɔfr]",
    "type": "",
    "translation": "n.f. 提供；提出，提议；要约；开价，报价 v. t. 宣布，宣告；讲，说；发表，宣读； v.i. 宣判；做",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 902,
    "word": "prononcer",
    "phonetic": "[prɔnɔ̃se]",
    "type": "",
    "translation": "出决定，表态",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 903,
    "word": "débarquer",
    "phonetic": "[debarke]",
    "type": "",
    "translation": "v.t. 下（客）；卸（货）；v.i. 下船；下飞机；下火车 v.t. 再带来；带回来；把……放回原处；使恢复到原来的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 904,
    "word": "décidé",
    "phonetic": "[deside]",
    "type": "",
    "translation": "a. 坚决的，果断的；已决定的，既定的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 905,
    "word": "livrer",
    "phonetic": "[livre]",
    "type": "",
    "translation": "v.t. 交出，交给；送交；丢弃；出卖；叛变；交（货）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 906,
    "word": "profondeur",
    "phonetic": "[prɔfɔ̃dœr]",
    "type": "",
    "translation": "n.f. 深，深度；深刻，深入；深奥 a. 固体的；坚固的，牢固的，稳固的；结实的，强壮",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 907,
    "word": "solide",
    "phonetic": "[sɔlid]",
    "type": "",
    "translation": "的；耐劳的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 908,
    "word": "bouquet",
    "phonetic": "[bukε]",
    "type": "",
    "translation": "n.m. 花束；束，扎，簇，串 n.f. 地道；走廊，长廊；（陈列艺术品的）厅；画廊，陈",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 909,
    "word": "galerie",
    "phonetic": "[galri]",
    "type": "",
    "translation": "列廊 v.t. 指出，指示；出示；炫耀，卖弄；说明，表明；显",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 910,
    "word": "trente",
    "phonetic": "[trɑ̃t]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 三十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 911,
    "word": "indien",
    "phonetic": "[ɛ̃djɛ̃, -εn]",
    "type": "",
    "translation": "adj.， n. 印度的；印第安的；印度人；印第安人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 912,
    "word": "troupe",
    "phonetic": "[trup]",
    "type": "",
    "translation": "n.f. 军队，部队；士兵；群，队；剧团",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 913,
    "word": "droit",
    "phonetic": "[drwa, -t]",
    "type": "",
    "translation": "n.m. 权利；税；法律，法规；adj. 直的；adv. 笔直",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 914,
    "word": "société",
    "phonetic": "[sɔsjete]",
    "type": "",
    "translation": "n.f. 社会；社交界；协会，社团；公司；群居，群居生活",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 915,
    "word": "individu",
    "phonetic": "[ɛ̃dividy]",
    "type": "",
    "translation": "n.m. 个体；个人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 916,
    "word": "repousser",
    "phonetic": "[rəpuse]",
    "type": "",
    "translation": "v.t.， v.pr. 1.推开；击退； 2.排斥；拒绝；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 917,
    "word": "payé",
    "phonetic": "[peje]",
    "type": "",
    "translation": "受雇的；付清，报偿 a. 诚实的；正直的；善良的；适当的，适中的；令人满",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 918,
    "word": "honnête",
    "phonetic": "[ɔnεt]",
    "type": "",
    "translation": "意的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 919,
    "word": "constater",
    "phonetic": "[kɔ̃state]",
    "type": "",
    "translation": "v.t. 1.看到，观察到； 2.确认；了解，查明 n.m. 座位，椅子；席位；所在地；中心，中枢；[军]包",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 920,
    "word": "siège",
    "phonetic": "[sjεʒ]",
    "type": "",
    "translation": "围",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 921,
    "word": "impatience",
    "phonetic": "[ɛ̃pasjɑ̃s]",
    "type": "",
    "translation": "n.f. 无耐心，性急；焦急，不耐烦",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 922,
    "word": "poche",
    "phonetic": "[pɔ∫]",
    "type": "",
    "translation": "n.f. 衣袋，口袋；袋，包",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 923,
    "word": "confiance",
    "phonetic": "[kɔ̃fjɑ̃s]",
    "type": "",
    "translation": "n.f. 相信，信任，信心",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 924,
    "word": "chant",
    "phonetic": "[∫ɑ̃]",
    "type": "",
    "translation": "n.m. 歌唱；歌声；歌曲 16 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 925,
    "word": "cesser",
    "phonetic": "[sese]",
    "type": "",
    "translation": "ou [sɛse] v.t. 停止，终止；中断 prép. 不管（某人的阻挡），不顾（某人的反对）；虽",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 926,
    "word": "malgré",
    "phonetic": "[malgre]",
    "type": "",
    "translation": "然，尽管",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 927,
    "word": "nourriture",
    "phonetic": "[nurityr]",
    "type": "",
    "translation": "n.f. 食物；膳食；（精神）食粮，养料",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 928,
    "word": "interminable",
    "phonetic": "[ɛ̃tεrminabl]",
    "type": "",
    "translation": "adj. 无休止的，无止境的，没完没了的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 929,
    "word": "membre",
    "phonetic": "[mɑ̃br]",
    "type": "",
    "translation": "n.m. 成员，一分子；肢",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 930,
    "word": "scène",
    "phonetic": "[sεn]",
    "type": "",
    "translation": "n.f. 舞台；布景；现场；（戏剧的）场次；场面，情景",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 931,
    "word": "quelquefois",
    "phonetic": "[kεlkəfwa]",
    "type": "",
    "translation": "adv. 有时，偶尔",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 932,
    "word": "repas",
    "phonetic": "[rəpɑ]",
    "type": "",
    "translation": "n.m. 餐，饭食",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 933,
    "word": "passion",
    "phonetic": "[pasjɔ̃]",
    "type": "",
    "translation": "物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 934,
    "word": "condition",
    "phonetic": "[kɔ̃disjɔ̃]",
    "type": "",
    "translation": "n.f. 条件；（社会）地位，身份；状况；环境，形势",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 935,
    "word": "montagne",
    "phonetic": "[mɔ̃taɲ]",
    "type": "",
    "translation": "n.f. 山，山岳；山区；一大堆 a. 广阔的，宽广的；宽阔的，宽敞的；宏伟的；广泛",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 936,
    "word": "vaste",
    "phonetic": "[vast]",
    "type": "",
    "translation": "的；庞大的；广博的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 937,
    "word": "champ",
    "phonetic": "[∫ɑ̃]",
    "type": "",
    "translation": "n.m. 田，耕地；（活动、研究的）范围，领域；视野",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 938,
    "word": "larme",
    "phonetic": "[larm]",
    "type": "",
    "translation": "n.f. 眼泪 adj. 这样的，这种的；如此的；如同，像…一样；这等",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 939,
    "word": "tel",
    "phonetic": "[tεl]",
    "type": "",
    "translation": "的，如此质量的；到如此程度的；某一个；某某人；某个 [不用冠词]；因而，因此，以致；以使，以便，使得 v.t. 奠定，确立；创办，设立，建立；安排，安置；部",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 940,
    "word": "façon",
    "phonetic": "[fasɔ̃]",
    "type": "",
    "translation": "客气",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 941,
    "word": "admirer",
    "phonetic": "[admire]",
    "type": "",
    "translation": "v.t.赞赏，赞美；观赏；仰慕，钦佩",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 942,
    "word": "hasard",
    "phonetic": "[azar]",
    "type": "",
    "translation": "虚音H n.m. 机遇，巧合；风险；偶然，偶然性 v.t. 盖，覆盖；使布满；走完，行驶（路程）；保护，掩",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 943,
    "word": "couvrir",
    "phonetic": "[kuvrir]",
    "type": "",
    "translation": "护",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 944,
    "word": "île",
    "phonetic": "[il]",
    "type": "",
    "translation": "n.f. 岛，岛屿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 945,
    "word": "instrument",
    "phonetic": "[ɛ̃strymɑ̃]",
    "type": "",
    "translation": "段，方法",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 946,
    "word": "couteau",
    "phonetic": "[kuto]",
    "type": "",
    "translation": "n.m. 刀",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 947,
    "word": "roue",
    "phonetic": "[ru]",
    "type": "",
    "translation": "n.f. 车轮；齿轮；轮状物 n.f. 白的，白色的；洁白的，纯洁的，清洁的；空白的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 948,
    "word": "blanche",
    "phonetic": "[blɑ̃∫]",
    "type": "",
    "translation": "清白的；无通常效果的，形式上的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 949,
    "word": "parole",
    "phonetic": "[parɔl]",
    "type": "",
    "translation": "n.f. 话，话语；讲话；发言；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 950,
    "word": "soldat",
    "phonetic": "[sɔlda]",
    "type": "",
    "translation": "n.m. 军人；士兵",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 951,
    "word": "centaine",
    "phonetic": "[sɑ̃tεn]",
    "type": "",
    "translation": "n.f. 百位数，百个；百来个，近百个 n.m. 情况，场合；机会；事件；案情，案件；处境，境",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 952,
    "word": "cas",
    "phonetic": "[kɑ, ka]",
    "type": "",
    "translation": "况；病例 17 of 35 单词 音标 解释 No. v.t.， v.pr. 攻击，进攻；抨击控告，起诉；责问， 质",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 953,
    "word": "attaquer",
    "phonetic": "[atake]",
    "type": "",
    "translation": "询；力求战胜； 腐蚀，侵蚀，损坏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 954,
    "word": "mort",
    "phonetic": "[mɔr]",
    "type": "",
    "translation": "n.f. 死，死亡；灭亡，毁灭，完结",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 955,
    "word": "intention",
    "phonetic": "[ɛ̃tɑ̃sjɔ̃]",
    "type": "",
    "translation": "n.f. 意图，意向；意愿；目的，打算",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 956,
    "word": "poursuivre",
    "phonetic": "[pursɥivr]",
    "type": "",
    "translation": "v.t. 追，追逐；追捕；追求；继续；纠缠；[法]起诉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 957,
    "word": "volonté",
    "phonetic": "[vɔlɔ̃te]",
    "type": "",
    "translation": "n.f. 愿望，意愿；意志，毅力；意图，意向",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 958,
    "word": "masse",
    "phonetic": "[mas]",
    "type": "",
    "translation": "n.f. 1.块；股，团；堆； 2.总量，全体；群",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 959,
    "word": "tant",
    "phonetic": "[tɑ̃]",
    "type": "",
    "translation": "此…以至于 n.m. 沙漠；荒无人烟的地方；偏僻的地方；a. 荒无人烟",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 960,
    "word": "désert",
    "phonetic": "[dezεr, -t]",
    "type": "",
    "translation": "的，荒凉的；冷清的，僻静的 v.t.， v.pr. 1.下降，降低， 2.声音等减弱， 3.衰退，跌",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 961,
    "word": "baisser",
    "phonetic": "[bese]",
    "type": "",
    "translation": "ou [bεse] 价",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 962,
    "word": "fortune",
    "phonetic": "[fɔrtyn]",
    "type": "",
    "translation": "n.f. 财产，财富；命运；好运；恶运 n.f. 自然（界）；本性，本质；性格，性情；实物[与货",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 963,
    "word": "nature",
    "phonetic": "[natyr]",
    "type": "",
    "translation": "币相对而言]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 964,
    "word": "neige",
    "phonetic": "[nεʒ]",
    "type": "",
    "translation": "n.f. 雪；滑雪站；滑雪运动",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 965,
    "word": "revenu",
    "phonetic": "[rəvny]",
    "type": "",
    "translation": "n.m. 收入，收益",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 966,
    "word": "suite",
    "phonetic": "[sɥit]",
    "type": "",
    "translation": "n.f. 继续，一系列；顺序；连贯；后果；后续部分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 967,
    "word": "voyageur",
    "phonetic": "[vwajaʒœr]",
    "type": "",
    "translation": "n. 旅行者；旅客，乘客；旅行家；游客",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 968,
    "word": "instant",
    "phonetic": "[ɛ̃stɑ̃]",
    "type": "",
    "translation": "a. 紧迫的，迫切的，紧急的；n.m. 瞬间，瞬时，顷刻",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 969,
    "word": "satisfaction",
    "phonetic": "[satisfaksjɔ̃]",
    "type": "",
    "translation": "n.f. 满意，满足；高兴，愉快",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 970,
    "word": "banc",
    "phonetic": "[bɑ̃]",
    "type": "",
    "translation": "n.m. 长凳，长椅；席位 v.t. 使再接合；和……相接；重新加入；和……重聚；重",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 971,
    "word": "rejoindre",
    "phonetic": "[r(ə)ʒwɛ̃dr]",
    "type": "",
    "translation": "返，回到；赶上，追上",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 972,
    "word": "perdu",
    "phonetic": "[pεrdy]",
    "type": "",
    "translation": "adj. 失去的；错过的；迷路的；没有希望的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 973,
    "word": "durer",
    "phonetic": "[dyre]",
    "type": "",
    "translation": "v.i. 持续，延续；持续很久，拖延很长时间；持久；保持",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 974,
    "word": "certainement",
    "phonetic": "[sεrtεnmɑ̃]",
    "type": "",
    "translation": "adv. 肯定地，一定地；确实地，当然",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 975,
    "word": "salle",
    "phonetic": "[sal]",
    "type": "",
    "translation": "n.f. 房间；客厅；厅，室",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 976,
    "word": "poliment",
    "phonetic": "[pɔlimɑ̃]",
    "type": "",
    "translation": "adv. 礼貌地，彬彬有礼地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 977,
    "word": "honneur",
    "phonetic": "[ɔnœr]",
    "type": "",
    "translation": "n.m. 荣誉；尊严，自尊；名誉；光荣；尊敬，敬意",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 978,
    "word": "presser",
    "phonetic": "[prεse]",
    "type": "",
    "translation": "v.t. 压榨，挤；压，按，揿；催促；加速，加快 18 of 35 单词 音标 解释 No. v.i. 再上，重新登上；重新北上；重新上升；回涨，重新",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 979,
    "word": "remonter",
    "phonetic": "[r(ə)mɔ̃te]",
    "type": "",
    "translation": "上涨；追溯，回溯；起始于；v.t. 重登，再上；重新往上 搬；提高，使增高；使精神振作；重新装配 n.f. 价值；价格；才能；有效，有效性；[数]值；pl. 准",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 980,
    "word": "valeur",
    "phonetic": "[valœr]",
    "type": "",
    "translation": "则，标准；英勇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 981,
    "word": "saint",
    "phonetic": "[sɛ̃, -t]",
    "type": "",
    "translation": "a. 神圣的；圣洁的；圣的；n. 圣人，圣徒 n.m. 使用，应用；（官能等的）运用；用途；惯例；用",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 982,
    "word": "usage",
    "phonetic": "[yzaʒ]",
    "type": "",
    "translation": "法",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 983,
    "word": "avance",
    "phonetic": "[avɑ̃s]",
    "type": "",
    "translation": "n.f. 前进；提前，提早",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 984,
    "word": "rail",
    "phonetic": "[rɑj]",
    "type": "",
    "translation": "n.m. 铁轨，钢轨；轨道；铁路",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 985,
    "word": "reconnaissance",
    "phonetic": "[rəkɔnεsɑ̃s]",
    "type": "",
    "translation": "n.f. 认识，认出；承认，确认；侦察；感激",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 986,
    "word": "grimace",
    "phonetic": "[grimas]",
    "type": "",
    "translation": "n.f. 鬼脸，怪相 adv. 合乎自然规律地；天然地；必然地；当然；生来；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 987,
    "word": "naturellement",
    "phonetic": "[natyrεlmɑ̃]",
    "type": "",
    "translation": "自然地，不加做作地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 988,
    "word": "loi",
    "phonetic": "[lwa]",
    "type": "",
    "translation": "n.f. 法，法律；[宗]戒律；规则；法则；规律，定律",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 989,
    "word": "acte",
    "phonetic": "[akt]",
    "type": "",
    "translation": "n.m. 行动，动作，行为；证书；文件；契约；[剧]幕",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 990,
    "word": "violence",
    "phonetic": "[vjɔlɑ̃s]",
    "type": "",
    "translation": "n.f. 猛烈，激烈；暴力，强暴；粗暴",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 991,
    "word": "fil",
    "phonetic": "[fil]",
    "type": "",
    "translation": "n.m. 纱；线；丝；导线，电线",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 992,
    "word": "forêt",
    "phonetic": "[fɔrε]",
    "type": "",
    "translation": "n.f. 林，森林；林立 prép.， adv. 那是，那就是；这是，这就是；以上就",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 993,
    "word": "voilà",
    "phonetic": "[vwala]",
    "type": "",
    "translation": "是，上面就是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 994,
    "word": "campagne",
    "phonetic": "[kɑ̃paɲ]",
    "type": "",
    "translation": "n.f. 原野；农村，乡村；出征，战役；活动；运动",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 995,
    "word": "hauteur",
    "phonetic": "[otœr]",
    "type": "",
    "translation": "虚音H n.f. 高，高度；海拔；高地；高超；高尚",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 996,
    "word": "quartier",
    "phonetic": "[kartje]",
    "type": "",
    "translation": "n.m. 四分之一部分；块，片；街区；区；住宅区",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 997,
    "word": "nombreux",
    "phonetic": "[nɔ̃brø]",
    "type": "",
    "translation": "a. 为数众多的；许多",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 998,
    "word": "surtout",
    "phonetic": "[syrtu]",
    "type": "",
    "translation": "adv. 特别；尤其 n.f. 1.透视；景色；展望； 2.前景； 3.观点，角度，眼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 999,
    "word": "perspective",
    "phonetic": "[pεrspεktiv]",
    "type": "",
    "translation": "光",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1000,
    "word": "heureusement",
    "phonetic": "[œrøzmɑ̃]",
    "type": "",
    "translation": "adv. 完满地；幸好",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1001,
    "word": "émotion",
    "phonetic": "[emosjɔ̃]",
    "type": "",
    "translation": "n.f. 感动，激动；感情",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1002,
    "word": "visage",
    "phonetic": "[vizaʒ]",
    "type": "",
    "translation": "n.m. 脸，面孔；人；面容，脸色；面貌，外观 v.t. 留痕迹；留下印记；做记号；记录；（仪器）指示；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1003,
    "word": "marquer",
    "phonetic": "[marke]",
    "type": "",
    "translation": "表示",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1004,
    "word": "dent",
    "phonetic": "[dɑ̃]",
    "type": "",
    "translation": "n.f. 牙，牙齿；齿状物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1005,
    "word": "retentir",
    "phonetic": "[rətɑ̃tir]",
    "type": "",
    "translation": "v.i. 充满响声，产生回响；回荡；产生反响，引起反应 a. 悲伤的；忧愁的；令人难过的，悲惨的；阴暗的，阴",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1006,
    "word": "triste",
    "phonetic": "[trist]",
    "type": "",
    "translation": "沉的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1007,
    "word": "éprouver",
    "phonetic": "[epruve]",
    "type": "",
    "translation": "v.t. 试验，检验；考验；使遭受苦难；体验到",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1008,
    "word": "causer",
    "phonetic": "[koze]",
    "type": "",
    "translation": "v.t. 引起，造成；v.i. 交谈，闲谈",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1009,
    "word": "dépenser",
    "phonetic": "[depɑ̃se]",
    "type": "",
    "translation": "v.t. 用（钱），花（钱）；消耗；耗费，花费",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1010,
    "word": "meeting",
    "phonetic": "[mitiŋ]",
    "type": "",
    "translation": "n.m. 集会，会议，会；运动会，演示会 19 of 35 单词 音标 解释 No. n. 1.目击者， 目睹者； 2.旁观者观众（艺术品或建筑物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1011,
    "word": "spectateur",
    "phonetic": "[spεktatœr]",
    "type": "",
    "translation": "的）参 观者 n.f. 弄碎，打碎，弄断；弄碎的东西，打碎的东西，弄断",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1012,
    "word": "casse",
    "phonetic": "[kas]",
    "type": "",
    "translation": "的东西 v.t.（突然）发现，发觉，看出；通知，告知；v.i. 考",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1013,
    "word": "aviser",
    "phonetic": "[avize]",
    "type": "",
    "translation": "虑，思考",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1014,
    "word": "erreur",
    "phonetic": "[εrœr]",
    "type": "",
    "translation": "ou [erœr] n.f. 错误，谬误；过错；谬论；误差，偏差",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1015,
    "word": "retomber",
    "phonetic": "[rətɔ̃be]",
    "type": "",
    "translation": "种状态]；消失；减弱，减退；落到某人头上，（责任 等）由某人负担",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1016,
    "word": "lèvre",
    "phonetic": "[lεvr]",
    "type": "",
    "translation": "n.f. 唇，嘴唇 v.t.， v.pr. 1.点火，点燃点亮；照亮 2.激起，引起，惹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1017,
    "word": "allumer",
    "phonetic": "[alyme]",
    "type": "",
    "translation": "起 3.打开（暖气，收音机）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1018,
    "word": "plutôt",
    "phonetic": "[plyto]",
    "type": "",
    "translation": "adv. 宁可，宁愿；与其……倒不如；有点儿；相当，挺",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1019,
    "word": "lecture",
    "phonetic": "[lεktyr]",
    "type": "",
    "translation": "n.f. 阅读，阅览；朗读，宣读；解读；读物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1020,
    "word": "désir",
    "phonetic": "[dezir]",
    "type": "",
    "translation": "n.m. 要求；愿望，欲望；性欲",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1021,
    "word": "habitude",
    "phonetic": "[abityd]",
    "type": "",
    "translation": "n.f. 习惯，习俗，惯例；熟练，经验，熟悉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1022,
    "word": "contenter",
    "phonetic": "[kɔ̃tɑ̃te]",
    "type": "",
    "translation": "v.t. 使高兴，使快乐；使满意，使满足 a. 相邻的，邻近的；相近的，相似的；n. 邻居；邻座的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1023,
    "word": "voisin",
    "phonetic": "[vwazɛ̃, -in]",
    "type": "",
    "translation": "人；邻国",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1024,
    "word": "brûler",
    "phonetic": "[bryle]",
    "type": "",
    "translation": "v.t. 焚烧，烧毁；烧焦；烫伤，烧伤",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1025,
    "word": "victime",
    "phonetic": "[viktim]",
    "type": "",
    "translation": "n.f. 受害者；牺牲者；遭难者；死亡者",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1026,
    "word": "facile",
    "phonetic": "[fasil]",
    "type": "",
    "translation": "a. 容易的，方便的；流利的，流畅的；随和的，宽容的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1027,
    "word": "véritable",
    "phonetic": "[veritabl]",
    "type": "",
    "translation": "a. 真实的，确实的；真的；真正的[指名副其实的] v.t. 使固定，使不动；使定居；安置；使停留；确定，规",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1028,
    "word": "chacun",
    "phonetic": "[∫akœ̃]",
    "type": "",
    "translation": "pron.indéf. 各人，每个人；每一个；各物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1029,
    "word": "toile",
    "phonetic": "[twal]",
    "type": "",
    "translation": "n.f. 布， 画布， 画， 布景",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1030,
    "word": "parfum",
    "phonetic": "[parfœ̃]",
    "type": "",
    "translation": "n.m. 芳香，香味；香料，香水；香精",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1031,
    "word": "promenade",
    "phonetic": "[prɔmnad]",
    "type": "",
    "translation": "n.f. 散步；溜达，闲逛",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1032,
    "word": "costume",
    "phonetic": "[kɔstym]",
    "type": "",
    "translation": "n.m. 服装；男式（成套）西服 v.t. 关闭，封闭，堵塞；（用墙等）围住；使停止，使结",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1033,
    "word": "clore",
    "phonetic": "[klɔr]",
    "type": "",
    "translation": "束 v.t. 带走，拿走，运走；夺走，夺去；冲走，卷走；使无",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1034,
    "word": "emporter",
    "phonetic": "[ɑ̃pɔrte]",
    "type": "",
    "translation": "法自制",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1035,
    "word": "conscience",
    "phonetic": "[kɔ̃sjɑ̃s]",
    "type": "",
    "translation": "n.f. 意识，知觉，良心",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1036,
    "word": "demeurer",
    "phonetic": "[dəmœre]",
    "type": "",
    "translation": "v.i. 逗留，停留；居住；继续存在；依然是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1037,
    "word": "moindre",
    "phonetic": "[mwɛ̃dr]",
    "type": "",
    "translation": "a. 较小的；较少的；较弱的；最小的；最少的；最弱的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1038,
    "word": "parfois",
    "phonetic": "[parfwa]",
    "type": "",
    "translation": "adv. 有时候，有时，往往 v.t. 带来，领来；送……到（某地），运……到（某",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1039,
    "word": "amener",
    "phonetic": "[amne]",
    "type": "",
    "translation": "地）；促使（某人做某事）；导致，造成",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1040,
    "word": "sort",
    "phonetic": "[sɔr]",
    "type": "",
    "translation": "n.m. 命运；境遇；运气，机缘 20 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1041,
    "word": "vérité",
    "phonetic": "[verite]",
    "type": "",
    "translation": "n.f. 真理；真实（性）；真相；真话 a. 快的；迅速的，匆忙的；敏捷的；速成的；n.m. 特快",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1042,
    "word": "rapide",
    "phonetic": "[rapid]",
    "type": "",
    "translation": "列车",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1043,
    "word": "conserver",
    "phonetic": "[kɔ̃sεrve]",
    "type": "",
    "translation": "v.t. 保存，贮藏；保管；保持，保留 a. 本人的，自己的；特有的；本来的，固有的；清洁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1044,
    "word": "propre",
    "phonetic": "[prɔpr]",
    "type": "",
    "translation": "的，干净的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1045,
    "word": "dur",
    "phonetic": "[dyr]",
    "type": "",
    "translation": "的，严峻的；困苦的；冷酷的，无情的 adv. 在外边，在外面；n.m. 外部，外面，外表；周围环",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1046,
    "word": "dehors",
    "phonetic": "[dəɔr]",
    "type": "",
    "translation": "境",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1047,
    "word": "morceau",
    "phonetic": "[mɔrso]",
    "type": "",
    "translation": "[乐]选段 v.t. 举起，提起；拿走，搬走；除去；脱掉（衣服等）；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1048,
    "word": "souffler",
    "phonetic": "[sufle]",
    "type": "",
    "translation": "冲击，刮倒；低声说 v.t. 投，掷，抛，发射；挥，踢；突然说出；发行，发",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1049,
    "word": "autrement",
    "phonetic": "[otrəmɑ̃]",
    "type": "",
    "translation": "adv. 否则，不然；不同，不一样",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1050,
    "word": "hier",
    "phonetic": "[jεr]",
    "type": "",
    "translation": "adv. 昨天，昨日；近来，最近，过去",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1051,
    "word": "jeu",
    "phonetic": "[ʒø]",
    "type": "",
    "translation": "n.m. 游戏，玩耍，娱乐；比赛；赌博；手段，计谋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1052,
    "word": "carte",
    "phonetic": "[kart]",
    "type": "",
    "translation": "n.f. 卡片，薄纸板；纸牌；证件；地图",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1053,
    "word": "favoriser",
    "phonetic": "[favɔrize]",
    "type": "",
    "translation": "v.t. 优待；照顾；支持；促进；帮助；有利于，有助于",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1054,
    "word": "trajet",
    "phonetic": "[traʒε]",
    "type": "",
    "translation": "n.m. 行程，旅程，路程；路线",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1055,
    "word": "perruque",
    "phonetic": "[pεryk]",
    "type": "",
    "translation": "n.f. 假发",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1056,
    "word": "bouillir",
    "phonetic": "[bujir]",
    "type": "",
    "translation": "v.i. 沸滚，沸腾；在开水里烫，在沸滚的液体中煮",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1057,
    "word": "irrésistible",
    "phonetic": "[irezistibl]",
    "type": "",
    "translation": "a. 不可抵抗的；不可抑制的；难以抑制的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1058,
    "word": "brise",
    "phonetic": "[briz]",
    "type": "",
    "translation": "n.f. 凉爽的微风，和风 n.f. 低音，低音弦；男低音（演员）；低音乐器（演奏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1059,
    "word": "basse",
    "phonetic": "[bɑs]",
    "type": "",
    "translation": "者）；低音号；暗礁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1060,
    "word": "établi",
    "phonetic": "[etabli]",
    "type": "",
    "translation": "n.m. 工作台，钳桌",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1061,
    "word": "sombrer",
    "phonetic": "[sɔ̃bre]",
    "type": "",
    "translation": "v.i.， v.t. 沉没；深陷，消失，毁灭",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1062,
    "word": "difficulté",
    "phonetic": "[difikylte]",
    "type": "",
    "translation": "n.f. 难，困难性；费劲，难懂，深奥；困难的事情",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1063,
    "word": "fatigue",
    "phonetic": "[fatig]",
    "type": "",
    "translation": "n.f. 疲乏，劳累 n.m. 圆，圆圈；圈，圆形物；圈子[指常见的人、常从事",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1064,
    "word": "cercle",
    "phonetic": "[sεrkl]",
    "type": "",
    "translation": "的活动]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1065,
    "word": "épaule",
    "phonetic": "[epol]",
    "type": "",
    "translation": "n.f. 肩，肩部",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1066,
    "word": "nez",
    "phonetic": "[ne]",
    "type": "",
    "translation": "n.m. 鼻子；头部，机头",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1067,
    "word": "jeunesse",
    "phonetic": "[ʒœnεs]",
    "type": "",
    "translation": "n.f. 青年时代，青春；成长期；初期 v.t.， v.pr. 1.照亮， 点燃； 2.使具有光彩 3.启发，开",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1068,
    "word": "éclairer",
    "phonetic": "[eklεre]",
    "type": "",
    "translation": "导；说明，解释 21 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1069,
    "word": "vêtement",
    "phonetic": "[vεtmɑ̃]",
    "type": "",
    "translation": "n.m. 衣服，服装",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1070,
    "word": "objet",
    "phonetic": "[ɔbʒε]",
    "type": "",
    "translation": "目的，目标；内容",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1071,
    "word": "logique",
    "phonetic": "[lɔʒik]",
    "type": "",
    "translation": "合乎逻辑的；必然的，合理的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1072,
    "word": "opération",
    "phonetic": "[ɔperasjɔ̃]",
    "type": "",
    "translation": "n.f. 作用，活动；[军]作战，行动；[医]手术",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1073,
    "word": "sentiment",
    "phonetic": "[sɑ̃timɑ̃]",
    "type": "",
    "translation": "n.m. 感觉，知觉，意识；情感；情绪；意见，看法",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1074,
    "word": "rapporter",
    "phonetic": "[rapɔrte]",
    "type": "",
    "translation": "v.t. 再拿来，再带来；添加；汇报；归还原处；送还",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1075,
    "word": "clown",
    "phonetic": "[klun]",
    "type": "",
    "translation": "n.m. 丑角，小丑；滑稽可笑的人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1076,
    "word": "char",
    "phonetic": "[∫ar]",
    "type": "",
    "translation": "n.m. 双轮马车；彩车；坦克",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1077,
    "word": "doigt",
    "phonetic": "[dwa]",
    "type": "",
    "translation": "n.m. 手指，足趾；一指的宽度",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1078,
    "word": "malheureux",
    "phonetic": "[malœrø, øz]",
    "type": "",
    "translation": "a. 不幸的，可怜的；不祥的；不利的；倒霉的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1079,
    "word": "frisson",
    "phonetic": "[frisɔ̃]",
    "type": "",
    "translation": "n.m. 寒颤，颤抖，发抖",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1080,
    "word": "folie",
    "phonetic": "[fɔli]",
    "type": "",
    "translation": "n.f. 疯癫，精神错乱；发疯，疯狂，荒唐；癖好",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1081,
    "word": "principal",
    "phonetic": "[prɛ̃sipal]",
    "type": "",
    "translation": "a. 主要的，首要的，最重要的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1082,
    "word": "pari",
    "phonetic": "[pari]",
    "type": "",
    "translation": "n.m. 打赌；赌注；赌博",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1083,
    "word": "turban",
    "phonetic": "[tyrbɑ̃]",
    "type": "",
    "translation": "n.m. 头巾",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1084,
    "word": "fouler",
    "phonetic": "[fule]",
    "type": "",
    "translation": "v.t.， v.pr. 1.压，榨，挤； 2.行走在...上； 3.扭伤",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1085,
    "word": "réponse",
    "phonetic": "[repɔ̃s]",
    "type": "",
    "translation": "n.f. 回答，答复；回信；答案",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1086,
    "word": "éclater",
    "phonetic": "[eklate]",
    "type": "",
    "translation": "v.i.， v.pr. 1.爆裂，爆炸； 2.突然发出巨响 a. 正方形的，四方的；明确的，断然的；坦率的，果断",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1087,
    "word": "carré",
    "phonetic": "[kare]",
    "type": "",
    "translation": "的；n.m. 正方形，四方形；方形，方形物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1088,
    "word": "reine",
    "phonetic": "[rεn]",
    "type": "",
    "translation": "n.f. 女王；王后",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1089,
    "word": "cependant",
    "phonetic": "[səpɑ̃dɑ̃]",
    "type": "",
    "translation": "adv. 可是，然而，但是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1090,
    "word": "absolu",
    "phonetic": "[apsɔly]",
    "type": "",
    "translation": "a. 绝对的，完全的；专制的，独裁的；专横的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1091,
    "word": "divers",
    "phonetic": "[divεr, -s]",
    "type": "",
    "translation": "a. 各种各样的，不同的；多变的，变换的，多样的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1092,
    "word": "aspect",
    "phonetic": "[aspε]",
    "type": "",
    "translation": "n.m. 外观，外表，外貌；方面，角度；观点 a. 中间的，中部的；中等的；平均的；n.m. 方法；手",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1093,
    "word": "moyen",
    "phonetic": "[mwajɛ̃, -εn]",
    "type": "",
    "translation": "段；pl. 金钱，资财",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1094,
    "word": "moyenne",
    "phonetic": "[mwajεn]",
    "type": "",
    "translation": "n.f. 中等；平均数；及格分数；平均公里",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1095,
    "word": "franchir",
    "phonetic": "[frɑ̃∫ir]",
    "type": "",
    "translation": "v.t. 1.越过，跨过，穿过； 2.克服",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1096,
    "word": "tranquillement",
    "phonetic": "[trɑ̃kilmɑ̃]",
    "type": "",
    "translation": "adv. 平静地， 安稳地 ；温顺地； 柔和地； 忠厚地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1097,
    "word": "sacré",
    "phonetic": "[sakre]",
    "type": "",
    "translation": "a. [宗]神圣的；不可侵犯的；可恶的；绝妙的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1098,
    "word": "bonne",
    "phonetic": "[bɔn]",
    "type": "",
    "translation": "adj.f. 好的；n.f. 女仆，女佣",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1099,
    "word": "chargé",
    "phonetic": "[∫arʒe]",
    "type": "",
    "translation": "a. 载荷的，有负载的；充满的；负责的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1100,
    "word": "reçu",
    "phonetic": "[r(ə)sy]",
    "type": "",
    "translation": "n.m. 收据，收条；a.被接受的；被接收的；收到的 v.t. 悬挂，吊起；绞死，吊死；v.i. 挂着，吊着；下垂，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1101,
    "word": "pendre",
    "phonetic": "[pɑ̃dr]",
    "type": "",
    "translation": "拖下来",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1102,
    "word": "condamnation",
    "phonetic": "[kɔ̃danasjɔ̃]",
    "type": "",
    "translation": "n.f. 判决，宣判；处罚，判刑；谴责，指责",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1103,
    "word": "concours",
    "phonetic": "[kɔ̃kur]",
    "type": "",
    "translation": "n.m. 协助，协作；竞赛，比赛；考试 22 of 35 单词 音标 解释 No. a. 有智力的；聪明的，理解力强的；机智灵巧的，精明",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1104,
    "word": "intelligent",
    "phonetic": "[ɛ̃teliʒɑ̃]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1105,
    "word": "race",
    "phonetic": "[ras]",
    "type": "",
    "translation": "n.f. 人种，种族；[动]种；同一派人 v.i. 提交法官仲裁；v.t. 连累；使名誉受到影响；危害，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1106,
    "word": "compromettre",
    "phonetic": "[kɔ̃prɔmεtr]",
    "type": "",
    "translation": "损害",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1107,
    "word": "entrevoir",
    "phonetic": "[ɑ̃trəvwar]",
    "type": "",
    "translation": "v.t. 隐约看见，模糊看见；瞥见；模糊地预感到",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1108,
    "word": "poing",
    "phonetic": "[pwɛ̃]",
    "type": "",
    "translation": "n.m. 拳，拳头 v.t. 翻转；颠倒；弄乱；使混乱；打翻，推倒；推翻；颠",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1109,
    "word": "renverser",
    "phonetic": "[rɑ̃vεrse]",
    "type": "",
    "translation": "覆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1110,
    "word": "récit",
    "phonetic": "[resi]",
    "type": "",
    "translation": "n.m. 叙述，记述",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1111,
    "word": "navire",
    "phonetic": "[navir]",
    "type": "",
    "translation": "n.m. 船舶，船，军舰",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1112,
    "word": "bâtiment",
    "phonetic": "[bɑtimɑ̃]",
    "type": "",
    "translation": "n.m. 建筑物；建筑；建筑业；船舶，巨轮",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1113,
    "word": "vapeur",
    "phonetic": "[vapœr]",
    "type": "",
    "translation": "n.f. 蒸气；蒸汽，汽",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1114,
    "word": "consulter",
    "phonetic": "[kɔ̃sylte]",
    "type": "",
    "translation": "v.t. 请教，咨询；求医；查阅，查考",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1115,
    "word": "obstacle",
    "phonetic": "[ɔpstakl]",
    "type": "",
    "translation": "n.m. 障碍（物）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1116,
    "word": "perte",
    "phonetic": "[pεrt]",
    "type": "",
    "translation": "n.f. 丢失；丧失；消失；损失；死亡；输，失败",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1117,
    "word": "disposition",
    "phonetic": "[dispozisjɔ̃]",
    "type": "",
    "translation": "n.f. 安排，布置，布局；支配权，使用权；条文，条款",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1118,
    "word": "paquebot",
    "phonetic": "[pakbo]",
    "type": "",
    "translation": "n.m. 大型客轮，邮船，远洋航轮",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1119,
    "word": "bazar",
    "phonetic": "[bazar]",
    "type": "",
    "translation": "n.m.（东方、北非的）集市，市场；商场，百货商店",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1120,
    "word": "mets",
    "phonetic": "[mε]",
    "type": "",
    "translation": "n.m. 菜肴， 盘装菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1121,
    "word": "métropolitain",
    "phonetic": "[metrɔpɔlitɛ̃]",
    "type": "",
    "translation": "a. 大都会的，大城市的；首府的，首都的；宗主国的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1122,
    "word": "physionomie",
    "phonetic": "[fizjɔnɔmi]",
    "type": "",
    "translation": "n.f. 相貌，容貌；面部表情；面貌，特点，特征",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1123,
    "word": "moi",
    "phonetic": "[mwa]",
    "type": "",
    "translation": "pron.pers. 我； 自我",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1124,
    "word": "prolongé",
    "phonetic": "[prɔlɔ̃ʒe]",
    "type": "",
    "translation": "adj. 持久的，持续时间长的；延长的，延伸的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1125,
    "word": "fleuve",
    "phonetic": "[flœv]",
    "type": "",
    "translation": "n.m. 江，河，川 v.t.， v.pr. 1.上船；上火车； 2.卷入，投入 3.装上船；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1126,
    "word": "embarquer",
    "phonetic": "[ɑ̃barke]",
    "type": "",
    "translation": "使上车； 4.开始，着手",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1127,
    "word": "connu",
    "phonetic": "[kɔny]",
    "type": "",
    "translation": "a. 认识的，已知的；著名的，众所周知的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1128,
    "word": "foi",
    "phonetic": "[fwa]",
    "type": "",
    "translation": "n.f. 信用；信仰，宗教信仰；信任，信赖；诺言，保证",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1129,
    "word": "précieux",
    "phonetic": "[presjø]",
    "type": "",
    "translation": "a. 珍贵的，贵重的；可贵的，宝贵的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1130,
    "word": "circonstance",
    "phonetic": "[sirkɔ̃stɑ̃s]",
    "type": "",
    "translation": "n.f. 情况，状况，环境；时机，形势",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1131,
    "word": "franc",
    "phonetic": "[frɑ̃]",
    "type": "",
    "translation": "a. 坦率的，直率的；明确的；免税的；n.m. 法郎",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1132,
    "word": "fonder",
    "phonetic": "[fɔ̃de]",
    "type": "",
    "translation": "v.t. 创建，创办，创立，缔造；设立",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1133,
    "word": "comptoir",
    "phonetic": "[kɔ̃twar]",
    "type": "",
    "translation": "n.m. 柜台；（酒）吧台；商行；银行",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1134,
    "word": "égal",
    "phonetic": "[egal]",
    "type": "",
    "translation": "a. 相等的；同等的，同样的；势均力敌的；平等的 a. 狭的，窄的；狭隘的，局限的；紧的；密切的，亲密",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1135,
    "word": "étroit",
    "phonetic": "[etrwa, -t]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1136,
    "word": "rafale",
    "phonetic": "[rafal]",
    "type": "",
    "translation": "n.f. 阵风，狂风；意外事故；连射",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1137,
    "word": "sacrifice",
    "phonetic": "[sakrifis]",
    "type": "",
    "translation": "n.m. [宗]祭品，供品，牺牲（品）；牺牲，献身 n.f. 船舱；小室；电梯间；空中索道间；车辆驾驶室；飞",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1138,
    "word": "cabine",
    "phonetic": "[kabin]",
    "type": "",
    "translation": "机驾驶舱 23 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1139,
    "word": "guider",
    "phonetic": "[gide]",
    "type": "",
    "translation": "v.t. 带领；给（某人）做向导；指导；引导；指挥",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1140,
    "word": "coutume",
    "phonetic": "[kutym]",
    "type": "",
    "translation": "n.f. 习惯，习俗，惯例",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1141,
    "word": "colonne",
    "phonetic": "[kɔlɔn]",
    "type": "",
    "translation": "n.f. 柱，支柱，圆柱；（印刷品的）栏，列；[军]纵队",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1142,
    "word": "prisonnier",
    "phonetic": "[prizɔnje]",
    "type": "",
    "translation": "n. 俘虏；囚犯；被禁闭的军人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1143,
    "word": "précipité",
    "phonetic": "[presipite]",
    "type": "",
    "translation": "a. 匆忙的，仓促的；n.m. [化]沉淀的 v.i. 逃跑；逃避；飞逝；流出；渗漏；v.t. 逃避，躲避；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1144,
    "word": "brume",
    "phonetic": "[brym]",
    "type": "",
    "translation": "n.f. 雾，轻雾，雾霭；模糊，糊涂；模糊不清；海雾 v.i. 旋转，回转；（车辆等）拐弯，转弯；盘旋；v.t.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1145,
    "word": "virer",
    "phonetic": "[vire]",
    "type": "",
    "translation": "[银，会]转账，划账",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1146,
    "word": "auparavant",
    "phonetic": "[oparavɑ̃]",
    "type": "",
    "translation": "adv. 从前，以前；先，在先 1.凿穿，打穿；凿，开辟； 2.穿过，透过；看穿，看破",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1147,
    "word": "percer",
    "phonetic": "[pεrse]",
    "type": "",
    "translation": "3.v.i. 突破而出；突围； 4.显露，显出，流露，崭露头角 v.t. 搅浑；使模糊不清；使慌乱；扰乱，打扰；使心绪不",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1148,
    "word": "troubler",
    "phonetic": "[truble]",
    "type": "",
    "translation": "宁 a. 末端的，尽头的；最后的，最末的；极度的；过分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1149,
    "word": "extrême",
    "phonetic": "[εkstrεm]",
    "type": "",
    "translation": "的，极端的；n.m. 极端",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1150,
    "word": "signal",
    "phonetic": "[siɲal]",
    "type": "",
    "translation": "n.m. 信号，暗号 n.f. 轮舞，圆舞；轮舞曲；圆体书法，圆体字；巡逻，巡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1151,
    "word": "ronde",
    "phonetic": "[rɔ̃d]",
    "type": "",
    "translation": "查；巡逻队",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1152,
    "word": "évident",
    "phonetic": "[evidɑ̃]",
    "type": "",
    "translation": "a. 明显的，显而易见的，一目了然的，显著的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1153,
    "word": "malle",
    "phonetic": "[mal]",
    "type": "",
    "translation": "n.f.（旅行用的）箱子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1154,
    "word": "dedans",
    "phonetic": "[dədɑ̃]",
    "type": "",
    "translation": "adv. 在内，在里面；n.m. 内部，里面",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1155,
    "word": "couverture",
    "phonetic": "[kuvεrtyr]",
    "type": "",
    "translation": "n.f. 被子，毯子；屋顶；护封；封面",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1156,
    "word": "machinalement",
    "phonetic": "[ma∫inalmɑ̃]",
    "type": "",
    "translation": "adv. 死记硬背",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1157,
    "word": "soigneusement",
    "phonetic": "[swaɲøzmɑ̃]",
    "type": "",
    "translation": "adv. 细心地，仔细地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1158,
    "word": "coiffer",
    "phonetic": "[kwafe]",
    "type": "",
    "translation": "v.t. 给……梳头；给……理发；给……戴帽；戴上",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1159,
    "word": "bec",
    "phonetic": "[bεk]",
    "type": "",
    "translation": "n.m.（鸟）嘴，喙；尖端，突出部分；（容器的）口",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1160,
    "word": "certes",
    "phonetic": "[sεrt]",
    "type": "",
    "translation": "adv. 当然，必定，的确 a. 忠诚的，忠实的；忠贞的，可靠的；忠于事实的，符",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1161,
    "word": "fidèle",
    "phonetic": "[fidεl]",
    "type": "",
    "translation": "合真实的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1162,
    "word": "soutenir",
    "phonetic": "[sutnir]",
    "type": "",
    "translation": "v.t. 支撑；搀扶；维持体力；支持，援助；保持；拥护",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1163,
    "word": "toutefois",
    "phonetic": "[tutfwa]",
    "type": "",
    "translation": "adv. 尽管如此，不过，仍然，还是",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1164,
    "word": "prolonger",
    "phonetic": "[prɔlɔ̃ʒe]",
    "type": "",
    "translation": "v.t. 使（期限等）延长；使延伸，使伸展，加长",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1165,
    "word": "fuite",
    "phonetic": "[fɥit]",
    "type": "",
    "translation": "n.f. 逃跑；逃避，躲避；漏泄；泄密",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1166,
    "word": "définitif",
    "phonetic": "[definitif]",
    "type": "",
    "translation": "a. 最后的，决定性的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1167,
    "word": "rangé",
    "phonetic": "[rɑ̃ʒe]",
    "type": "",
    "translation": "adj. 收拾好的， 整洁的， 规规矩矩的， 生活有条不紊的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1168,
    "word": "degré",
    "phonetic": "[dəgre]",
    "type": "",
    "translation": "n.m. 等级，级别；程度，阶段；度，度数 v.t. （使）空，倒空；喝光；吃光；使撤出，使撤离；疏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1169,
    "word": "influence",
    "phonetic": "[ɛ̃flyɑ̃s]",
    "type": "",
    "translation": "n.f. 影响；作用；威信，权势",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1170,
    "word": "paire",
    "phonetic": "[pεr]",
    "type": "",
    "translation": "n.f. 一双，一副；一对",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1171,
    "word": "liqueur",
    "phonetic": "[likœ:r]",
    "type": "",
    "translation": "n.f. 甜烧酒，利口酒；（药用）液，液体",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1172,
    "word": "gin",
    "phonetic": "[dʒin]",
    "type": "",
    "translation": "n.m. 杜松子酒 a. 报丧的，预报死亡的；致命的，致死的；不祥的；招",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1173,
    "word": "funeste",
    "phonetic": "[fynεst]",
    "type": "",
    "translation": "致重大损失的；有害的 24 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1174,
    "word": "réfugié",
    "phonetic": "[refyʒje]",
    "type": "",
    "translation": "a. 避难的，逃亡的；n. 难民；避难者，逃亡者",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1175,
    "word": "détective",
    "phonetic": "[detεktiv]",
    "type": "",
    "translation": "n. 私家侦探",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1176,
    "word": "résine",
    "phonetic": "[rezin]",
    "type": "",
    "translation": "n.f. [化]树脂 v.i. 飞来飞去，飞舞，飞翔；飘扬，飘舞；轻浮；走钢",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1177,
    "word": "voltiger",
    "phonetic": "[vɔltiʒe]",
    "type": "",
    "translation": "丝，耍马戏，演杂技",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1178,
    "word": "inquiétude",
    "phonetic": "[ɛ̃kjetyd]",
    "type": "",
    "translation": "n.f. 担心，担忧，不安，焦急",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1179,
    "word": "réflexion",
    "phonetic": "[reflεksjɔ̃]",
    "type": "",
    "translation": "n.f. 反射[指波]；思考，考虑；反省；感想，想法 n.f. 带领，引导；驾驶；指挥，领导；行为，品行；管",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1180,
    "word": "conduite",
    "phonetic": "[kɔ̃dɥit]",
    "type": "",
    "translation": "道，管件",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1181,
    "word": "cerveau",
    "phonetic": "[sεrvo]",
    "type": "",
    "translation": "n.m. 脑；头脑，思想；中枢；智囊，关键人物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1182,
    "word": "crainte",
    "phonetic": "[krɛ̃t]",
    "type": "",
    "translation": "n.f. 害怕，畏惧；忧虑，担心",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1183,
    "word": "prévision",
    "phonetic": "[previzjɔ̃]",
    "type": "",
    "translation": "n.f. 预见，预料，预测，预报",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1184,
    "word": "conclure",
    "phonetic": "[kɔ̃klyr]",
    "type": "",
    "translation": "v.t. 缔结，达成，商定；结束 v.t. 实施，实行，执行；[法]执行死刑，处决；演奏，表",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1185,
    "word": "exécuter",
    "phonetic": "[εgzekyte]",
    "type": "",
    "translation": "ou [egzekyte] 演",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1186,
    "word": "fracas",
    "phonetic": "[fraka]",
    "type": "",
    "translation": "n.m. 爆裂声，撞击声，哗啦声，轰隆声",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1187,
    "word": "lame",
    "phonetic": "[lam]",
    "type": "",
    "translation": "n.f. 薄片；刀片；薄板",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1188,
    "word": "tort",
    "phonetic": "[tɔr]",
    "type": "",
    "translation": "n.m. 过错，错误；损害，伤害，损失",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1189,
    "word": "précaution",
    "phonetic": "[prekosjɔ̃]",
    "type": "",
    "translation": "n.f. 预防措施；谨慎，小心 a. 不规则的，无规律的，不整齐的；经常变化的，不稳",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1190,
    "word": "irrégulier",
    "phonetic": "[iregylje]",
    "type": "",
    "translation": "定的；不合常规的，不正常的；不正规的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1191,
    "word": "barrer",
    "phonetic": "[bare]",
    "type": "",
    "translation": "v.t.（用横杆等）拦住；挡住，拦阻",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1192,
    "word": "franchement",
    "phonetic": "[frɑ̃∫mɑ̃]",
    "type": "",
    "translation": "adv. 坦率地，直率地；坦率地讲；非常，确实；完全",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1193,
    "word": "électrique",
    "phonetic": "[elεktrik]",
    "type": "",
    "translation": "a. 电的；触电般的；十分强烈的 v.t.， v.pr. 1.涂，敷，贴； 2.运用，应用，使用，援用",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1194,
    "word": "appliquer",
    "phonetic": "[aplike]",
    "type": "",
    "translation": "3.实施，实行； 4.专心于，全神贯注于",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1195,
    "word": "bassin",
    "phonetic": "[basɛ̃]",
    "type": "",
    "translation": "n.m. 盆；水池；池塘；盆地 a. 宽宏大量的，宽厚的；慷慨的；富饶的，肥沃的；丰",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1196,
    "word": "généreux",
    "phonetic": "[ʒenerø, -z]",
    "type": "",
    "translation": "富的 v.t. 为……辩护；证明无罪；说明理由；解释；证实；论",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1197,
    "word": "justifier",
    "phonetic": "[ʒystifje]",
    "type": "",
    "translation": "证，证明；使合法，使成为正当的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1198,
    "word": "besogne",
    "phonetic": "[bəzɔɲ]",
    "type": "",
    "translation": "n.f. 工作，活儿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1199,
    "word": "caresser",
    "phonetic": "[karεse]",
    "type": "",
    "translation": "v.t. 抚爱，抚摸；轻拂",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1200,
    "word": "chauffer",
    "phonetic": "[∫ofe]",
    "type": "",
    "translation": "v.t. 烧热，加热；激励，使兴奋；v.i. 变热；发热 v.,v.pr. 折断，打碎；停止，中止；宣告废除；绝交；关",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1201,
    "word": "détour",
    "phonetic": "[detur]",
    "type": "",
    "translation": "n.m. 绕道，迂回，走弯路；拐弯；拐弯抹角，兜圈子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1202,
    "word": "hurlement",
    "phonetic": "[yrləmɑ̃]",
    "type": "",
    "translation": "虚音H n.m. 嗥叫；吼叫，喊叫",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1203,
    "word": "formé",
    "phonetic": "[fɔrme]",
    "type": "",
    "translation": "adj. 成形的, 形成的, 长成的, 成熟的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1204,
    "word": "typhon",
    "phonetic": "[tifɔ̃]",
    "type": "",
    "translation": "n.m. 台风",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1205,
    "word": "invariable",
    "phonetic": "[ɛ̃varjabl]",
    "type": "",
    "translation": "a. 不变的，不改变的；[语]词形不变化的，词尾不变化的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1206,
    "word": "ahurir",
    "phonetic": "[ayrir]",
    "type": "",
    "translation": "v.t. 使慌乱，使惊呆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1207,
    "word": "apprécier",
    "phonetic": "[apresje]",
    "type": "",
    "translation": "v.t. 估价，评价；估计，判断，衡量；赏识，欣赏 n.m. 低语声，窃窃议论声；埋怨声，怨言；低沉连续的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1208,
    "word": "murmure",
    "phonetic": "[myrmyr]",
    "type": "",
    "translation": "声音 25 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1209,
    "word": "concert",
    "phonetic": "[kɔ̃sεr]",
    "type": "",
    "translation": "n.m. 协调，一致，和谐；音乐会；合唱团，乐队；齐鸣",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1210,
    "word": "religieux",
    "phonetic": "[r(ə)liʒjø, -z]",
    "type": "",
    "translation": "a. 宗教的；修道的；笃信宗教的；n. 修道士，修女",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1211,
    "word": "convoi",
    "phonetic": "[kɔ̃vwa]",
    "type": "",
    "translation": "n.m. 车队；船队；队列；列车",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1212,
    "word": "facilement",
    "phonetic": "[fasilmɑ̃]",
    "type": "",
    "translation": "adv. 容易地， 轻易地， 不费力地；至少， 起码 v.t. 放下；放置；（用车）把……带到；寄存，存放；提",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1213,
    "word": "déposer",
    "phonetic": "[depoze]",
    "type": "",
    "translation": "交，提呈；拿掉，拆下 v.t. 向……挑衅；惹；（女人）挑逗（男人）；引起，激",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1214,
    "word": "provoquer",
    "phonetic": "[prɔvɔke]",
    "type": "",
    "translation": "起",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1215,
    "word": "tournant",
    "phonetic": "[turnɑ̃, -t]",
    "type": "",
    "translation": "a. 旋转的，能转动的；迂回曲折的, 盘旋的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1216,
    "word": "canal",
    "phonetic": "[kanal]",
    "type": "",
    "translation": "n.m. 1.运河，水渠，海峡， 2.管道，途径",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1217,
    "word": "dizaine",
    "phonetic": "[dizεn]",
    "type": "",
    "translation": "n.f. 十个左右，十来个",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1218,
    "word": "ouverture",
    "phonetic": "[uvεrtyr]",
    "type": "",
    "translation": "n.f. 打开；开启；开口；开始；开张，开幕；营业；开放",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1219,
    "word": "manifester",
    "phonetic": "[manifεste]",
    "type": "",
    "translation": "v.t. 表示，表达；显示，显露；v.i. 参加游行，举行示威",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1220,
    "word": "conséquence",
    "phonetic": "[kɔ̃sekɑ̃s]",
    "type": "",
    "translation": "n.f. 后果，结果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1221,
    "word": "redevenir",
    "phonetic": "[rədvənir]",
    "type": "",
    "translation": "v.i. 再次成为",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1222,
    "word": "domination",
    "phonetic": "[dɔminasjɔ̃]",
    "type": "",
    "translation": "n.f. 控制，支配；统治",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1223,
    "word": "gouverneur",
    "phonetic": "[guvεrnœr]",
    "type": "",
    "translation": "n.m. 总督；省长，州长；总裁，总长；〈军事〉司令 adv. 确切地，准确地；以本义；清洁地，干净地，整洁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1224,
    "word": "proprement",
    "phonetic": "[prɔprəmɑ̃]",
    "type": "",
    "translation": "地；廉洁地，正派地，正当地；恰当地，适当地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1225,
    "word": "modifier",
    "phonetic": "[mɔdifje]",
    "type": "",
    "translation": "v.t. 改变，修改；修；v.pr. 改变，变化",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1226,
    "word": "antique",
    "phonetic": "[ɑ̃tik]",
    "type": "",
    "translation": "a. 古代的；古老的；过时的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1227,
    "word": "passager",
    "phonetic": "[pasaʒe]",
    "type": "",
    "translation": "n. 乘客，旅客；a. 过路的，经过的；短暂的，一时的 n.m. 假期；休假；节假日；中止工作合同；中止租赁合",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1228,
    "word": "congé",
    "phonetic": "[kɔ̃ʒe]",
    "type": "",
    "translation": "同",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1229,
    "word": "rade",
    "phonetic": "[rad]",
    "type": "",
    "translation": "n.f.【航海】锚地, 停泊场；n.m.〈行话〉酒吧",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1230,
    "word": "contrer",
    "phonetic": "[kɔ̃tre]",
    "type": "",
    "translation": "v. [牌戏]加倍；反对，阻碍",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1231,
    "word": "sieur",
    "phonetic": "[sjœr]",
    "type": "",
    "translation": "n.m. 先生",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1232,
    "word": "chaussette",
    "phonetic": "[∫osεt]",
    "type": "",
    "translation": "n.f. 袜子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1233,
    "word": "procession",
    "phonetic": "[prɔsesjɔ̃]",
    "type": "",
    "translation": "n.f. 行列，游行队伍；迎神；长列，长龙 v.t. 强奸；违反，违犯，违背，破坏；闯入；侵犯；（对",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1234,
    "word": "violer",
    "phonetic": "[vjɔle]",
    "type": "",
    "translation": "圣地的）亵渎",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1235,
    "word": "adversaire",
    "phonetic": "[advεrsεr]",
    "type": "",
    "translation": "n. 对手，敌手；对方 adj. 被占用的；被借用的；忙碌的；罹病的，遭受…的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1236,
    "word": "pris",
    "phonetic": "[pri, -z]",
    "type": "",
    "translation": "入迷的；凝结的，结冰的；受骗上当的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1237,
    "word": "navigation",
    "phonetic": "[navigasjɔ̃]",
    "type": "",
    "translation": "n.f. 航行，航海；航海学；领航；航空学；航空",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1238,
    "word": "considérable",
    "phonetic": "[kɔ̃siderabl]",
    "type": "",
    "translation": "a. 大量的，重大的；值得注意的，重要的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1239,
    "word": "délai",
    "phonetic": "[delε]",
    "type": "",
    "translation": "n.m. 期限，时限；延期，延迟",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1240,
    "word": "river",
    "phonetic": "[rive]",
    "type": "",
    "translation": "v.t. 钉死；铆接；扣牢",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1241,
    "word": "marchandise",
    "phonetic": "[mar∫ɑ̃diz]",
    "type": "",
    "translation": "n.f. 商品，货物",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1242,
    "word": "manier",
    "phonetic": "[manje]",
    "type": "",
    "translation": "v.t. 操作，操纵；控制，支配；使用，运用",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1243,
    "word": "fonctionnaire",
    "phonetic": "[fɔ̃ksjɔnεr]",
    "type": "",
    "translation": "n. 官员，职员，公务员",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1244,
    "word": "brigadier",
    "phonetic": "[brigadje]",
    "type": "",
    "translation": "n.m. 队长，班长，组长；下士；水手长",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1245,
    "word": "aucunement",
    "phonetic": "[okynəmɑ̃]",
    "type": "",
    "translation": "adv. 一点不，一点没有，绝不，丝毫不",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1246,
    "word": "impassible",
    "phonetic": "[ɛ̃pasibl]",
    "type": "",
    "translation": "adj. 无表情的； 无动于衷的； 沉着的， 镇定的 26 of 35 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1247,
    "word": "foie",
    "phonetic": "[fwa]",
    "type": "",
    "translation": "n.m. 肝，肝脏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1248,
    "word": "muraille",
    "phonetic": "[myrɑj]",
    "type": "",
    "translation": "n.f. 高墙，城墙",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1249,
    "word": "charbon",
    "phonetic": "[∫arbɔ̃]",
    "type": "",
    "translation": "n.m. 煤；木炭笔；[医]炭疽 1.瞄准， 对； \"2.v.t. indir （+ à）以...为目的， 追",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1250,
    "word": "favorable",
    "phonetic": "[favɔrabl]",
    "type": "",
    "translation": "a. 好意的；赞成的，支持的；有利的；有促进作用的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1251,
    "word": "oublié",
    "phonetic": "[ublije]",
    "type": "",
    "translation": "adj. 被遗忘的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1252,
    "word": "irriter",
    "phonetic": "[irite]",
    "type": "",
    "translation": "v.t. 激怒，使恼怒，使生气；刺激，使难受",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1253,
    "word": "auditeur",
    "phonetic": "[oditœr, -tris]",
    "type": "",
    "translation": "n. 听众",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1254,
    "word": "pavillon",
    "phonetic": "[pavijɔ̃]",
    "type": "",
    "translation": "n.m. 独家小楼；楼阁；亭子；[海]国籍旗，信号旗",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1255,
    "word": "singulier",
    "phonetic": "[sɛ̃gylje, -εr]",
    "type": "",
    "translation": "a. 独特的，特殊的，奇特的，奇异的，古怪的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1256,
    "word": "étonné",
    "phonetic": "[etɔne]",
    "type": "",
    "translation": "adj. 被震撼的， 惊愕的；惊讶的， 惊奇的， 吃惊的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1257,
    "word": "maritime",
    "phonetic": "[maritim]",
    "type": "",
    "translation": "a. 沿海的，海岸的，海的；航海的；海上的；海事的 adv. 干净地，清洁地；清楚地，清晰地；明确地；明显",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1258,
    "word": "nettement",
    "phonetic": "[nεtmɑ̃]",
    "type": "",
    "translation": "地；直截了当地，干脆地；很，许多 a. 不由自主的，无意识的，本能的；无意的；非出本意",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1259,
    "word": "involontaire",
    "phonetic": "[ɛ̃vɔlɔ̃tεr]",
    "type": "",
    "translation": "的 v.t. 进行，实施；给（某人或身体某部分）施行手术；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1260,
    "word": "opérer",
    "phonetic": "[ɔpere]",
    "type": "",
    "translation": "v.i. 进行，干，做；起作用，见效；动手术",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1261,
    "word": "couché",
    "phonetic": "[ku∫e]",
    "type": "",
    "translation": "adj.躺着的；倾斜的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1262,
    "word": "pressé",
    "phonetic": "[prεse]",
    "type": "",
    "translation": "a. 榨过的，挤过的；匆忙的，急促的；紧急的 n.m.（一棵树的全部）叶子，叶丛；（伐下的）带叶树",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1263,
    "word": "feuillage",
    "phonetic": "[fœjaʒ]",
    "type": "",
    "translation": "枝 n.f. 储备（品），储藏（物）；储存，备用；存款；部分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1264,
    "word": "provision",
    "phonetic": "[prɔvizjɔ̃]",
    "type": "",
    "translation": "付款；预付款",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1265,
    "word": "remords",
    "phonetic": "[r(ə)mɔr]",
    "type": "",
    "translation": "n.m. 内疚，悔恨，良心的责备",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1266,
    "word": "principalement",
    "phonetic": "[prɛ̃sipalmɑ̃]",
    "type": "",
    "translation": "adv. 主要地；尤其，特别",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1267,
    "word": "flèche",
    "phonetic": "[flε∫]",
    "type": "",
    "translation": "n.f. 箭；箭头，箭形符号，箭形标志",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1268,
    "word": "marine",
    "phonetic": "[marin]",
    "type": "",
    "translation": "n.f. 航海术；海员；海运业；海军",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1269,
    "word": "courant",
    "phonetic": "[kurɑ̃, -t]",
    "type": "",
    "translation": "a. 流动的；当前的；日常的，平常的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1270,
    "word": "renseignement",
    "phonetic": "[rɑ̃sεɲmɑ̃]",
    "type": "",
    "translation": "n.m. 情况，消息；情报",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1271,
    "word": "faculté",
    "phonetic": "[fakylte]",
    "type": "",
    "translation": "n.f. 官能，能力；才能；学院；系；大学",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1272,
    "word": "tuyau",
    "phonetic": "[tɥijo]",
    "type": "",
    "translation": "n.m. 管，管子，管道，导管",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1273,
    "word": "envers",
    "phonetic": "[ɑ̃vεr]",
    "type": "",
    "translation": "n.m. 反面，背面；相反的一面，反面；背阴的山坡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1274,
    "word": "gigantesque",
    "phonetic": "[ʒigɑ̃tεsk]",
    "type": "",
    "translation": "adj. 1.巨人般的；魁梧的； 2.庞大的，宏伟的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1275,
    "word": "convenable",
    "phonetic": "[kɔ̃vnabl]",
    "type": "",
    "translation": "a. 合适的，适当的；得体的，合乎礼仪的；可接受的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1276,
    "word": "moitié",
    "phonetic": "[mwatje]",
    "type": "",
    "translation": "n.f. 一半；一半左右；老婆 n.f. 休息，歇脚；休息处，歇脚处；interj. 站住！够了！",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1277,
    "word": "halte",
    "phonetic": "[alt]",
    "type": "",
    "translation": "虚音H 行了！",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1278,
    "word": "taillis",
    "phonetic": "[taji]",
    "type": "",
    "translation": "n.m. 矮林 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1279,
    "word": "singe",
    "phonetic": "[sɛ̃ʒ]",
    "type": "",
    "translation": "n.m. 猴 0 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1280,
    "word": "ramper",
    "phonetic": "[rɑ̃pe]",
    "type": "",
    "translation": "v.i. 爬行，匍匐而行；（植物）蔓生，攀缘 1 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1281,
    "word": "tambour",
    "phonetic": "[tɑ̃bur]",
    "type": "",
    "translation": "n.m. 鼓；鼓声；鼓手；鼓形物；绞筒；滚筒；卷筒 2 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1282,
    "word": "collier",
    "phonetic": "[kɔlje]",
    "type": "",
    "translation": "n.m. 项链，颈饰；（牲畜的）颈圈 3 27 of 35 单词 音标 解释 No. 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1283,
    "word": "tumulte",
    "phonetic": "[tymylt]",
    "type": "",
    "translation": "n.m. 骚乱，嘈杂，喧闹；杂乱，烦乱，纷繁 4 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1284,
    "word": "supplice",
    "phonetic": "[syplis]",
    "type": "",
    "translation": "n.m. 酷刑；（肉体的）剧痛；痛苦，苦恼，折磨 5 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1285,
    "word": "courber",
    "phonetic": "[kurbe]",
    "type": "",
    "translation": "v.t. 使弯曲，使弯下；使倾斜 6 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1286,
    "word": "brûlé",
    "phonetic": "[bryle]",
    "type": "",
    "translation": "n.m. 焦的，烧焦的；失去信用的；焦味 7 100",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1287,
    "word": "inspecteur",
    "phonetic": "[ɛ̃spεktœr]",
    "type": "",
    "translation": "n. 视察员，检查员，监察员 8 100 n. 指挥者，长；主人；教师；n.m. 师傅，教练；工头；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1288,
    "word": "maître",
    "phonetic": "[mεtr]",
    "type": "",
    "translation": "9 大师 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1289,
    "word": "bourreau",
    "phonetic": "[buro]",
    "type": "",
    "translation": "n.m. 刽子手；残忍的人，虐待他人的人；拼命干活的人 0 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1290,
    "word": "fourrure",
    "phonetic": "[furyr]",
    "type": "",
    "translation": "n.f. 毛皮，皮货；皮衣服；皮毛 1 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1291,
    "word": "industriel",
    "phonetic": "[ɛ̃dystrijεl]",
    "type": "",
    "translation": "a. 工业的，产业的；n.m. 企业家，工业家 2 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1292,
    "word": "représentation",
    "phonetic": "[rəprezɑ̃tasjɔ̃]",
    "type": "",
    "translation": "n.f. 表现，表达；表示，体现，象征；描绘 3 101 肯定的，确定的；确实的，确凿的；确信的；一些，某 certaine 4 些；某种，某个； 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1293,
    "word": "parti",
    "phonetic": "[parti]",
    "type": "",
    "translation": "n.m. 党，政党；派，派别 5 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1294,
    "word": "farouche",
    "phonetic": "[faru∫]",
    "type": "",
    "translation": "adj. 1.易受惊的，胆小的； 2.不合群的；野性的 6 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1295,
    "word": "parcours",
    "phonetic": "[parkur]",
    "type": "",
    "translation": "n.m. 通行, 通过, 经过；航线；航路；路线；行程，里程 7 101",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1296,
    "word": "domestique",
    "phonetic": "[dɔmεstik]",
    "type": "",
    "translation": "a. 家庭的，家内的；家养的，驯养的；n. 仆人，佣人 9 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1297,
    "word": "garer",
    "phonetic": "[gare]",
    "type": "",
    "translation": "v.t. 收藏，放好；停放（车辆）；把（车）开进站 0 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1298,
    "word": "pendule",
    "phonetic": "[pɑ̃dyl]",
    "type": "",
    "translation": "n.m. 摆；n.f. 摆钟，挂钟，座钟 1 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1299,
    "word": "horloge",
    "phonetic": "[ɔrlɔʒ]",
    "type": "",
    "translation": "n.f. 钟，时钟 2 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1300,
    "word": "mandat",
    "phonetic": "[mɑ̃da]",
    "type": "",
    "translation": "n.m. 委托，委任；委托权；委任期；汇票；付款通知 3 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1301,
    "word": "affairer",
    "phonetic": "[afεre]",
    "type": "",
    "translation": "v.pr. 忙碌，忙 4 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1302,
    "word": "compris",
    "phonetic": "[kɔ̃pri, -z]",
    "type": "",
    "translation": "a. 包括在内的；理解的，懂了的 5 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1303,
    "word": "nationalité",
    "phonetic": "[nasjɔnalite]",
    "type": "",
    "translation": "n.f. 国籍；民族；民族性，民族特点 6 102",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1304,
    "word": "éblouissant",
    "phonetic": "[ebluisɑ̃]",
    "type": "",
    "translation": "adj. 令人眼花缭乱 7 102 n.m. 堰堤，防波堤，堤；浇铸；（装饰家具的）饰布；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1305,
    "word": "jeté",
    "phonetic": "[ʒəte]",
    "type": "",
    "translation": "8 〈体育〉挺举 102 n.m. 职员，雇员，办事员；店员，伙计；代理人，受托",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1306,
    "word": "commis",
    "phonetic": "[kɔmi]",
    "type": "",
    "translation": "9 人 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1307,
    "word": "locomotive",
    "phonetic": "[lɔkɔmɔtiv]",
    "type": "",
    "translation": "n.f. 机车，火车头 0 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1308,
    "word": "sifflet",
    "phonetic": "[siflε]",
    "type": "",
    "translation": "n.m. 哨子；汽笛；pl.（表示反对的）嘘声，倒彩声 1 103 v.t. 使戴上面纱；用罩布盖住；用帷幔蒙住；掩盖，掩",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1309,
    "word": "voiler",
    "phonetic": "[vwale]",
    "type": "",
    "translation": "2 饰；隐瞒；使暗淡，使模糊，使朦胧 28 of 35 单词 音标 解释 No. 103 n.m. 树干；〈建筑〉柱身；托，柄，杆，架，支柱；酒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1310,
    "word": "fût",
    "phonetic": "[fy]",
    "type": "",
    "translation": "3 桶，大桶 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1311,
    "word": "coque",
    "phonetic": "[kɔk]",
    "type": "",
    "translation": "n.f. 果壳；结 4 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1312,
    "word": "intervalle",
    "phonetic": "[ɛ̃tεrval]",
    "type": "",
    "translation": "n.m. 间隔，间距；间歇，间隙；期间；[乐]音程 5 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1313,
    "word": "officier",
    "phonetic": "[ɔfisje]",
    "type": "",
    "translation": "n.m. 军官；官员 6 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1314,
    "word": "houle",
    "phonetic": "[ul]",
    "type": "",
    "translation": "虚音H n.f. 涌浪，波涛；波涛状；激烈 7 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1315,
    "word": "relâcher",
    "phonetic": "[rəlɑ∫e]",
    "type": "",
    "translation": "v.t. 放松，使松弛；释放；使舒松；使松懈 8 103",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1316,
    "word": "piloter",
    "phonetic": "[pilɔte]",
    "type": "",
    "translation": "v.t. 领港，领航，引水；驾驶；领路；在…上打桩 9 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1317,
    "word": "ruiner",
    "phonetic": "[rɥine]",
    "type": "",
    "translation": "v.t. 使破产；使毁坏，使灭亡；使无力；破坏 0 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1318,
    "word": "mis",
    "phonetic": "[mi, -z]",
    "type": "",
    "translation": "adj. 摆好的；穿着（衣服）的 1 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1319,
    "word": "promis",
    "phonetic": "[prɔmi]",
    "type": "",
    "translation": "a. 允诺的，许诺的，答应的 2 104 a. 可尊敬的，令人尊敬的；体面的；有信誉的；光荣",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1320,
    "word": "honorable",
    "phonetic": "[ɔnɔrabl]",
    "type": "",
    "translation": "3 的；过得去的，足够的，相当好的 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1321,
    "word": "compartiment",
    "phonetic": "[kɔ̃partimɑ̃]",
    "type": "",
    "translation": "n.m. 分隔车室，包房，小间；格子 4 104 adj. 被超过的，被胜过的；过时的；控制不了局面的，应",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1322,
    "word": "dépassé",
    "phonetic": "[depase]",
    "type": "",
    "translation": "5 付不了局面的 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1323,
    "word": "passerelle",
    "phonetic": "[pasrεl]",
    "type": "",
    "translation": "n.f. 步行桥，天桥，跳板；舷梯，客梯；过渡，衔接 6 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1324,
    "word": "bander",
    "phonetic": "[bɑ̃de]",
    "type": "",
    "translation": "v. 包扎；蒙住，包住；拉紧；被拉紧， 被绷紧 7 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1325,
    "word": "terrestre",
    "phonetic": "[tεrεstr]",
    "type": "",
    "translation": "a. 地球的；陆地的；陆生的；陆上的；人间的 8 104",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1326,
    "word": "avancé",
    "phonetic": "[avɑ̃se]",
    "type": "",
    "translation": "a. 前面的，前方的；先进的，进步的；提前的，提早的 9 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1327,
    "word": "réservé",
    "phonetic": "[rezεrve]",
    "type": "",
    "translation": "adj. 预定的，保留的；稳重的人；谨慎的，稳重的 0 105 a. 同谋的，共犯的，帮凶的；默契的，会心的，串通好",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1328,
    "word": "complice",
    "phonetic": "[kɔ̃plis]",
    "type": "",
    "translation": "1 的；n. 同谋者，共犯，帮凶 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1329,
    "word": "parier",
    "phonetic": "[parje]",
    "type": "",
    "translation": "v.t. 打赌；赌；肯定，担保 2 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1330,
    "word": "parent",
    "phonetic": "[parɑ̃, -t]",
    "type": "",
    "translation": "n. 亲属，亲戚；（学生）家长；n.m. pl. 父母，双亲 3 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1331,
    "word": "passant",
    "phonetic": "[pasɑ̃, -t]",
    "type": "",
    "translation": "a. 行人很多的，车辆来往频繁的；n. 过路人，行人 4 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1332,
    "word": "couvert",
    "phonetic": "[kuvεr, -t]",
    "type": "",
    "translation": "a. 穿衣的，戴帽的；带篷的，有屋顶的；n.m. 餐具 5 105 v.t.， v.pr. 折磨，使痛苦，使苦恼，使忧虑；纠缠，烦",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1333,
    "word": "tourmenter",
    "phonetic": "[turmɑ̃te]",
    "type": "",
    "translation": "6 扰；使颠簸；歪曲，曲解 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1334,
    "word": "désespéré",
    "phonetic": "[dezεspere]",
    "type": "",
    "translation": "a. 绝望的；无助的；毫无希望的；n. 绝望者 7 105 n.f. 钱包，钱夹；奖学金，助学金；交易所，证券交易",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1335,
    "word": "bourse",
    "phonetic": "[burs]",
    "type": "",
    "translation": "8 所；证券交易 105",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1336,
    "word": "invariablement",
    "phonetic": "[ɛ̃varjabləmɑ̃]",
    "type": "",
    "translation": "adv. 不变地， 总是 9 106 adj. 1.值得注意的，惹人注目； 2.卓越的，非凡的；出",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1337,
    "word": "remarquable",
    "phonetic": "[r(ə)markabl]",
    "type": "",
    "translation": "0 色的 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1338,
    "word": "valet",
    "phonetic": "[valε]",
    "type": "",
    "translation": "n.m. 仆从，仆人；奴性十足的人，奴才 1 29 of 35 单词 音标 解释 No. 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1339,
    "word": "fougère",
    "phonetic": "[fuʒεr]",
    "type": "",
    "translation": "n.f. 蕨 2 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1340,
    "word": "éclairé",
    "phonetic": "[eklere]",
    "type": "",
    "translation": "a. 知识渊博的，经验丰富的，内行的，有见识的 3 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1341,
    "word": "embarrassé",
    "phonetic": "[ɑ̃barase]",
    "type": "",
    "translation": "a. 被阻塞的，受阻碍的；为难的，尴尬的 4 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1342,
    "word": "éloigné",
    "phonetic": "[elwaɲe]",
    "type": "",
    "translation": "a. 远离的，远隔的；遥远的；远处的 5 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1343,
    "word": "cinquantaine",
    "phonetic": "[s ɛ̃kɑ̃tɛn]",
    "type": "",
    "translation": "n.f. 五十，五十左右；五十岁，五十岁左右 6 106 v.t. 消耗，消费；完成；食用；（在咖啡馆、酒馆等）喝",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1344,
    "word": "consommer",
    "phonetic": "[kɔ̃sɔme]",
    "type": "",
    "translation": "7 饮料 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1345,
    "word": "compliment",
    "phonetic": "[kɔ̃plimɑ̃]",
    "type": "",
    "translation": "n.m. 称赞的话；恭维话；祝词，贺词 8 106",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1346,
    "word": "cape",
    "phonetic": "[kap]",
    "type": "",
    "translation": "n.f. 斗篷，披风 9 107",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1347,
    "word": "photographier",
    "phonetic": "[fɔtɔgrafje]",
    "type": "",
    "translation": "v.t. 拍摄，给……照相；铭记，把……印入脑中 0 107 n.m. 床头，枕边；【建筑】(教堂中殿内)司祭席的后",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1348,
    "word": "chevet",
    "phonetic": "[∫əvε]",
    "type": "",
    "translation": "1 部；【矿物】矿脉底部 107",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1349,
    "word": "renversé",
    "phonetic": "[rɑ̃vεrse]",
    "type": "",
    "translation": "adj. 颠倒的；反向的 2 107 v.t. 督促，敦促，催告，警告；勒令，责令；要求；〈法",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1350,
    "word": "sommer",
    "phonetic": "[sɔme]",
    "type": "",
    "translation": "3 学〉传唤；〈数学〉求和 107 v.i. 出汗，流汗；冒水汽，渗水，滴水珠；辛劳，费力，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1351,
    "word": "suer",
    "phonetic": "[sɥe]",
    "type": "",
    "translation": "4 费劲 107",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1352,
    "word": "gentleman",
    "phonetic": "[dʒεntləman]",
    "type": "",
    "translation": "n.m. 绅士 5 107",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1353,
    "word": "voulu",
    "phonetic": "[vuly]",
    "type": "",
    "translation": "adj. 需要的， 规定的；故意的 6 107 v.i. 行进，走路，行走；缓进，渐进；进行，前进；〈军",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1354,
    "word": "cheminer",
    "phonetic": "[∫mine]",
    "type": "",
    "translation": "7 事〉逼近，推进 107 v.t.， v.pr. 使烦恼，使操心；操劳，苦干，疲于；花气",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1355,
    "word": "peiner",
    "phonetic": "[pεne]",
    "type": "",
    "translation": "8 力，努力 107",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1356,
    "word": "destination",
    "phonetic": "[dεstinasjɔ̃]",
    "type": "",
    "translation": "n.f. 用途；目的地，终点 9 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1357,
    "word": "soit",
    "phonetic": "[swa]",
    "type": "",
    "translation": "adj. 即，就是，等于说；假定；好吧，行吧，也好 0 108 adj. 沉着的， 镇定的； 冷静的， 坚定的， 不可动摇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1358,
    "word": "imperturbable",
    "phonetic": "[ɛ̃pεrtyrbabl]",
    "type": "",
    "translation": "1 的： 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1359,
    "word": "ému",
    "phonetic": "[emy]",
    "type": "",
    "translation": "a. 激动的，感动的 2 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1360,
    "word": "circulaire",
    "phonetic": "[sirkylεr]",
    "type": "",
    "translation": "a. 圆的；圆周的；环绕的，循环的；n.f. 通报，通知 3 108 n.m. 获胜，胜利，赢得；收益，收获；收入；好处，利",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1361,
    "word": "gain",
    "phonetic": "[gɛ̃]",
    "type": "",
    "translation": "4 益 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1362,
    "word": "mécanicien",
    "phonetic": "[mekanisjɛ̃]",
    "type": "",
    "translation": "n. 机械师；力学专家 5 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1363,
    "word": "haute",
    "phonetic": "['ot]",
    "type": "",
    "translation": "虚音H n.f. 上流社会 6 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1364,
    "word": "contredire",
    "phonetic": "[kɔ̃trədir]",
    "type": "",
    "translation": "v.t.， v.pr. 1.反驳，辩驳； 2.与...相反 7 adj. 缩小的，缩减了的；减低的，降低的；削减的：地处 108 不显眼地方的小房间；陋室，破旧的小屋；屋隅，壁凹；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1365,
    "word": "réduit",
    "phonetic": "[redɥi]",
    "type": "",
    "translation": "8 （城堡最里层的）内堡；（军舰的）内炮塔；袋形抵抗阵 地；隐蔽处， 避难所 30 of 35 单词 音标 解释 No. 108",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1366,
    "word": "vêtu",
    "phonetic": "[vety]",
    "type": "",
    "translation": "a. 穿着衣服的 9 109 n.m. 决定，决议，命令；决算，结算；判决；决定的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1367,
    "word": "arrêté",
    "phonetic": "[arεte]",
    "type": "",
    "translation": "0 不可动摇的 109 a. 抬起的；加高的；翻起的，卷起的；n.m. 抄录，记",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1368,
    "word": "relevé",
    "phonetic": "[rəlve]",
    "type": "",
    "translation": "1 录；清单；账单；统计表 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1369,
    "word": "robuste",
    "phonetic": "[rɔbyst]",
    "type": "",
    "translation": "a. 强壮的，结实的；坚固的，耐用的 2 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1370,
    "word": "maudire",
    "phonetic": "[modir]",
    "type": "",
    "translation": "v.t. 诅咒，咒骂；责骂，抱怨 3 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1371,
    "word": "consul",
    "phonetic": "[kɔ̃syl]",
    "type": "",
    "translation": "n.m. 领事；商事裁判官 4 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1372,
    "word": "mât",
    "phonetic": "[mɑ]",
    "type": "",
    "translation": "n.m. 桅，桅杆；旗杆 5 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1373,
    "word": "prodiguer",
    "phonetic": "[prɔdige]",
    "type": "",
    "translation": "v.t.， v.pr. 挥霍，浪费；滥用；慷慨地给予 6 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1374,
    "word": "pacifique",
    "phonetic": "[pasifik]",
    "type": "",
    "translation": "a. 热爱和平的；平和的，温和的；和平的；太平的 7 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1375,
    "word": "douane",
    "phonetic": "[dwan]",
    "type": "",
    "translation": "n.f. 海关；海关总署；关税 8 109",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1376,
    "word": "obligé",
    "phonetic": "[ɔbliʒe]",
    "type": "",
    "translation": "a. 负有义务的；被迫的；不可避免的；感恩的 9 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1377,
    "word": "conséquent",
    "phonetic": "[kɔ̃sekɑ̃]",
    "type": "",
    "translation": "a. 始终不渝的，一贯的；重要的，重大的 0 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1378,
    "word": "invraisemblable",
    "phonetic": "[ɛ̃vrεsɑ̃blabl]",
    "type": "",
    "translation": "a. 不像真的， 未必确实的，不可靠的；奇特的 1 110 a. 容易的，轻便的，便利的；自在的；无拘无束的；富",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1379,
    "word": "aisé",
    "phonetic": "[eze]",
    "type": "",
    "translation": "2 裕的 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1380,
    "word": "royale",
    "phonetic": "[rwajal]",
    "type": "",
    "translation": "n.f. 皇族 3 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1381,
    "word": "joueur",
    "phonetic": "[ʒwœr]",
    "type": "",
    "translation": "n. 游戏者；运动员；赌徒；演奏者 4 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1382,
    "word": "commune",
    "phonetic": "[kɔmyn]",
    "type": "",
    "translation": "n.f. 市镇；[史]公社 5 110 a. 勇敢的，大胆的，有勇气的；坚定的，果断的；放肆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1383,
    "word": "hardi",
    "phonetic": "[ardi]",
    "type": "",
    "translation": "虚音H 6 的；厚颜的 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1384,
    "word": "trot",
    "phonetic": "[tro]",
    "type": "",
    "translation": "n.m. （马等的）快步，小跑 7 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1385,
    "word": "sûreté",
    "phonetic": "[syrte]",
    "type": "",
    "translation": "n.f. 安全；安全性，可靠性；保险；准确；可靠，稳当 8 110",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1386,
    "word": "fâcheux",
    "phonetic": "[fɑ∫ø]",
    "type": "",
    "translation": "a. 令人不快的，令人恼火的；有损害的；不适当的 9 111",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1387,
    "word": "musicien",
    "phonetic": "[myzisjɛ̃]",
    "type": "",
    "translation": "n. 音乐家，作曲家；演奏家，乐师 0 111",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1388,
    "word": "découvert",
    "phonetic": "[dekuvεr, -t]",
    "type": "",
    "translation": "a. 暴露的，无遮盖的；n.m. 透支金额 1 111",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1389,
    "word": "surveillance",
    "phonetic": "[syrvεjɑ̃s]",
    "type": "",
    "translation": "n.f. 1.监视； 监督； 2.警戒； 3.受监视； 受看管 2 111 n.f. 横档，横梁；轨枕，枕木；横道，近路，捷径；困",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1390,
    "word": "traverse",
    "phonetic": "[travεrs]",
    "type": "",
    "translation": "3 难，障碍，挫折 111 n.m. 草图，图样；航线，路线；〈技术〉定线，轮廓",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1391,
    "word": "tracé",
    "phonetic": "[trase]",
    "type": "",
    "translation": "4 线，放样线 111",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1392,
    "word": "ceinture",
    "phonetic": "[sɛ̃tyr]",
    "type": "",
    "translation": "n.f. 腰带，裤带；裤腰，裙腰；（身体的）腰部；围绕物 6 111",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1393,
    "word": "contempler",
    "phonetic": "[kɔ̃tɑ̃ple]",
    "type": "",
    "translation": "v.t. 凝视，注视；出神地看，欣赏地看，惊讶地看 7 31 of 35 单词 音标 解释 No. 111",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1394,
    "word": "suivant",
    "phonetic": "[sɥivɑ̃, -t]",
    "type": "",
    "translation": "adj. 随后的，下一个的；prép. 按照，根据 8 111 adj.num.card.， adj.inv. 十六；第十六；（一个月份",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1395,
    "word": "seize",
    "phonetic": "[sεz]",
    "type": "",
    "translation": "9 的）十六日 112 n.m. 矮树林，矮树丛，丛林；有皮毛夹里的；有浓毛",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1396,
    "word": "fourré",
    "phonetic": "[fure]",
    "type": "",
    "translation": "0 的；夹馅的，夹心的 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1397,
    "word": "éclair",
    "phonetic": "[eklεr]",
    "type": "",
    "translation": "n.m. 1.电光，闪光；闪过；刹那间 2.闪现式的，极快的 1 112 a. 连续的，不断的；经常的；连贯的；听众多的，观众",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1398,
    "word": "suivi",
    "phonetic": "[sɥivi]",
    "type": "",
    "translation": "2 多的 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1399,
    "word": "atteint",
    "phonetic": "[atɛ̃]",
    "type": "",
    "translation": "adj. 被击中的；得病的，染上疾病的 3 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1400,
    "word": "employé",
    "phonetic": "[ɑ̃plwaje]",
    "type": "",
    "translation": "n. 职员，雇员 4 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1401,
    "word": "brouette",
    "phonetic": "[bruεt]",
    "type": "",
    "translation": "n.f. 独轮手推小车 5 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1402,
    "word": "merveilleusement",
    "phonetic": "[mεrvεjøzmɑ̃]",
    "type": "",
    "translation": "adv. 奇妙 6 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1403,
    "word": "agile",
    "phonetic": "[aʒil]",
    "type": "",
    "translation": "a. 灵活的，敏捷的，伶俐的 7 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1404,
    "word": "emporté",
    "phonetic": "[ɑ̃pɔrte]",
    "type": "",
    "translation": "adj. 暴躁的，易怒的，急性子的 8 112",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1405,
    "word": "poussé",
    "phonetic": "[puse]",
    "type": "",
    "translation": "adj. 提高的，加强的，深入的，精工细作的 9 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1406,
    "word": "golfe",
    "phonetic": "[gɔlf]",
    "type": "",
    "translation": "n.m. 海湾 0 113 a. 狂热的，盲信的；狂热崇拜的，狂热爱好的；n. 狂热",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1407,
    "word": "fanatique",
    "phonetic": "[fanatik]",
    "type": "",
    "translation": "1 者，盲信者；狂热崇拜者，狂热爱好者 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1408,
    "word": "magistrat",
    "phonetic": "[maʒistra]",
    "type": "",
    "translation": "n.m. 司法官员；行政官员；法官；审判官；检察官 2 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1409,
    "word": "sonné",
    "phonetic": "[sɔne]",
    "type": "",
    "translation": "adj.（钟点等）已敲过的；被击倒的； 被击昏的 3 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1410,
    "word": "capricieux",
    "phonetic": "[kaprisjø]",
    "type": "",
    "translation": "a. 任性的，反复无常的；多变的，变幻莫测的 4 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1411,
    "word": "insuffisant",
    "phonetic": "[ɛ̃syfizɑ̃, -t]",
    "type": "",
    "translation": "a. 不足的，不够的，缺乏的；缺乏能力的 5 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1412,
    "word": "mollir",
    "phonetic": "[mɔlir]",
    "type": "",
    "translation": "v.i. 变得软弱无力，减弱；退让；降低 6 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1413,
    "word": "vigoureusement",
    "phonetic": "[vigurøzmɑ]",
    "type": "",
    "translation": "adv. 大力 7 113 a. 对当代问题表态或采取行动的[指作家、艺术家]，介入",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1414,
    "word": "engagé",
    "phonetic": "[ɑ̃gaʒe]",
    "type": "",
    "translation": "8 （政治）的，卷入的；应募入伍的 113",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1415,
    "word": "bourrasque",
    "phonetic": "[burask]",
    "type": "",
    "translation": "n.f. 狂风，阵风，暴风；一时激怒；爆发，突发 9 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1416,
    "word": "canon",
    "phonetic": "[kanɔ̃]",
    "type": "",
    "translation": "n.m. 炮，大炮；炮管，炮筒；枪管，枪筒；教规 0 114 adj. 约定，商妥，商定；习惯；约定的，商妥的，商定",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1417,
    "word": "convenu",
    "phonetic": "[kɔ̃vny]",
    "type": "",
    "translation": "1 的；习惯的 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1418,
    "word": "ramure",
    "phonetic": "[ramyr]",
    "type": "",
    "translation": "n.f. （一棵树的）枝叶；鹿类的角 2 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1419,
    "word": "violent",
    "phonetic": "[vjɔlɑ̃]",
    "type": "",
    "translation": "a. 猛烈的，剧烈的；使用暴力的；粗暴的 3 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1420,
    "word": "dock",
    "phonetic": "[dɔk]",
    "type": "",
    "translation": "n.m. 码头；船坞；码头仓库 4 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1421,
    "word": "consciencieusement",
    "phonetic": "[kɔ̃sjɑ̃sjøzmɑ̃]",
    "type": "",
    "translation": "adv. 切实 5 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1422,
    "word": "pus",
    "phonetic": "[py]",
    "type": "",
    "translation": "n.m. 脓 6 32 of 35 单词 音标 解释 No. 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1423,
    "word": "braver",
    "phonetic": "[brave]",
    "type": "",
    "translation": "v.t. 冒，不顾；藐视；顶撞 7 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1424,
    "word": "appuyé",
    "phonetic": "[apɥije]",
    "type": "",
    "translation": "adj. 支持 8 114",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1425,
    "word": "notice",
    "phonetic": "[nɔtis]",
    "type": "",
    "translation": "n.f. 概述，简介；说明书 9 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1426,
    "word": "admirablement",
    "phonetic": "[admirabləmɑ̃]",
    "type": "",
    "translation": "adv. 令人钦佩 0 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1427,
    "word": "cité",
    "phonetic": "[site]",
    "type": "",
    "translation": "n.f. 城市；全城居民；城邦，国家；居住区 1 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1428,
    "word": "coiffé",
    "phonetic": "[kwafe]",
    "type": "",
    "translation": "adj. 戴帽子的， 戴头饰的； 梳过头的， 头发梳好的 2 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1429,
    "word": "secrète",
    "phonetic": "[səkrεt]",
    "type": "",
    "translation": "n.f. 秘密的，机密的，神秘的；隐藏的 3 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1430,
    "word": "commerçant",
    "phonetic": "[kɔmεrsɑ̃, -t]",
    "type": "",
    "translation": "n. 商人；a. 经商的；商业繁盛的；很会做生意的 4 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1431,
    "word": "cloche",
    "phonetic": "[klɔ∫]",
    "type": "",
    "translation": "n.f. 钟；钟形罩；蠢人，笨蛋；a. 愚蠢的，笨的 5 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1432,
    "word": "gang",
    "phonetic": "[gɑ̃g]",
    "type": "",
    "translation": "[gaŋ] n.m. 党 6 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1433,
    "word": "distancer",
    "phonetic": "[distɑ̃se]",
    "type": "",
    "translation": "v.t.， v.pr. 保持距离，疏远 7 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1434,
    "word": "pagode",
    "phonetic": "[pagɔd]",
    "type": "",
    "translation": "n.f. 寺庙，寺院；塔，宝塔，浮屠 8 115",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1435,
    "word": "acquisition",
    "phonetic": "[akizisjɔ̃]",
    "type": "",
    "translation": "n.f. 获得，取得；购得；获得物，购得物 9 116 a. 土生土长的，本地出生的；[植]本地的；出生于海外",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1436,
    "word": "indigène",
    "phonetic": "[ɛ̃diʒεn]",
    "type": "",
    "translation": "0 的；n. 本地人，当地人；本地植物；出生于海外的人 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1437,
    "word": "appareiller",
    "phonetic": "[apareje]",
    "type": "",
    "translation": "v.t.， v.pr. 启航，准备开船 1 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1438,
    "word": "damer",
    "phonetic": "[dame]",
    "type": "",
    "translation": "v.t. 夯实，打夯，捣实 2 116 adj. [宗]被祝圣的， 祝圣的； 惯用的， 约定俗成的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1439,
    "word": "consacré",
    "phonetic": "[kɔ̃sakre]",
    "type": "",
    "translation": "3 有名望的， 知名的， 著名的 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1440,
    "word": "fine",
    "phonetic": "[fin]",
    "type": "",
    "translation": "n.f. 上等烧酒， 白兰地 4 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1441,
    "word": "accusé",
    "phonetic": "[akyze]",
    "type": "",
    "translation": "n. 被告，被告人 5 116 a.破坏了的, 毁坏了的;坍塌的;毁灭了的, 灭亡了的;破产",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1442,
    "word": "ruiné",
    "phonetic": "[rɥine]",
    "type": "",
    "translation": "6 的 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1443,
    "word": "sensiblement",
    "phonetic": "[sɑ̃sibləmɑ̃]",
    "type": "",
    "translation": "adv. 显著地, 明显地, 显然;几乎 7 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1444,
    "word": "mathématique",
    "phonetic": "[matematik]",
    "type": "",
    "translation": "a. 数学的；精确的，严密的；n.f. pl. 数学 8 116",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1445,
    "word": "minuter",
    "phonetic": "[minyte]",
    "type": "",
    "translation": "v.t. 精确安排…的时间；草拟，起草 9 117 n.m. 意外事故，伴随的麻烦；事件，事变；（戏剧、小",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1446,
    "word": "incident",
    "phonetic": "[ɛ̃sidɑ̃]",
    "type": "",
    "translation": "0 说中的）插曲，插叙 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1447,
    "word": "chronomètre",
    "phonetic": "[krɔnɔmεtr]",
    "type": "",
    "translation": "n.m. 秒表；时计，标准时表，精密时计，天文钟 1 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1448,
    "word": "vive",
    "phonetic": "[viv]",
    "type": "",
    "translation": "interj. 万岁 2 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1449,
    "word": "embranchement",
    "phonetic": "[ɑ̃brɑ̃∫mɑ̃]",
    "type": "",
    "translation": "n.m. 分枝，分杈；岔路口；（动植物分类学中的）门 3 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1450,
    "word": "abasourdir",
    "phonetic": "[abazurdir]",
    "type": "",
    "translation": "v.t. 使震惊，使惊愕；震耳欲聋；震得头昏脑胀 4 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1451,
    "word": "piper",
    "phonetic": "[pipe]",
    "type": "",
    "translation": "v.i. 吹笛者 5 33 of 35 单词 音标 解释 No. 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1452,
    "word": "signalement",
    "phonetic": "[siɲalmɑ̃]",
    "type": "",
    "translation": "n.m. 体貌特征 6 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1453,
    "word": "coquin",
    "phonetic": "[kɔkɛ̃, -in]",
    "type": "",
    "translation": "n. 调皮的（人），淘气的（人） 7 117",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1454,
    "word": "apposer",
    "phonetic": "[apoze]",
    "type": "",
    "translation": "v.t. 粘贴，贴；安放；添加；署（名），盖（章） 8 117 n.f. 不动声色，无表情；冷淡，冷漠，无动于衷；沉着，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1455,
    "word": "impassibilité",
    "phonetic": "[ɛ̃pasibilite]",
    "type": "",
    "translation": "9 冷静，镇定，镇静 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1456,
    "word": "richement",
    "phonetic": "[ri∫mɑ̃]",
    "type": "",
    "translation": "adv. 丰富地 0 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1457,
    "word": "contretemps",
    "phonetic": "[kɔ̃trətɑ̃]",
    "type": "",
    "translation": "n.m. 意外情况，意外事故 1 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1458,
    "word": "roulis",
    "phonetic": "[ruli]",
    "type": "",
    "translation": "n.m. 滚 2 118 n.f. [技]底板；（平底船的）船底；[采]平巷底； 底梁；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1459,
    "word": "sole",
    "phonetic": "[sɔl]",
    "type": "",
    "translation": "3 [农]轮作田；鳎， 箬鳎鱼， 舌鳎；（马、驴等的）蹄底 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1460,
    "word": "primer",
    "phonetic": "[prime]",
    "type": "",
    "translation": "v.t. 超过，胜过；奖赏，给予奖金；占先，领先，占首位 4 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1461,
    "word": "coût",
    "phonetic": "[ku]",
    "type": "",
    "translation": "n.m. 费用；成本；价格，价钱 5 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1462,
    "word": "briquer",
    "phonetic": "[brike]",
    "type": "",
    "translation": "v.t. 抛光 6 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1463,
    "word": "pulluler",
    "phonetic": "[pylyle]",
    "type": "",
    "translation": "v.i. 一群 7 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1464,
    "word": "goutter",
    "phonetic": "[gute]",
    "type": "",
    "translation": "v.i. 滴落，滴答，嘀嗒 8 118",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1465,
    "word": "aperçu",
    "phonetic": "[apεrsy]",
    "type": "",
    "translation": "n.m. 概况，概述；概观 9 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1466,
    "word": "pittoresque",
    "phonetic": "[pitɔrεsk]",
    "type": "",
    "translation": "a. 风景如画的；别致的，生动的，绚丽多彩的 0 119 v.t.， v.pr. [园艺]培土， 壅土；（动物）躲进洞穴，住",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1467,
    "word": "terrer",
    "phonetic": "[tεre]",
    "type": "",
    "translation": "1 在地底下；躲藏；〈军事〉隐蔽 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1468,
    "word": "formalité",
    "phonetic": "[fɔrmalite]",
    "type": "",
    "translation": "n.f. 手续，程序；礼节，礼仪，客套；形式 2 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1469,
    "word": "brancher",
    "phonetic": "[brɑ̃∫e]",
    "type": "",
    "translation": "v.t. 联接，接通；使（机械等）运转；v.i. 栖在树枝上 3 119 a. 大胆的，勇敢的；果敢的；鲁莽的，无礼的；n. 大胆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1470,
    "word": "audacieux",
    "phonetic": "[odasjø]",
    "type": "",
    "translation": "4 的人，勇敢的人，莽撞的人 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1471,
    "word": "monté",
    "phonetic": "[mɔ̃te]",
    "type": "",
    "translation": "adj. 安装 5 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1472,
    "word": "préparatif",
    "phonetic": "[preparatif]",
    "type": "",
    "translation": "n.m. 准备；准备工作[多用复数] 6 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1473,
    "word": "soumis",
    "phonetic": "[sumi, -z]",
    "type": "",
    "translation": "adj. 服从的， 顺从的， 听话的， 驯服的 8 119",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1474,
    "word": "situé",
    "phonetic": "[sitɥe]",
    "type": "",
    "translation": "a. 位于……的，座落在……的 9 120",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1475,
    "word": "réglementaire",
    "phonetic": "[regləmɑ̃tεr]",
    "type": "",
    "translation": "adj. 规定的；合乎规定的；有关规章条例的 0 120",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1476,
    "word": "amarre",
    "phonetic": "[amar]",
    "type": "",
    "translation": "n.f. 船缆，绳索 1 120",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1477,
    "word": "portion",
    "phonetic": "[pɔrsjɔ̃]",
    "type": "",
    "translation": "n.f. 一部分；一份，一客[指食物] 2 120",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1478,
    "word": "épouvanter",
    "phonetic": "[epuvɑ̃te]",
    "type": "",
    "translation": "v.t. 使惊恐，使恐怖，使畏惧 3 120 v.t.， v.pr. 安顿，安置，安排，安插；许配成亲；放入",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1479,
    "word": "caser",
    "phonetic": "[kaze]",
    "type": "",
    "translation": "4 格内 34 of 35 单词 音标 解释 No. 120",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1480,
    "word": "voleur",
    "phonetic": "[vɔlœr, -øz]",
    "type": "",
    "translation": "n. 贼，强盗；暴利的商人 5 35 of 35",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1481,
    "word": "océan",
    "phonetic": "[ɔseɑ̃]",
    "type": "",
    "translation": "n.m. 海洋；大洋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1482,
    "word": "peur",
    "phonetic": "[pœr]",
    "type": "",
    "translation": "n.f. 怕，害怕；畏惧，恐惧",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1483,
    "word": "danger",
    "phonetic": "[dɑ̃ʒe]",
    "type": "",
    "translation": "n.m. 危险",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1484,
    "word": "compliqué",
    "phonetic": "[kɔ̃plike]",
    "type": "",
    "translation": "a. 复杂的；难懂的，难于理解的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1485,
    "word": "toi",
    "phonetic": "[twa]",
    "type": "",
    "translation": "pron.pers. 你 v.i. 来，来到；出现，产生；发生，突然来临；来自；出",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1486,
    "word": "planète",
    "phonetic": "[planεt]",
    "type": "",
    "translation": "n.f. 行星 adj. 长的，远的；长久的，久远的 n.m.长，长度 adv.许",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1487,
    "word": "important",
    "phonetic": "[ɛ̃pɔrtɑ̃]",
    "type": "",
    "translation": "a. 重要的，重大的；大量的，可观的 a. 粗壮的；胖的；厚的；大的；重大的；严重的；n.m.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1488,
    "word": "numéro",
    "phonetic": "[nymero]",
    "type": "",
    "translation": "n.m. 号数，号码；（期刊的）期，号；节目 3 of 12 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1489,
    "word": "exemple",
    "phonetic": "[εgzɑ̃pl]",
    "type": "",
    "translation": "n.m. 模范，典范，榜样；教训；实例；样本",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1490,
    "word": "rose",
    "phonetic": "[roz]",
    "type": "",
    "translation": "色情的；n.m. 玫瑰红，粉红色",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1491,
    "word": "aimé",
    "phonetic": "[εme]",
    "type": "",
    "translation": "被爱的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1492,
    "word": "couleur",
    "phonetic": "[kulœr]",
    "type": "",
    "translation": "色彩 v.t. 开，打开；开辟；开放；开办；v.i. 开启；开张；开",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1493,
    "word": "explication",
    "phonetic": "[εksplikasjɔ̃]",
    "type": "",
    "translation": "n.f. 说明，解释；说明原因，解释理由",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1494,
    "word": "bonjour",
    "phonetic": "[bɔ̃ʒur]",
    "type": "",
    "translation": "n.m. 早安！日安！你好！",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1495,
    "word": "jardin",
    "phonetic": "[ʒardɛ̃]",
    "type": "",
    "translation": "n.m. 园子，菜园，花园",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1496,
    "word": "fleur",
    "phonetic": "[flœr]",
    "type": "",
    "translation": "n.f. 花；有花植物；花的图案；花状物；精华，精粹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1497,
    "word": "unique",
    "phonetic": "[ynik]",
    "type": "",
    "translation": "a. 惟一的；独特的，无与伦比的；少有的，少见的 v.i. 走，行走；踏，踩；（车辆、船的）行驶；运行，运",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1498,
    "word": "beauté",
    "phonetic": "[bote]",
    "type": "",
    "translation": "n.f. 美，优美，美丽；高尚，崇高",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1499,
    "word": "lampe",
    "phonetic": "[lɑ̃p]",
    "type": "",
    "translation": "n.f. 灯；照明器具；（电）灯泡 n.m. 击，打，敲，撞；一举，一着，一下；敲打声，撞",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1500,
    "word": "plaisir",
    "phonetic": "[plεzir]",
    "type": "",
    "translation": "n.m. 愉快，高兴，快乐；乐趣；娱乐 n.m. 周围，周长；环绕，环行；散步；转动，旋转；旋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1501,
    "word": "responsable",
    "phonetic": "[rεspɔ̃sabl]",
    "type": "",
    "translation": "因的；n. 负责人 v.i. 喊，叫；大声叫嚷；（物体）嘎吱响；v.t. 呼喊，喊",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1502,
    "word": "raisonnable",
    "phonetic": "[rεzɔnabl]",
    "type": "",
    "translation": "a. 有理性的，有理智的；合理的；公道的，适当的 v.i. 剩下，留下，停留；逗留；留在某处不动；保持，处",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1503,
    "word": "différent",
    "phonetic": "[diferɑ̃]",
    "type": "",
    "translation": "a. 不同的，相异的；变成不同的，变样的 n.m. 小圆点；标点；句号；分数；百分点；地方；要",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1504,
    "word": "village",
    "phonetic": "[vilaʒ]",
    "type": "",
    "translation": "n.m. 村庄，乡村；全村的人 v.t. 重新看，再看；重见某人，再见某人；复查，复核，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1505,
    "word": "semaine",
    "phonetic": "[s(ə)mεn]",
    "type": "",
    "translation": "n.f. 一周；工作周；周，星期；周薪 v.t. 数；计算；算上，包括；拥有；算入，算作；v.i.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1506,
    "word": "activité",
    "phonetic": "[aktivite]",
    "type": "",
    "translation": "n.f. 活动 v.t. 再拿，再取；拿回；收回；恢复；夺回，收复；重新",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1507,
    "word": "importance",
    "phonetic": "[ɛ̃pɔrtɑ̃s]",
    "type": "",
    "translation": "n.f. 重要，重要性，重大；声望，影响",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1508,
    "word": "dessiner",
    "phonetic": "[desine]",
    "type": "",
    "translation": "v.t. 画；绘画；使轮廓、线条突出",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1509,
    "word": "portrait",
    "phonetic": "[pɔrtrε]",
    "type": "",
    "translation": "n.m. 肖像，画像；相片；描绘；脸，面孔",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1510,
    "word": "peintre",
    "phonetic": "[pɛ̃tr]",
    "type": "",
    "translation": "n.m. 画家，画师；油漆工，漆匠 a. 开着的；开放的；易于接受的；坦率的；开朗的；公",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1511,
    "word": "ouvert",
    "phonetic": "[uvεr, -t]",
    "type": "",
    "translation": "开的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1512,
    "word": "faim",
    "phonetic": "[fɛ̃]",
    "type": "",
    "translation": "n.f. 饿，饥饿；饥荒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1513,
    "word": "doucement",
    "phonetic": "[dusmɑ̃]",
    "type": "",
    "translation": "愉快地；小心地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1514,
    "word": "endroit",
    "phonetic": "[ɑ̃drwa]",
    "type": "",
    "translation": "n.m. 地方，场所；（身体等的）部位；居住地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1515,
    "word": "longtemps",
    "phonetic": "[lɔ̃tɑ̃]",
    "type": "",
    "translation": "adv. 长久地，很久",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1516,
    "word": "caisse",
    "phonetic": "[kεs]",
    "type": "",
    "translation": "n.f. 1.箱子，外壳 2.收银台",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1517,
    "word": "herbe",
    "phonetic": "[εrb]",
    "type": "",
    "translation": "n.f. 草，草本植物；草地，草坪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1518,
    "word": "prince",
    "phonetic": "[prɛ̃s]",
    "type": "",
    "translation": "n.m. 君主，君王；王子；太子；亲王",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1519,
    "word": "avion",
    "phonetic": "[avjɔ̃]",
    "type": "",
    "translation": "n.m. 飞机 v.i. 飞，飞翔；飞行；飞舞；v.t. 偷窃，抢劫；诈骗；宰",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1520,
    "word": "brusquement",
    "phonetic": "[bryskəmɑ̃]",
    "type": "",
    "translation": "adv. 粗暴地， 生硬地；突然地， 急剧地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1521,
    "word": "tellement",
    "phonetic": "[tεlmɑ̃]",
    "type": "",
    "translation": "adv. 这样地， 如此地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1522,
    "word": "preuve",
    "phonetic": "[prœv]",
    "type": "",
    "translation": "n.f. 证据，证明；标志，表示 a. 平静的，安稳的，安静的；不吵闹的；安宁的，恬静",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1523,
    "word": "tranquille",
    "phonetic": "[trɑ̃kil]",
    "type": "",
    "translation": "的 nà xiē (形) ces (代) les; ceux (celles) -là; celui, 278 ceux celle, ceux, celles",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1524,
    "word": "semblable",
    "phonetic": "[sɑ̃blabl]",
    "type": "",
    "translation": "a. 相似的，相像的；如此的；n. 同样的人，同类的东西 8 of 12 单词 音标 解释 No. n.m. 出发；离开；起飞；启航；开端，开始；出发点，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1525,
    "word": "effort",
    "phonetic": "[efɔr]",
    "type": "",
    "translation": "n.m. 用力；努力，竭力，尽力",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1526,
    "word": "invisible",
    "phonetic": "[ɛ̃vizibl]",
    "type": "",
    "translation": "a. 看不见的，不可见的 v.t. 推，推进；驱，赶；促使，促进；发出（喊叫声）；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1527,
    "word": "arracher",
    "phonetic": "[ara∫e]",
    "type": "",
    "translation": "v.t.（连根）拔；夺去，争得；力夺，巧夺；扯下，拔下 prép. 自……以来，从……以后；从……，自……；adv.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1528,
    "word": "étoile",
    "phonetic": "[etwal]",
    "type": "",
    "translation": "等的）明星",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1529,
    "word": "fragile",
    "phonetic": "[fraʒil]",
    "type": "",
    "translation": "的，脆弱的；不稳固的，不牢靠的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1530,
    "word": "cadeau",
    "phonetic": "[kado]",
    "type": "",
    "translation": "n.m. 礼物，礼品",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1531,
    "word": "tas",
    "phonetic": "[tɑ]",
    "type": "",
    "translation": "n.m. 堆，垛；工地 a. 快的；迅速的，匆忙的；敏捷的；速成的；n.m. 特快",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1532,
    "word": "lentement",
    "phonetic": "[lɑ̃tmɑ̃]",
    "type": "",
    "translation": "adv. 缓慢地，慢腾腾地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1533,
    "word": "douceur",
    "phonetic": "[dusœr]",
    "type": "",
    "translation": "n.f. 甜；轻柔；美妙；甜蜜；温和；温柔",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1534,
    "word": "marchand",
    "phonetic": "[mar∫ɑ̃, -d]",
    "type": "",
    "translation": "n. 商人，生意人；a. 销售的；商品的；商业的；经商的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1535,
    "word": "ordre",
    "phonetic": "[ɔrdr]",
    "type": "",
    "translation": "畴；命令",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1536,
    "word": "change",
    "phonetic": "[∫ɑ̃ʒ]",
    "type": "",
    "translation": "n.m. 交换，兑换，外汇交易；外汇兑换率",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1537,
    "word": "autorité",
    "phonetic": "[otɔrite]",
    "type": "",
    "translation": "n.f. 威信，威望；权威人士；权力，职权；权力机关",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1538,
    "word": "bête",
    "phonetic": "[bεt]",
    "type": "",
    "translation": "n.f. 兽；畜生；牲口；a. 傻的，愚蠢的；糊涂的；不幸的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1539,
    "word": "honte",
    "phonetic": "[ɔ̃t]",
    "type": "",
    "translation": "虚音H n.f. 羞愧，惭愧；耻辱，羞耻",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1540,
    "word": "addition",
    "phonetic": "[adisjɔ̃]",
    "type": "",
    "translation": "n.f. 增加，增添；增加物；[数]加法；（餐馆等的）账单",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1541,
    "word": "content",
    "phonetic": "[kɔ̃tɑ̃, -t]",
    "type": "",
    "translation": "a. 高兴的；满意的，满足的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1542,
    "word": "paysage",
    "phonetic": "[peizaʒ]",
    "type": "",
    "translation": "n.m. 风景，景色；风景画，风景照；面貌，格局",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1543,
    "word": "écho",
    "phonetic": "[eko]",
    "type": "",
    "translation": "响，共鸣，响应",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1544,
    "word": "mouton",
    "phonetic": "[mutɔ̃]",
    "type": "",
    "translation": "n.m. 羊，绵羊；羊肉 adj. 做好的， 完成的； 成功的， 出色的；够成功的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1545,
    "word": "réussi",
    "phonetic": "[reysi]",
    "type": "",
    "translation": "够出色的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1546,
    "word": "dessin",
    "phonetic": "[desɛ̃]",
    "type": "",
    "translation": "n.m. 素描，图画；绘画；轮廓，外形",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1547,
    "word": "fermé",
    "phonetic": "[fεrme]",
    "type": "",
    "translation": "a. 封闭的；关闭的，合拢的；不爱交往的；不开朗的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1548,
    "word": "soif",
    "phonetic": "[swaf]",
    "type": "",
    "translation": "n.f. 渴；渴望，欲望 a. 荒谬的，荒唐的，荒诞的；[哲]不合逻辑的，违背逻辑",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1549,
    "word": "absurde",
    "phonetic": "[apsyrd]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1550,
    "word": "crayon",
    "phonetic": "[krεjɔ̃]",
    "type": "",
    "translation": "n.m. 铅笔；铅笔状物 10 of 12 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1551,
    "word": "tailler",
    "phonetic": "[taje]",
    "type": "",
    "translation": "v.t. 切削，剪，割；凿；裁剪；琢磨，修剪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1552,
    "word": "drame",
    "phonetic": "[dram]",
    "type": "",
    "translation": "n.m. 戏剧；正剧；剧本；悲剧，惨剧，悲惨事件",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1553,
    "word": "plante",
    "phonetic": "[plɑ̃t]",
    "type": "",
    "translation": "n.f. 植物；作物；花草",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1554,
    "word": "fontaine",
    "phonetic": "[fɔ̃tεn]",
    "type": "",
    "translation": "n.f. 泉，泉水；喷泉，喷水池；水槽",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1555,
    "word": "fatigué",
    "phonetic": "[fatige]",
    "type": "",
    "translation": "a. 疲劳的；显得疲劳的；用旧的，用坏的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1556,
    "word": "assis",
    "phonetic": "[asi, -z]",
    "type": "",
    "translation": "a. 坐着的；稳固的，稳定的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1557,
    "word": "consoler",
    "phonetic": "[kɔ̃sɔle]",
    "type": "",
    "translation": "v.t. 安慰，慰问；鼓励；减轻，使缓和",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1558,
    "word": "faible",
    "phonetic": "[fεbl]",
    "type": "",
    "translation": "的，不坚固的；微弱的；微薄的 a. 天真的；幼稚的，头脑简单的；朴素的；n. 天真的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1559,
    "word": "naïf",
    "phonetic": "[naif, naiv]",
    "type": "",
    "translation": "人；幼稚的人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1560,
    "word": "utile",
    "phonetic": "[ytil]",
    "type": "",
    "translation": "a. 有用的，有益的；可用的，有效的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1561,
    "word": "poule",
    "phonetic": "[pul]",
    "type": "",
    "translation": "n.f. 母鸡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1562,
    "word": "intéressant",
    "phonetic": "[ɛ̃terɛsɑ̃]",
    "type": "",
    "translation": "ou [ɛ̃teresɑ̃] a. 有趣的；引人注目的；值得关心的；有利的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1563,
    "word": "blé",
    "phonetic": "[ble]",
    "type": "",
    "translation": "n.m. 小麦",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1564,
    "word": "adieu",
    "phonetic": "[adjø]",
    "type": "",
    "translation": "interj.， n.m. 再见！永别了！ v.t. （使）空，倒空；喝光；吃光；使撤出，使撤离；疏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1565,
    "word": "armer",
    "phonetic": "[arme]",
    "type": "",
    "translation": "v.t. 武装，配备武器；装备；上膛， 装弹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1566,
    "word": "rougir",
    "phonetic": "[ruʒir]",
    "type": "",
    "translation": "v.t. 使变红，染红；v.i. 变红；（由于激动等而）脸红 adv. 马上，过会儿；今天下午，下午； ～...～ 时而…时",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1567,
    "word": "tantôt",
    "phonetic": "[tɑ̃to]",
    "type": "",
    "translation": "而…",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1568,
    "word": "gravement",
    "phonetic": "[gravmɑ̃]",
    "type": "",
    "translation": "adv. 严肃地， 认真地； 庄严地；严重地； 危险地",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1569,
    "word": "calcul",
    "phonetic": "[kalkyl]",
    "type": "",
    "translation": "n.m. 1.计算，算数 2.估计",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1570,
    "word": "grammaire",
    "phonetic": "[gramεr]",
    "type": "",
    "translation": "n.f. 语法；语法学；语法书",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1571,
    "word": "tombé",
    "phonetic": "[tɔ̃be]",
    "type": "",
    "translation": "adj. 落下的, 掉下来的；被贬谪的, 被废黜的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1572,
    "word": "papillon",
    "phonetic": "[papijɔ̃]",
    "type": "",
    "translation": "n.m. 蝴蝶，蛾 adj. 被占用的；被借用的；忙碌的；罹病的，遭受…的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1573,
    "word": "catastrophe",
    "phonetic": "[katastrɔf]",
    "type": "",
    "translation": "n.f. 严重灾难；灾难性事件 adj. 熄灭的；暗淡的，微弱的；减弱的，消失的，灭绝",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1574,
    "word": "éteint",
    "phonetic": "[etɛ̃]",
    "type": "",
    "translation": "的；极度衰弱的，无表情的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1575,
    "word": "puits",
    "phonetic": "[pɥi]",
    "type": "",
    "translation": "n.m. 水井；（竖）坑；矿井",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1576,
    "word": "serpent",
    "phonetic": "[sεrpɑ̃]",
    "type": "",
    "translation": "n.m. 蛇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1577,
    "word": "disparition",
    "phonetic": "[disparisjɔ̃]",
    "type": "",
    "translation": "n.f. 消失；失踪；遗失；消亡，灭亡，灭绝；死亡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1578,
    "word": "habillé",
    "phonetic": "[abije]",
    "type": "",
    "translation": "adj. 穿着衣服的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1579,
    "word": "gronder",
    "phonetic": "[grɔ̃de]",
    "type": "",
    "translation": "（对孩子）训斥，责骂",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1580,
    "word": "seau",
    "phonetic": "[so]",
    "type": "",
    "translation": "n.m. 水桶；桶；一桶之量",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1581,
    "word": "graine",
    "phonetic": "[grεn]",
    "type": "",
    "translation": "n.f. 种子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1582,
    "word": "grandiose",
    "phonetic": "[grɑ̃djoz]",
    "type": "",
    "translation": "a. 伟大的，宏伟的，雄伟的；壮丽的，壮观的；崇高的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1583,
    "word": "volcan",
    "phonetic": "[vɔlkɑ̃]",
    "type": "",
    "translation": "n.m. 火山",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1584,
    "word": "épine",
    "phonetic": "[epin]",
    "type": "",
    "translation": "n.f.（植物的）刺，棘；（某些动物的）刺，壳针 n.m. 宗教仪式；礼仪，礼节；仪式，典礼；常规；习",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1585,
    "word": "rite",
    "phonetic": "[rit]",
    "type": "",
    "translation": "俗，惯例",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1586,
    "word": "bâiller",
    "phonetic": "[bɑje]",
    "type": "",
    "translation": "v.i. 打呵欠；半开，微开；未关严，未关紧",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1587,
    "word": "marteau",
    "phonetic": "[marto]",
    "type": "",
    "translation": "n.m. 锤子；门环 v.t.， v.pr. 使烦恼，使操心；操劳，苦干，疲于；花气",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1588,
    "word": "découragé",
    "phonetic": "[dekuraʒe]",
    "type": "",
    "translation": "a.泄气的，沮丧的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1589,
    "word": "trouvé",
    "phonetic": "[truve]",
    "type": "",
    "translation": "adj. 拾到的， 捡来的；很恰当的， 绝妙的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1590,
    "word": "réverbère",
    "phonetic": "[revεrbεr]",
    "type": "",
    "translation": "n.m. 反射镜；路灯",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1591,
    "word": "rallumer",
    "phonetic": "[ralyme]",
    "type": "",
    "translation": "v.t. 重新点燃；重新唤起，重新激起，重新引起 v.t. 驯养，驯化，驯服（动物）；使顺从，使听话，使变",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1592,
    "word": "apprivoiser",
    "phonetic": "[aprivwaze]",
    "type": "",
    "translation": "得容易接近[指人]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1593,
    "word": "sauf",
    "phonetic": "[sof]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1594,
    "word": "arbuste",
    "phonetic": "[arbyst]",
    "type": "",
    "translation": "n.m. 小灌木；小矮树 n.m. 光，光芒；[物]辐射，放射，发射；辐射能；光",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1595,
    "word": "rayonnement",
    "phonetic": "[rεjɔnmɑ̃]",
    "type": "",
    "translation": "辉，威望；影响，传播",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1596,
    "word": "grelot",
    "phonetic": "[grəlo]",
    "type": "",
    "translation": "n.m. 铃，铃铛",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1597,
    "word": "flâner",
    "phonetic": "[flɑne]",
    "type": "",
    "translation": "v.i. 闲逛，闲荡；偷懒，游手好闲，无所事事",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1598,
    "word": "pétale",
    "phonetic": "[petal]",
    "type": "",
    "translation": "n.m. 花瓣 12 of 12",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1599,
    "word": "un",
    "phonetic": "[œ̃]",
    "type": "",
    "translation": "a. num. card. 一；第一；art. indéf. 一个，一次",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1600,
    "word": "deux",
    "phonetic": "[dø]",
    "type": "",
    "translation": "a. num. card. inv. 二，两；第二；n.m. inv. 二，二字 a. num. card. inv. 四；第四；n.m. inv. 四；[牌戏]四",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1601,
    "word": "quatre",
    "phonetic": "[katr]",
    "type": "",
    "translation": "点 a. num. card. inv. 五；第五；n.m. inv. 五字；（扑克",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1602,
    "word": "cinq",
    "phonetic": "[sɛ̃k]",
    "type": "",
    "translation": "中的）5 adj.num.card.， adj.inv. 六；（一个月份的）6日；6",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1603,
    "word": "sept",
    "phonetic": "[sεt]",
    "type": "",
    "translation": "的）七点",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1604,
    "word": "neuf",
    "phonetic": "[nœf]",
    "type": "",
    "translation": "a. 新的 / n.m. 九；新东西",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1605,
    "word": "dix",
    "phonetic": "[dis]",
    "type": "",
    "translation": "a. num. card. inv. 十；第十 adj.num.card.， adj.inv. （第）十一 ；第十一号房间",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1606,
    "word": "quatorze",
    "phonetic": "[katɔrz]",
    "type": "",
    "translation": "a. num. card. inv. 十四；第十四；n.m. inv. 十四 a. num. card. inv. 十五；第十五；n.m. inv. 十五；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1607,
    "word": "quinze",
    "phonetic": "[kɛ̃z]",
    "type": "",
    "translation": "[体]橄榄球队 adj.num.card.， adj.inv. 十六；第十六；（一个月份",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1608,
    "word": "dix-sept",
    "phonetic": "[disεt]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 十七；第十七",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1609,
    "word": "dix-huit",
    "phonetic": "[dizɥit]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 十八；第十八",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1610,
    "word": "dix-neuf",
    "phonetic": "[diznœf]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 十九；第十九",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1611,
    "word": "vingt-deux",
    "phonetic": "[vɛ̃tdø]",
    "type": "",
    "translation": "flics...",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1612,
    "word": "trente-trois",
    "phonetic": "[trɑ̃ttrwa]",
    "type": "",
    "translation": "数字 33",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1613,
    "word": "quarante",
    "phonetic": "[karɑ̃t]",
    "type": "",
    "translation": "a. num. card. inv. 四十；第四十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1614,
    "word": "cinquante",
    "phonetic": "[sɛ̃kɑ̃t]",
    "type": "",
    "translation": "a. num. card. inv. 五十；第五十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1615,
    "word": "soixante",
    "phonetic": "[swasɑ̃t]",
    "type": "",
    "translation": "adj.num.card.， adj.inv. 六十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1616,
    "word": "soixante-dix",
    "phonetic": "[swasɑ̃tdis]",
    "type": "",
    "translation": "n.m.， adj. 七十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1617,
    "word": "quatre-vingts",
    "phonetic": "[katrəvɛ̃]",
    "type": "",
    "translation": "a. num. card. 八十；第八十 28 quatre-vingt-un 八十一",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1618,
    "word": "quatre-vingt-dix",
    "phonetic": "[katrəvɛ̃dis]",
    "type": "",
    "translation": "adj.num.card. 九十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1619,
    "word": "cent",
    "phonetic": "[sɑ̃]",
    "type": "",
    "translation": "a. num. card. 百；第一百；很多，许多",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1620,
    "word": "mille",
    "phonetic": "[mil]",
    "type": "",
    "translation": "a. num. card. inv. 一千；第一千；许多的 n.m. 百万；百万法郎、百万元或百万镑等；巨大数目，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1621,
    "word": "milliard",
    "phonetic": "[miljar]",
    "type": "",
    "translation": "n.m. 十亿；巨大数目 a. 第一的；原始的；第一位的，首要的；初步的，基本",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1622,
    "word": "deuxième",
    "phonetic": "[døzjεm]",
    "type": "",
    "translation": "a. num. ord. 第二；n. 第二个，第二名",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1623,
    "word": "second",
    "phonetic": "[s(ə)gɔ̃, -d]",
    "type": "",
    "translation": "a. 第二；另外一个；次要的，二等的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1624,
    "word": "troisième",
    "phonetic": "[trwazjεm]",
    "type": "",
    "translation": "adj.num.ord. 第三个；第三；三分之一的 a. num. ord. 第四；n. 第四名；n.f. 四年级[初中三年",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1625,
    "word": "quatrième",
    "phonetic": "[katrijεm]",
    "type": "",
    "translation": "级]；[汽]第四档速度 a. num. ord. 第五（点）；n. 第五名；a.， n.m. 五分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1626,
    "word": "cinquième",
    "phonetic": "[sɛ̃kjεm]",
    "type": "",
    "translation": "之一（的）；n.f.（法国的）五年级；（车辆的）第五挡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1627,
    "word": "sixième",
    "phonetic": "[sizjεm]",
    "type": "",
    "translation": "adj.num.ord. 六分之一；第六个；第六",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1628,
    "word": "septième",
    "phonetic": "[sεtjεm]",
    "type": "",
    "translation": "a. num. ord. 第七；n. 第七个，第七名；n.f. 七年级 adj.num.ord. 第八；第八个，第八名；八分之一的；八",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1629,
    "word": "huitième",
    "phonetic": "['ɥitjεm]",
    "type": "",
    "translation": "虚音H 分之一 ；八年级",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1630,
    "word": "neuvième",
    "phonetic": "[nœvjεm]",
    "type": "",
    "translation": "adj.num.ord. 第九（个） ；九分之一",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1631,
    "word": "dixième",
    "phonetic": "[dizjεm]",
    "type": "",
    "translation": "a.， n.m. 十分之一（的） adj.num.ord. 第十一（个）；十一分之一；[乐]十一度",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1632,
    "word": "onzième",
    "phonetic": "[ɔ̃zjεm]",
    "type": "",
    "translation": "（音程） adj.num.ord. 十二分之一；第十二个；十二分之一",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1633,
    "word": "douzième",
    "phonetic": "[duzjεm]",
    "type": "",
    "translation": "（的）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1634,
    "word": "treizième",
    "phonetic": "[trεzjεm]",
    "type": "",
    "translation": "adj.num.ord. 十三分之一；第十三个；第十三",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1635,
    "word": "quatorzième",
    "phonetic": "[katɔrzjεm]",
    "type": "",
    "translation": "adj.num.ord. 第十四（个）；十四分之一（的） adj.num.ord. 第十五； 第十五个， 第十五名；十五分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1636,
    "word": "quinzième",
    "phonetic": "[kɛ̃zjεm]",
    "type": "",
    "translation": "之一（的） adj.num.ord. 第十六（个），第十六名；十六世纪；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1637,
    "word": "seizième",
    "phonetic": "[sεzjεm]",
    "type": "",
    "translation": "（巴黎）第十六区；第十六天；十六分之一；[乐]十六度 （音程）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1638,
    "word": "dix-huitième",
    "phonetic": "[dizɥitjεm]",
    "type": "",
    "translation": "adj.num.ord. 第十八；十八分之一（的）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1639,
    "word": "dix-neuvième",
    "phonetic": "[diznœvjεm]",
    "type": "",
    "translation": "adj.num.ord. 第十九",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1640,
    "word": "vingtième",
    "phonetic": "[vɛ̃tjεm]",
    "type": "",
    "translation": "adj.num.ord. 二十分之一；第二十个；第二十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1641,
    "word": "trentième",
    "phonetic": "[trɑ̃tjεm]",
    "type": "",
    "translation": "adj.num.ord. 三十分之一；第三十个；第三十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1642,
    "word": "quarantième",
    "phonetic": "[karɑ̃tjεm]",
    "type": "",
    "translation": "adj.num.ord. 第四十（个）；四十分之一（的） adj.num.ord. 五十分之一；第五十个；第五十；五十分",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1643,
    "word": "cinquantième",
    "phonetic": "[sɛ̃kɑ̃tjεm]",
    "type": "",
    "translation": "之一的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1644,
    "word": "soixantième",
    "phonetic": "[swasɑ̃tjεm]",
    "type": "",
    "translation": "adj.num.ord. 六十分之一；第六十个；第六十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1645,
    "word": "soixante-dixième",
    "phonetic": "[swasɑ̃tdizjεm]",
    "type": "",
    "translation": "n.m.， adj. 七十分之一；第七十个；第七十",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1646,
    "word": "quatre-vingtième",
    "phonetic": "[katrəvɛ̃tjεm]",
    "type": "",
    "translation": "adj.num.ord. 第八十（个）： 八十分之一（的）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1647,
    "word": "quatre-vingt-dixième",
    "phonetic": "[katrəvɛ̃dizjεm]",
    "type": "",
    "translation": "adj.num.ord. 第九十（个）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1648,
    "word": "centième",
    "phonetic": "[sɑ̃tjεm]",
    "type": "",
    "translation": "a. num. ord. 第一百；a.， n.m. 百分之一 adj.num.ord. 第一千（个）；千分之一（的）；[数，",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1649,
    "word": "millième",
    "phonetic": "[miljεm]",
    "type": "",
    "translation": "军]角密度， 密位",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1650,
    "word": "millionième",
    "phonetic": "[miljɔnjεm]",
    "type": "",
    "translation": "adj.num.ord. 第一百万（个） ；百万分之一（的）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1651,
    "word": "milliardième",
    "phonetic": "[miljardjεm]",
    "type": "",
    "translation": "adj.num.ord. 第十亿；十亿分之一的；十亿分之一",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1652,
    "word": "date",
    "phonetic": "[dat]",
    "type": "",
    "translation": "n.f. 日期，年月日；时期，时代",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1653,
    "word": "demi",
    "phonetic": "[d(ə)mi]",
    "type": "",
    "translation": "a. 一半的，半个的；不完全的；n.m. 一半，半个",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1654,
    "word": "tiers",
    "phonetic": "[tjεr, -s]",
    "type": "",
    "translation": "n.m. 三分之一；第三者；外人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1655,
    "word": "virgule",
    "phonetic": "[virgyl]",
    "type": "",
    "translation": "n.f. 逗号；[数]小数点 2 of 4 单词 音标 解释 No. n.m. 小圆点；标点；句号；分数；百分点；地方；要",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1656,
    "word": "journée",
    "phonetic": "[ʒurne]",
    "type": "",
    "translation": "n.f. 白天；一天，一昼夜；工作日；日薪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1657,
    "word": "midi",
    "phonetic": "[midi]",
    "type": "",
    "translation": "n.m. 中午，正午",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1658,
    "word": "après-midi",
    "phonetic": "[aprεmidi]",
    "type": "",
    "translation": "n.m. 下午",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1659,
    "word": "soirée",
    "phonetic": "[sware]",
    "type": "",
    "translation": "n.f. 晚间，晚上；晚会",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1660,
    "word": "demain",
    "phonetic": "[d(ə)mɛ̃]",
    "type": "",
    "translation": "adv. 明天，明日；将来，未来",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1661,
    "word": "veille",
    "phonetic": "[vεj]",
    "type": "",
    "translation": "n.f. 熬夜；夜间值班，夜间警戒；前一天",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1662,
    "word": "après-demain",
    "phonetic": "[aprεdmɛ̃]",
    "type": "",
    "translation": "adv. 后天",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1663,
    "word": "plupart",
    "phonetic": "[plypar]",
    "type": "",
    "translation": "n.f. 大多数，大部分；大多数人，大部分人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1664,
    "word": "mardi",
    "phonetic": "[mardi]",
    "type": "",
    "translation": "n.m. 星期二",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1665,
    "word": "jeudi",
    "phonetic": "[ʒødi]",
    "type": "",
    "translation": "n.m. 星期四",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1666,
    "word": "vendredi",
    "phonetic": "[vɑ̃drədi]",
    "type": "",
    "translation": "n.m. 星期五",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1667,
    "word": "dimanche",
    "phonetic": "[dimɑ̃∫]",
    "type": "",
    "translation": "n.m. 星期日",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1668,
    "word": "janvier",
    "phonetic": "[ʒɑ̃vje]",
    "type": "",
    "translation": "n.m. 一月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1669,
    "word": "février",
    "phonetic": "[fevrije]",
    "type": "",
    "translation": "n.m. 二月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1670,
    "word": "mars",
    "phonetic": "[mars]",
    "type": "",
    "translation": "n.m. 三月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1671,
    "word": "avril",
    "phonetic": "[avril]",
    "type": "",
    "translation": "n.m. 四月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1672,
    "word": "juin",
    "phonetic": "[ʒɥɛ̃]",
    "type": "",
    "translation": "n.m. 六月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1673,
    "word": "juillet",
    "phonetic": "[ʒɥijε]",
    "type": "",
    "translation": "n.m. 七月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1674,
    "word": "août",
    "phonetic": "[u(t)]",
    "type": "",
    "translation": "n.m. 八月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1675,
    "word": "décembre",
    "phonetic": "[desɑ̃br]",
    "type": "",
    "translation": "n.m. 十二月",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1676,
    "word": "an",
    "phonetic": "[ɑ̃]",
    "type": "",
    "translation": "n.m. 年；年龄",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1677,
    "word": "décennie",
    "phonetic": "[deseni]",
    "type": "",
    "translation": "n.f. 十年",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1678,
    "word": "siècle",
    "phonetic": "[sjεkl]",
    "type": "",
    "translation": "n.m. 百年；世纪；时期；时代；长时期",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1679,
    "word": "hiver",
    "phonetic": "[ivεr]",
    "type": "",
    "translation": "n.m. 冬，冬季，冬天；寒冬",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1680,
    "word": "printemps",
    "phonetic": "[prɛ̃tɑ̃]",
    "type": "",
    "translation": "n.m. 春天，春季；青春，青年时代 3 of 4 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1681,
    "word": "automne",
    "phonetic": "[otɔn]",
    "type": "",
    "translation": "ou [ɔtɔn] n.m. 秋天，秋季",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1682,
    "word": "zéro",
    "phonetic": "[zero]",
    "type": "",
    "translation": "n.m. 零；无；无能的人，一无可取的人 4 of 4",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1683,
    "word": "abalone",
    "phonetic": "[abalɔn]",
    "type": "",
    "translation": "n.m. 鲍鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1684,
    "word": "abricot",
    "phonetic": "[abriko]",
    "type": "",
    "translation": "n.m. 杏子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1685,
    "word": "acide",
    "phonetic": "[asid]",
    "type": "",
    "translation": "a. 酸的；尖酸的，刻薄的；n.m. [化]酸",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1686,
    "word": "ail",
    "phonetic": "[aj]",
    "type": "",
    "translation": "n.m. 大蒜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1687,
    "word": "alcool",
    "phonetic": "[alkɔl]",
    "type": "",
    "translation": "n.m. 酒精；白酒；酒精度高的饮料； 醇;乙醇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1688,
    "word": "aliments",
    "phonetic": "[alimɑ̃]",
    "type": "",
    "translation": "食物； 粮食； 水谷",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1689,
    "word": "amande",
    "phonetic": "[amɑ̃d]",
    "type": "",
    "translation": "n.f. 巴旦杏仁；核果的种仁",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1690,
    "word": "amer",
    "phonetic": "[amεr]",
    "type": "",
    "translation": "a. 苦的，苦涩的；痛苦的，辛酸的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1691,
    "word": "amuse-gueule",
    "phonetic": "[amyzgœl]",
    "type": "",
    "translation": "n.m. 开胃菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1692,
    "word": "ananas",
    "phonetic": "[anana(s)]",
    "type": "",
    "translation": "n.m. 菠萝，凤梨",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1693,
    "word": "anchois",
    "phonetic": "[ɑ̃∫wa]",
    "type": "",
    "translation": "n.m. 鳀鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1694,
    "word": "anguille",
    "phonetic": "[ɑ̃gij]",
    "type": "",
    "translation": "n.f. 鳗鱼， 鳝鱼；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1695,
    "word": "arachide",
    "phonetic": "[ara∫id]",
    "type": "",
    "translation": "n.f. 花生，落花生",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1696,
    "word": "arbouse",
    "phonetic": "[arbuz]",
    "type": "",
    "translation": "n.f. 野草莓",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1697,
    "word": "aubergine",
    "phonetic": "[obεrʒin]",
    "type": "",
    "translation": "n.f. 茄；茄子；a. inv. 深紫色的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1698,
    "word": "avocat",
    "phonetic": "[avɔka, -t]",
    "type": "",
    "translation": "n. 律师；牛油果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1699,
    "word": "azerole",
    "phonetic": "[azrɔl]",
    "type": "",
    "translation": "n.f. 意大利山楂",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1700,
    "word": "banane",
    "phonetic": "[banan]",
    "type": "",
    "translation": "n.f. 香蕉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1701,
    "word": "banquet",
    "phonetic": "[bɑ̃kε]",
    "type": "",
    "translation": "n.m. 1.宴会；2.果实",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1702,
    "word": "beignet",
    "phonetic": "[bεɲε]",
    "type": "",
    "translation": "n.m. （带馅的）炸糕，煎饼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1703,
    "word": "betterave",
    "phonetic": "[bεtra:v]",
    "type": "",
    "translation": "n.f. 食用甜菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1704,
    "word": "beurre",
    "phonetic": "[bœr]",
    "type": "",
    "translation": "n.m. 黄油；植物油脂",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1705,
    "word": "bière",
    "phonetic": "[bjεr]",
    "type": "",
    "translation": "n.f. 啤酒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1706,
    "word": "biscuit",
    "phonetic": "[biskɥi]",
    "type": "",
    "translation": "n.m. 饼干；小圆饼；素坯瓷，本色瓷，白瓷",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1707,
    "word": "bœuf",
    "phonetic": "[bœf]",
    "type": "",
    "translation": "n.m. 牛，公牛；牛肉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1708,
    "word": "boisson",
    "phonetic": "[bwasɔ̃]",
    "type": "",
    "translation": "n.f. 饮料；酒，含酒精饮料",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1709,
    "word": "bonbon",
    "phonetic": "[bɔ̃bɔ̃]",
    "type": "",
    "translation": "n.m. 糖果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1710,
    "word": "boucherie",
    "phonetic": "[bu∫ri]",
    "type": "",
    "translation": "n.f. 鲜肉业；肉店；屠杀",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1711,
    "word": "boulette",
    "phonetic": "[bulεt]",
    "type": "",
    "translation": "n.f. 小团，小球；丸子，小面团；差错，疏忽",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1712,
    "word": "brocoli",
    "phonetic": "[brɔkɔli]",
    "type": "",
    "translation": "n.m. 花茎甘蓝， 花椰菜；同",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1713,
    "word": "cacahuète",
    "phonetic": "[kakawεt, -ɥεt]",
    "type": "",
    "translation": "花生（指果实），花生仁；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1714,
    "word": "cacao",
    "phonetic": "[kakao]",
    "type": "",
    "translation": "n.m. 可可子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1715,
    "word": "café",
    "phonetic": "[kafe]",
    "type": "",
    "translation": "n.m. 咖啡豆；咖啡；咖啡馆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1716,
    "word": "canard",
    "phonetic": "[kanar]",
    "type": "",
    "translation": "n.m. 鸭，雄鸭",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1717,
    "word": "cantine",
    "phonetic": "[kɑ̃tin]",
    "type": "",
    "translation": "n.f. 食堂，饭厅；旅行箱",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1718,
    "word": "carotte",
    "phonetic": "[karɔt]",
    "type": "",
    "translation": "n.f. 胡萝卜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1719,
    "word": "carpe",
    "phonetic": "[karp]",
    "type": "",
    "translation": "n.f.， n.m. 腕；鲤鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1720,
    "word": "casse-croûte",
    "phonetic": "[kaskrut]",
    "type": "",
    "translation": "n.m. 快餐食品",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1721,
    "word": "céleri",
    "phonetic": "[sɛlri]",
    "type": "",
    "translation": "n.m. 芹菜，旱芹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1722,
    "word": "céréales",
    "phonetic": "[sereal]",
    "type": "",
    "translation": "谷物， 粮食 1 of 7 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1723,
    "word": "cerise",
    "phonetic": "[s(ə)riz]",
    "type": "",
    "translation": "n.f. 樱桃",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1724,
    "word": "champignon",
    "phonetic": "[∫ɑ̃piɲɔ̃]",
    "type": "",
    "translation": "n.m. 蘑菇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1725,
    "word": "chèvre",
    "phonetic": "[∫εvr]",
    "type": "",
    "translation": "n.f. 1.山羊，山羊皮 2.山羊奶酪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1726,
    "word": "chou",
    "phonetic": "[∫u]",
    "type": "",
    "translation": "n.m. 甘蓝，卷心菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1727,
    "word": "chou-fleur",
    "phonetic": "[∫uflœr]",
    "type": "",
    "translation": "n.m. 花椰菜， 花菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1728,
    "word": "ciboule",
    "phonetic": "[sibul]",
    "type": "",
    "translation": "n.f. 葱",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1729,
    "word": "ciboulette",
    "phonetic": "[sibulεt]",
    "type": "",
    "translation": "n.f. 细香葱， 小葱",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1730,
    "word": "citron",
    "phonetic": "[sitrɔ̃]",
    "type": "",
    "translation": "n.m. 柠檬；a. inv. 淡黄色的，柠檬黄的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1731,
    "word": "citronnade",
    "phonetic": "[sitrɔnad]",
    "type": "",
    "translation": "n.f. 柠檬水，柠檬汽水",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1732,
    "word": "citrouille",
    "phonetic": "[sitruj]",
    "type": "",
    "translation": "n.f. 南瓜；西葫芦；脑袋，大头",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1733,
    "word": "cochon",
    "phonetic": "[kɔ∫ɔ̃]",
    "type": "",
    "translation": "n.m. 猪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1734,
    "word": "compote",
    "phonetic": "[kɔ̃pɔt]",
    "type": "",
    "translation": "n.f. 果泥； 果糊",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1735,
    "word": "concombre",
    "phonetic": "[kɔ̃kɔ̃br]",
    "type": "",
    "translation": "n.m. 黄瓜 n.f. 糖果蜜饯业，甜食业；糖果蜜饯店；糖果蜜饯厂；糖",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1736,
    "word": "confiserie",
    "phonetic": "[kɔ̃fizri]",
    "type": "",
    "translation": "果，蜜饯，甜食",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1737,
    "word": "confiture",
    "phonetic": "[kɔ̃fityr]",
    "type": "",
    "translation": "n.f. 果酱",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1738,
    "word": "coq",
    "phonetic": "[kɔk]",
    "type": "",
    "translation": "n.m. 公鸡，雄鸡",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1739,
    "word": "coriandre",
    "phonetic": "[kɔrjɑ̃dr]",
    "type": "",
    "translation": "n.f. 芫荽",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1740,
    "word": "côtelette",
    "phonetic": "[kotlεt]",
    "type": "",
    "translation": "n.f. 排骨",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1741,
    "word": "courge",
    "phonetic": "[kurʒ]",
    "type": "",
    "translation": "n.f. 笋瓜；南瓜；西葫芦",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1742,
    "word": "crabe",
    "phonetic": "[krab]",
    "type": "",
    "translation": "n.m. 蟹 n.f. 奶油，乳油；香脂，乳膏；a. inv. 乳白色的，浅黄色",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1743,
    "word": "crème",
    "phonetic": "[krεm]",
    "type": "",
    "translation": "的，米色的 n.m. 绉纱，绉绸，绉布，绉呢；（丧事用的）黑纱；n.f.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1744,
    "word": "crêpe",
    "phonetic": "[krεp]",
    "type": "",
    "translation": "薄饼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1745,
    "word": "crevette",
    "phonetic": "[krəvεt]",
    "type": "",
    "translation": "n.f. 虾",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1746,
    "word": "écrevisse",
    "phonetic": "[ekrəvis]",
    "type": "",
    "translation": "n.f. 螯虾",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1747,
    "word": "cuire",
    "phonetic": "[kɥir]",
    "type": "",
    "translation": "v.t. 烧，煮，焖；烘，烤；蒸；焙烧",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1748,
    "word": "cuisine",
    "phonetic": "[kɥizin]",
    "type": "",
    "translation": "n.f. 厨房；烹调，烹饪；烹饪法；菜肴",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1749,
    "word": "daurade",
    "phonetic": "[dɔrad]",
    "type": "",
    "translation": "n.f. 黄鱼，黄花鱼，鲷",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1750,
    "word": "délicieux",
    "phonetic": "[delisjø]",
    "type": "",
    "translation": "a. 令人非常快乐的；可口的，美味的；芬芳的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1751,
    "word": "robinet",
    "phonetic": "[rɔbinε]",
    "type": "",
    "translation": "n.m.（流体的）开关，龙头；阀 n.f. 热的，暖的，烫的；保暖的；炎热的，发热的，发烫",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1752,
    "word": "chaude",
    "phonetic": "[ʃo:d]",
    "type": "",
    "translation": "的；热情的，激情的；急躁的；热烈的，激烈的，强烈 的；最近的，新近的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1753,
    "word": "potable",
    "phonetic": "[pɔtabl]",
    "type": "",
    "translation": "adj. 可饮的；还可以的 adj. 香料加多了的， 辛香作料加多了的， 辛辣的；轻佻",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1754,
    "word": "épicé",
    "phonetic": "[epise]",
    "type": "",
    "translation": "的， 色情的， 轻浮的， 猥亵的[指故事， 谈话]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1755,
    "word": "épicerie",
    "phonetic": "[episri]",
    "type": "",
    "translation": "n.f.（食品）杂货业；（食品）杂货店",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1756,
    "word": "épinard",
    "phonetic": "[epinar]",
    "type": "",
    "translation": "n.m. 菠菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1757,
    "word": "frire",
    "phonetic": "[frir]",
    "type": "",
    "translation": "v.t. 油炸，油氽，油煎；v.i. 在油中炸，在油中煎 v.跳，跳跃；猛扑，扑上去；蹦掉，飞掉；爆炸，炸毁；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1758,
    "word": "farine",
    "phonetic": "[farin]",
    "type": "",
    "translation": "n.f. 谷物磨成的粉，面粉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1759,
    "word": "fève",
    "phonetic": "[fεv]",
    "type": "",
    "translation": "n.f. 蚕豆；某些和蚕豆相似的豆类；蛹；（马）上腭肿胀",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1760,
    "word": "légumineuse",
    "phonetic": "[legyminøz]",
    "type": "",
    "translation": "【植物学】长荚果的；pl.豆科植物 2 of 7 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1761,
    "word": "figue",
    "phonetic": "[fig]",
    "type": "",
    "translation": "n.f. 无花果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1762,
    "word": "fraise",
    "phonetic": "[frεz]",
    "type": "",
    "translation": "n.f. 草莓",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1763,
    "word": "caillé",
    "phonetic": "[kaje]",
    "type": "",
    "translation": "n.m. 凝乳；干酪素",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1764,
    "word": "lait",
    "phonetic": "[lε]",
    "type": "",
    "translation": "n.m. 乳，奶；乳状液",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1765,
    "word": "fromage",
    "phonetic": "[frɔma:ʒ]",
    "type": "",
    "translation": "n.m. 干酪，奶酪",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1766,
    "word": "tofu",
    "phonetic": "[tɔfu]",
    "type": "",
    "translation": "n.m. 豆腐",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1767,
    "word": "fruit",
    "phonetic": "[frɥi]",
    "type": "",
    "translation": "n.m. 水果；果实；结果，成果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1768,
    "word": "galette",
    "phonetic": "[galεt]",
    "type": "",
    "translation": "n.f. 饼，烙饼，煎饼；黄油蛋糕，甜糕点 adj. 谷蛋白的， 面筋的；含谷蛋白的， 含面筋的；粘",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1769,
    "word": "glutineux",
    "phonetic": "[glytinø]",
    "type": "",
    "translation": "的， 粘性的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1770,
    "word": "gésier",
    "phonetic": "[ʒezje]",
    "type": "",
    "translation": "n.m. （禽类的）砂囊， 肫；胃； 肚子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1771,
    "word": "gingembre",
    "phonetic": "[ʒɛ̃ʒɑ̃br]",
    "type": "",
    "translation": "n.m. 姜，生姜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1772,
    "word": "ginseng",
    "phonetic": "[ʒinsεŋ]",
    "type": "",
    "translation": "n.m. 人参",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1773,
    "word": "glace",
    "phonetic": "[glas]",
    "type": "",
    "translation": "n.f. 冰；冰块；冰淇淋；玻璃；镜子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1774,
    "word": "glutamate",
    "phonetic": "[glytamat]",
    "type": "",
    "translation": "n.m. 【化学】谷氨酸盐（酯或根）， 味精",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1775,
    "word": "grenouille",
    "phonetic": "[grənuj]",
    "type": "",
    "translation": "n.f. 蛙",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1776,
    "word": "griller",
    "phonetic": "[grije]",
    "type": "",
    "translation": "v.t. 烤，烘；干炒；使干枯；烧毁；v.i. 烤，烘 a. 脂肪的；含脂肪的；油腻的；油性的；[印]粗体的；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1777,
    "word": "gras",
    "phonetic": "[grɑ, -s]",
    "type": "",
    "translation": "n.m. 肥肉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1778,
    "word": "hareng",
    "phonetic": "[arɑ̃]",
    "type": "",
    "translation": "虚音H n.m. 鲱鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1779,
    "word": "haricot",
    "phonetic": "[ariko]",
    "type": "",
    "translation": "虚音H n.m. 菜豆属植物；菜豆，四季豆，扁豆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1780,
    "word": "vert",
    "phonetic": "[vεr, -t]",
    "type": "",
    "translation": "a. 绿（色）的；未熟的，生的；生态运动的，绿党的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1781,
    "word": "holothurie",
    "phonetic": "[ɔlɔtyri]",
    "type": "",
    "translation": "n.f. 海参",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1782,
    "word": "homard",
    "phonetic": "[ɔmar]",
    "type": "",
    "translation": "虚音H n.m. 螯虾，龙虾",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1783,
    "word": "plateau",
    "phonetic": "[plato]",
    "type": "",
    "translation": "n.m. 托盘，盘子；高原",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1784,
    "word": "huile",
    "phonetic": "[ɥil]",
    "type": "",
    "translation": "n.f. 油",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1785,
    "word": "olive",
    "phonetic": "[ɔliv]",
    "type": "",
    "translation": "n.f. 油橄榄；橄榄形的东西；a. inv. 橄榄绿的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1786,
    "word": "huître",
    "phonetic": "[ɥitr]",
    "type": "",
    "translation": "n.f. 牡蛎，蚝",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1787,
    "word": "sésame",
    "phonetic": "[sezam]",
    "type": "",
    "translation": "n.m. 芝麻",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1788,
    "word": "soja",
    "phonetic": "[sɔʒa]",
    "type": "",
    "translation": "n.m. 大豆，黄豆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1789,
    "word": "igname",
    "phonetic": "[iɲam]",
    "type": "",
    "translation": "n.f. 薯",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1790,
    "word": "intestin",
    "phonetic": "[ɛ̃tεstɛ̃, -in]",
    "type": "",
    "translation": "n.m. [解]肠",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1791,
    "word": "colza",
    "phonetic": "[kɔlza]",
    "type": "",
    "translation": "n.m. 油菜，芸薹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1792,
    "word": "tournesol",
    "phonetic": "[turnəsɔl]",
    "type": "",
    "translation": "n.m. 向日葵",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1793,
    "word": "mauve",
    "phonetic": "[mov]",
    "type": "",
    "translation": "n.f. 淡紫色；锦葵",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1794,
    "word": "maïs",
    "phonetic": "[mais]",
    "type": "",
    "translation": "n.m. 玉米",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1795,
    "word": "pop-corn",
    "phonetic": "[pɔpkɔrn]",
    "type": "",
    "translation": "n.m.， n.inv. 爆米花",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1796,
    "word": "jambon",
    "phonetic": "[ʒɑ̃bɔ̃]",
    "type": "",
    "translation": "n.m. 猪肘子肉；火腿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1797,
    "word": "jambonneau",
    "phonetic": "[ʒɑ̃bɔno]",
    "type": "",
    "translation": "n.m. （猪）肘子，脚圈；【动】江珧的俗称",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1798,
    "word": "jus",
    "phonetic": "[ʒy]",
    "type": "",
    "translation": "n.m. 汁，液；果汁饮料，蔬菜汁饮料",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1799,
    "word": "kaki",
    "phonetic": "[kaki]",
    "type": "",
    "translation": "a. inv. 黄褐色的，土黄色的；n.m. inv. 黄褐色，土黄色",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1800,
    "word": "laitue",
    "phonetic": "[lεty]",
    "type": "",
    "translation": "ou [lety] n.f. 莴苣；叶用莴苣，生菜；拌生菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1801,
    "word": "lapin",
    "phonetic": "[lapɛ̃]",
    "type": "",
    "translation": "n. 兔；兔肉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1802,
    "word": "langouste",
    "phonetic": "[lɑ̃gust]",
    "type": "",
    "translation": "n.f. 龙虾 3 of 7 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1803,
    "word": "langue",
    "phonetic": "[lɑ̃g]",
    "type": "",
    "translation": "n.f. 语言；舌",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1804,
    "word": "lard",
    "phonetic": "[lar]",
    "type": "",
    "translation": "n.m. 猪膘，肥肉 adj. 腌制的； 腌泡的， 醋渍的；被海水浸过的， 遭受海",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1805,
    "word": "mariné",
    "phonetic": "[marine]",
    "type": "",
    "translation": "损的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1806,
    "word": "vinaigre",
    "phonetic": "[vinεgr]",
    "type": "",
    "translation": "n.m. 醋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1807,
    "word": "mandarine",
    "phonetic": "[mɑ̃darin]",
    "type": "",
    "translation": "n.f. 柑桔，橘柑，桔子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1808,
    "word": "mangue",
    "phonetic": "[mɑ̃g]",
    "type": "",
    "translation": "n.f. 芒果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1809,
    "word": "manioc",
    "phonetic": "[manjɔk]",
    "type": "",
    "translation": "n.m. 木薯 n.m. 靠女人卖淫为生的人；为妓女拉客的人；靠妓女养",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1810,
    "word": "maquereau",
    "phonetic": "[makro]",
    "type": "",
    "translation": "活的男人，杈杆；鸨母，妓院女老板；pl.鲭",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1811,
    "word": "Marmite",
    "phonetic": "[marmit]",
    "type": "",
    "translation": "n.f. 锅",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1812,
    "word": "pot",
    "phonetic": "[po]",
    "type": "",
    "translation": "n.m. 罐，壶，坛；酒杯",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1813,
    "word": "chaudron",
    "phonetic": "[∫odrɔ̃]",
    "type": "",
    "translation": "n.m. 小锅，手提锅；小锅之量；劣质钢琴；劣质乐器",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1814,
    "word": "bouilli",
    "phonetic": "[buji]",
    "type": "",
    "translation": "adj. 煮沸",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1815,
    "word": "bouillant",
    "phonetic": "[bujɑ̃, -t]",
    "type": "",
    "translation": "a. 沸滚的，煮沸的；激情的，热情的；急躁的，暴躁的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1816,
    "word": "méduse",
    "phonetic": "[medyz]",
    "type": "",
    "translation": "n.f.， n.pr. 水母，海蜇",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1817,
    "word": "melon",
    "phonetic": "[m(ə)lɔ̃]",
    "type": "",
    "translation": "n.m. 甜瓜 adj. 芳香的， 有香味的， 香喷喷的；加香料的， 加香精",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1818,
    "word": "parfumé",
    "phonetic": "[parfyme]",
    "type": "",
    "translation": "的；洒过香水的[指人]",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1819,
    "word": "cucurbitacées",
    "phonetic": "[kykyrbitase]",
    "type": "",
    "translation": "n.f.， n.pl. （葫芦）瓜； 葫芦科 a. 小的，细的；微小的，细微的；n.m. 菜单；（价格固",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1820,
    "word": "menu",
    "phonetic": "[məny]",
    "type": "",
    "translation": "定的）套餐",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1821,
    "word": "millet",
    "phonetic": "[mijε]",
    "type": "",
    "translation": "n.m. 黍；稷；小米",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1822,
    "word": "moule",
    "phonetic": "[mul]",
    "type": "",
    "translation": "n.m. 模子，铸模；模型；n.f. 贻贝，淡菜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1823,
    "word": "coquille",
    "phonetic": "[kɔkij]",
    "type": "",
    "translation": "n.f. 贝壳，甲壳；蛋壳；果壳",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1824,
    "word": "carapace",
    "phonetic": "[karapas]",
    "type": "",
    "translation": "n.f. 甲壳，外壳，背甲；保护层；甲",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1825,
    "word": "moutarde",
    "phonetic": "[mutard]",
    "type": "",
    "translation": "n.f. 芥菜；芥末",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1826,
    "word": "poudre",
    "phonetic": "[pudr]",
    "type": "",
    "translation": "n.f. 粉，粉末；香粉；火药",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1827,
    "word": "agneau",
    "phonetic": "[aɲo]",
    "type": "",
    "translation": "n.m. 羔羊；羔羊肉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1828,
    "word": "morue",
    "phonetic": "[mɔry]",
    "type": "",
    "translation": "n.f. 鳕鱼；[民]娼妓； 婊子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1829,
    "word": "navet",
    "phonetic": "[navε]",
    "type": "",
    "translation": "n.m. 萝卜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1830,
    "word": "noix",
    "phonetic": "[nwa]",
    "type": "",
    "translation": "n.f. 核桃；类似核桃的果实",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1831,
    "word": "noyau",
    "phonetic": "[nwajo]",
    "type": "",
    "translation": "n.m. 果核；核；骨干；核心力量",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1832,
    "word": "pépin",
    "phonetic": "[pepɛ̃]",
    "type": "",
    "translation": "n.m.（浆果、柑橘类水果的）籽，仁，种子；雨伞",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1833,
    "word": "pêche",
    "phonetic": "[pε∫]",
    "type": "",
    "translation": "n.f. 桃子；钓鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1834,
    "word": "cerneau",
    "phonetic": "[sεrno]",
    "type": "",
    "translation": "n.m. 青核桃； 青核桃肉 n.m.， n.f.， adj. 椰子；椰子纤维；（旧时的）甘草柠",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1835,
    "word": "coco",
    "phonetic": "[kɔko]",
    "type": "",
    "translation": "檬露；蛋；古柯碱， 可卡因[cocaïne的缩写] 162 nouilles 面条",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1836,
    "word": "soupe",
    "phonetic": "[sup]",
    "type": "",
    "translation": "n.f. 浓汤，羹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1837,
    "word": "œuf",
    "phonetic": "[œf]",
    "type": "",
    "translation": "n.m. 受精卵；卵子；蛋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1838,
    "word": "salé",
    "phonetic": "[sale]",
    "type": "",
    "translation": "a. 含盐的；咸的；盐渍的，腌的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1839,
    "word": "oie",
    "phonetic": "[wa]",
    "type": "",
    "translation": "n.f. 鹅；母鹅；傻瓜，笨蛋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1840,
    "word": "ormeau",
    "phonetic": "[ɔrmo]",
    "type": "",
    "translation": "n.m. 鲍鱼;小榆树 4 of 7 单词 音标 解释 No. n.f. 柑，桔，橙；n.m.， a. inv. 桔黄色（的），橙色",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1841,
    "word": "orange",
    "phonetic": "[ɔrɑ̃ʒ]",
    "type": "",
    "translation": "（的）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1842,
    "word": "omelette",
    "phonetic": "[ɔmlεt]",
    "type": "",
    "translation": "n.f. 煎蛋卷；炒蛋，摊鸡蛋",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1843,
    "word": "oursin",
    "phonetic": "[ursɛ̃]",
    "type": "",
    "translation": "n.m. 海胆； 熊皮；十分小气， 一志不拨",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1844,
    "word": "pain",
    "phonetic": "[pɛ̃]",
    "type": "",
    "translation": "n.m. 面包；食粮，生计",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1845,
    "word": "biscotte",
    "phonetic": "[biskɔt]",
    "type": "",
    "translation": "n.f. 面包干， 干面包片",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1846,
    "word": "grillé",
    "phonetic": "[grije]",
    "type": "",
    "translation": "adj. 在烤架上烤的；装有栅栏的， 用栅栏围起来的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1847,
    "word": "palourde",
    "phonetic": "[palurd]",
    "type": "",
    "translation": "n.f. 蛤，蚶",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1848,
    "word": "pamplemousse",
    "phonetic": "[pɑ̃pləmus]",
    "type": "",
    "translation": "n.m. 柚子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1849,
    "word": "papaye",
    "phonetic": "[papaj]",
    "type": "",
    "translation": "n.f. 番木瓜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1850,
    "word": "pastèque",
    "phonetic": "[pastεk]",
    "type": "",
    "translation": "n.f. 西瓜 n.f. 杆，撑竿，篙；测量竿；钓竿；瘦长的人；有叉的鹿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1851,
    "word": "perche",
    "phonetic": "[pεr∫]",
    "type": "",
    "translation": "角；法国旧长度单位；法国旧土地面积单位；（运送滑雪 者上山的电动）吊椅；鲈鱼；送话器架",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1852,
    "word": "persil",
    "phonetic": "[pεrsi]",
    "type": "",
    "translation": "ou [pεrsil] n.m. 香芹， 欧芹",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1853,
    "word": "pétoncle",
    "phonetic": "[petɔ̃kl]",
    "type": "",
    "translation": "n.m. 扇贝",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1854,
    "word": "pieuvre",
    "phonetic": "[pjœvr]",
    "type": "",
    "translation": "n.f. 章鱼；贪得无厌的人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1855,
    "word": "pigeon",
    "phonetic": "[piʒɔ̃]",
    "type": "",
    "translation": "n.m. 鸽子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1856,
    "word": "piment",
    "phonetic": "[pimɑ̃]",
    "type": "",
    "translation": "n.m. 辣椒；刺激性的东西；猥亵的成分 a. 冷的；冷却的；冷静的；无动于衷的，冷淡的；n.m.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1857,
    "word": "froid",
    "phonetic": "[frwa, -d]",
    "type": "",
    "translation": "冷，寒冷；冷的感觉；冷淡，疏远",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1858,
    "word": "poire",
    "phonetic": "[pwar]",
    "type": "",
    "translation": "n.f. 梨；梨形物 n.m. 烟熏的， 熏制的；被烟熏黑的：施过厩肥的， 施",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1859,
    "word": "fumé",
    "phonetic": "[fyme]",
    "type": "",
    "translation": "过肥的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1860,
    "word": "poireau",
    "phonetic": "[pwaro]",
    "type": "",
    "translation": "n.m. 韭菜， 葱",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1861,
    "word": "poivre",
    "phonetic": "[pwavr]",
    "type": "",
    "translation": "n.m. 胡椒；胡椒粉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1862,
    "word": "poivron",
    "phonetic": "[pwavrɔ̃]",
    "type": "",
    "translation": "n.m. 甜椒；柿子椒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1863,
    "word": "pomme",
    "phonetic": "[pɔm]",
    "type": "",
    "translation": "n.f. 苹果；苹果形物体 192 pomme de terre [pɔmdətεr] n.f. 土豆，马铃薯 n.f.（织物、纸等做成的）带，录音带；长条，带状物；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1864,
    "word": "bande",
    "phonetic": "[bɑ̃d]",
    "type": "",
    "translation": "群，队；帮，伙，集团",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1865,
    "word": "porc",
    "phonetic": "[pɔr]",
    "type": "",
    "translation": "n.m. 猪；猪肉；猪皮",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1866,
    "word": "potage",
    "phonetic": "[pɔtaʒ]",
    "type": "",
    "translation": "n.m.（用肉、蔬菜等做成的）浓汤",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1867,
    "word": "potiron",
    "phonetic": "[pɔtirɔ̃]",
    "type": "",
    "translation": "n.m. 大南瓜， 笋瓜",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1868,
    "word": "poulet",
    "phonetic": "[pulε]",
    "type": "",
    "translation": "n.m. 小鸡；母鸡肉；童子鸡肉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1869,
    "word": "poumon",
    "phonetic": "[pumɔ̃]",
    "type": "",
    "translation": "n.m. 肺",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1870,
    "word": "produit",
    "phonetic": "[prɔdɥi]",
    "type": "",
    "translation": "n.m. 产品；产物；收入，收益；利润，赢利",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1871,
    "word": "alimentaire",
    "phonetic": "[alimɑ̃tεr]",
    "type": "",
    "translation": "a. 食物的；食用的；饮食的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1872,
    "word": "prune",
    "phonetic": "[pryn]",
    "type": "",
    "translation": "n.f. 李，李子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1873,
    "word": "pruneau",
    "phonetic": "[pryno]",
    "type": "",
    "translation": "n.m. 李子干；黑皮肤的人；枪弹， 子弹 a. 干的；干燥的，干旱的；干枯的；不加水的；枯燥乏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1874,
    "word": "sec",
    "phonetic": "[sεk, sε∫]",
    "type": "",
    "translation": "味的；冷酷的；生硬的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1875,
    "word": "confit",
    "phonetic": "[kɔ̃fi, -t]",
    "type": "",
    "translation": "adj.糖渍的，糖煮的；醋泡的；油浸的 n.m. 焖肉冻 n.m.， n.inv. 四合糕[等量的面粉、糖、黄油和鸡蛋做",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1876,
    "word": "quatre-quarts",
    "phonetic": "[katkar]",
    "type": "",
    "translation": "成] 5 of 7 单词 音标 解释 No.",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1877,
    "word": "queue",
    "phonetic": "[kø]",
    "type": "",
    "translation": "n.f. 尾，尾巴；等候的行列，队伍 n.m.（动物的）毛；（人体上的）汗毛；（织物的）绒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1878,
    "word": "poil",
    "phonetic": "[pwal]",
    "type": "",
    "translation": "毛",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1879,
    "word": "raisin",
    "phonetic": "[rεzɛ̃]",
    "type": "",
    "translation": "n.m. 葡萄",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1880,
    "word": "vin",
    "phonetic": "[vɛ̃]",
    "type": "",
    "translation": "n.m. 葡萄酒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1881,
    "word": "rave",
    "phonetic": "[rav]",
    "type": "",
    "translation": "n.f. 萝卜；芜菁，苤蓝",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1882,
    "word": "ravioli",
    "phonetic": "[ravjɔli]",
    "type": "",
    "translation": "n.m. 饺子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1883,
    "word": "rein",
    "phonetic": "[rɛ̃]",
    "type": "",
    "translation": "n.m. 肾，肾脏；pl. 腰，腰部",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1884,
    "word": "viscères",
    "phonetic": "[visεr]",
    "type": "",
    "translation": "内容； 肠； 内脏",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1885,
    "word": "requin",
    "phonetic": "[r(ə)kɛ̃]",
    "type": "",
    "translation": "n.m. 鲨， 鲨鱼， 鲛 ；贪婪冷酷的人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1886,
    "word": "gluant",
    "phonetic": "[glyɑ̃, -t]",
    "type": "",
    "translation": "a. 黏的，黏性的，胶黏的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1887,
    "word": "restaurant",
    "phonetic": "[rεstɔrɑ̃]",
    "type": "",
    "translation": "n.m. 饭店，餐馆",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1888,
    "word": "riz",
    "phonetic": "[ri]",
    "type": "",
    "translation": "n.m. 水稻；米；米饭 adj. 熟的， 煮过的， 烧过的；焙烧过的；喝醉的， 酒醉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1889,
    "word": "cuit",
    "phonetic": "[kɥi, -t]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1890,
    "word": "rôtir",
    "phonetic": "[rɔtir, ro-]",
    "type": "",
    "translation": "v.t. 烤，烘；使枯焦",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1891,
    "word": "rôti",
    "phonetic": "[rɔti, ro-]",
    "type": "",
    "translation": "a. 烤的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1892,
    "word": "rosbif",
    "phonetic": "[rɔsbif]",
    "type": "",
    "translation": "n.m. 烤牛肉；英国人",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1893,
    "word": "rouleau",
    "phonetic": "[rulo]",
    "type": "",
    "translation": "n.m. 滚筒，辊，滚棒；卷；磙子",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1894,
    "word": "saindoux",
    "phonetic": "[sɛ̃du]",
    "type": "",
    "translation": "n.m. （熬熟的）猪油",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1895,
    "word": "salade",
    "phonetic": "[salad]",
    "type": "",
    "translation": "n.f. 凉拌生菜；生菜；冷盘；色拉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1896,
    "word": "saucisse",
    "phonetic": "[sosis]",
    "type": "",
    "translation": "n.f. 红肠，香肠，腊肠",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1897,
    "word": "saucisson",
    "phonetic": "[sosisɔ̃]",
    "type": "",
    "translation": "n.m. 粗红肠，大灌肠",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1898,
    "word": "saumon",
    "phonetic": "[somɔ̃]",
    "type": "",
    "translation": "n.m. 鲑鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1899,
    "word": "sauté",
    "phonetic": "[sote]",
    "type": "",
    "translation": "adj. 用油炒的食物， 嫩煎的食物；炒的， 嫩煎的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1900,
    "word": "scorpion",
    "phonetic": "[skɔrpjɔ̃]",
    "type": "",
    "translation": "n.m. 蝎子； le S～ 天蝎座； 233 séché 干的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1901,
    "word": "seiche",
    "phonetic": "[sε∫]",
    "type": "",
    "translation": "n.f. [动]墨鱼，乌贼；[地]湖面波动，湖震，假潮",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1902,
    "word": "sel",
    "phonetic": "[sεl]",
    "type": "",
    "translation": "n.m. 盐；风趣，妙趣",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1903,
    "word": "table",
    "phonetic": "[tabl]",
    "type": "",
    "translation": "n.f. 桌子，台子；餐桌；平台；数据表；一览表",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1904,
    "word": "salière",
    "phonetic": "[saljεr]",
    "type": "",
    "translation": "n.f. 盐瓶，盐盅；马的眼窝；锁骨上窝 v.t. 为……服务，为……效力；服侍；伺候吃饭；接待；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1905,
    "word": "germe",
    "phonetic": "[ʒεrm]",
    "type": "",
    "translation": "根源",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1906,
    "word": "sirop",
    "phonetic": "[siro]",
    "type": "",
    "translation": "n.m. 糖浆；糖汁 n.f. [技]底板；（平底船的）船底；[采]平巷底； 底梁；",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1907,
    "word": "sorgho",
    "phonetic": "[sɔrgo]",
    "type": "",
    "translation": "n.m. 蜀黍， 高梁 245 décortiqué 去皮的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1908,
    "word": "bouillon",
    "phonetic": "[bujɔ̃]",
    "type": "",
    "translation": "n.m. 肉汤，菜汤；（液体沸腾时冒出的）水泡，气泡 6 of 7 单词 音标 解释 No. adj. 完美的， 完善的 2熟练的， 老练的， 有经验的；清",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1909,
    "word": "consommé",
    "phonetic": "[kɔ̃sɔme]",
    "type": "",
    "translation": "炖肉汤",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1910,
    "word": "sucre",
    "phonetic": "[sykr]",
    "type": "",
    "translation": "n.m. 糖；糖块；[化]糖类",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1911,
    "word": "sucré",
    "phonetic": "[sykre]",
    "type": "",
    "translation": "a. 含糖的，加糖的；甜的；甜蜜的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1912,
    "word": "sucreries",
    "phonetic": "[sykrəri]",
    "type": "",
    "translation": "n.f.， n.pl. 甜食， 糖果",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1913,
    "word": "taro",
    "phonetic": "[taro]",
    "type": "",
    "translation": "n.m. 芋头",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1914,
    "word": "tarte",
    "phonetic": "[tart]",
    "type": "",
    "translation": "n.f. 奶油水果馅饼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1915,
    "word": "thé",
    "phonetic": "[te]",
    "type": "",
    "translation": "n.m. 茶叶；茶",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1916,
    "word": "jasmin",
    "phonetic": "[ʒasmɛ̃]",
    "type": "",
    "translation": "n.m. 茉莉；茉莉花；茉莉花香精",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1917,
    "word": "chrysanthème",
    "phonetic": "[krizɑ̃tεm]",
    "type": "",
    "translation": "n.m. 菊， 菊花",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1918,
    "word": "thon",
    "phonetic": "[tɔ̃]",
    "type": "",
    "translation": "n.m. 金枪鱼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1919,
    "word": "tomate",
    "phonetic": "[tɔmat]",
    "type": "",
    "translation": "n.f . 番茄，西红柿",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1920,
    "word": "tortue",
    "phonetic": "[tɔrty]",
    "type": "",
    "translation": "n.f. 龟，乌龟",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1921,
    "word": "tripes",
    "phonetic": "[trip]",
    "type": "",
    "translation": "（动物的）肠子；（动物的肠子做的）菜肴 超高温 260 U.H.T. [yaʃte] Cette brique de lait utilise la technique de l'UHT. 这盒牛奶使用了超高温消毒技术。 n.f. 香子兰果实；香子兰荚；香子（香）精，香草（香）",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1922,
    "word": "vanille",
    "phonetic": "[vanij]",
    "type": "",
    "translation": "精",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1923,
    "word": "vermicelle",
    "phonetic": "[vεrmisεl]",
    "type": "",
    "translation": "n.m. 细面条（汤），挂面（汤）；粉丝（汤） a. 瘦的；贫瘠的；微薄的，贫乏的；干瘪的；薄的；细",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1924,
    "word": "maigre",
    "phonetic": "[mεgr]",
    "type": "",
    "translation": "的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1925,
    "word": "haché",
    "phonetic": "['a∫e]",
    "type": "",
    "translation": "虚音H a. 切细的，切碎的，剁碎的；断断续续的，不连贯的",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1926,
    "word": "émincé",
    "phonetic": "[emɛ̃se]",
    "type": "",
    "translation": "n.m. 薄片， 肉片",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1927,
    "word": "lanier",
    "phonetic": "[lanje]",
    "type": "",
    "translation": "n.m. 一种雌猎隼",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1928,
    "word": "lanière",
    "phonetic": "[lanjεr]",
    "type": "",
    "translation": "n.f. 狭长带子； 皮带",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1929,
    "word": "volaille",
    "phonetic": "[vɔlaj]",
    "type": "",
    "translation": "n.f. 家禽；家禽肉",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1930,
    "word": "xérès",
    "phonetic": "[gzerεs, ks-]",
    "type": "",
    "translation": "n.m. 赫雷斯白葡萄酒",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  },
  {
    "id": 1931,
    "word": "yaourt",
    "phonetic": "[jaurt]",
    "type": "",
    "translation": "n.m. 酸奶 7 of 7",
    "commonMeanings": [],
    "example": "",
    "exampleTranslation": "",
    "image": "",
    "usages": [],
    "derivatives": [],
    "synonymsAntonyms": []
  }
];
